/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./node_modules/js-cookie/dist/js.cookie.js":
/*!**************************************************!*\
  !*** ./node_modules/js-cookie/dist/js.cookie.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));


/***/ }),

/***/ "./node_modules/slick-carousel/slick/slick.min.js":
/*!********************************************************!*\
  !*** ./node_modules/slick-carousel/slick/slick.min.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(i){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):undefined}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});


/***/ }),

/***/ "./node_modules/typed.js/dist/typed.module.js":
/*!****************************************************!*\
  !*** ./node_modules/typed.js/dist/typed.module.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return i; });
function t(){return t=Object.assign?Object.assign.bind():function(t){for(var s=1;s<arguments.length;s++){var e=arguments[s];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n])}return t},t.apply(this,arguments)}var s={strings:["These are the default values...","You know what you should do?","Use your own!","Have a great day!"],stringsElement:null,typeSpeed:0,startDelay:0,backSpeed:0,smartBackspace:!0,shuffle:!1,backDelay:700,fadeOut:!1,fadeOutClass:"typed-fade-out",fadeOutDelay:500,loop:!1,loopCount:Infinity,showCursor:!0,cursorChar:"|",autoInsertCss:!0,attr:null,bindInputFocusEvents:!1,contentType:"html",onBegin:function(t){},onComplete:function(t){},preStringTyped:function(t,s){},onStringTyped:function(t,s){},onLastStringBackspaced:function(t){},onTypingPaused:function(t,s){},onTypingResumed:function(t,s){},onReset:function(t){},onStop:function(t,s){},onStart:function(t,s){},onDestroy:function(t){}},e=new(/*#__PURE__*/function(){function e(){}var n=e.prototype;return n.load=function(e,n,i){if(e.el="string"==typeof i?document.querySelector(i):i,e.options=t({},s,n),e.isInput="input"===e.el.tagName.toLowerCase(),e.attr=e.options.attr,e.bindInputFocusEvents=e.options.bindInputFocusEvents,e.showCursor=!e.isInput&&e.options.showCursor,e.cursorChar=e.options.cursorChar,e.cursorBlinking=!0,e.elContent=e.attr?e.el.getAttribute(e.attr):e.el.textContent,e.contentType=e.options.contentType,e.typeSpeed=e.options.typeSpeed,e.startDelay=e.options.startDelay,e.backSpeed=e.options.backSpeed,e.smartBackspace=e.options.smartBackspace,e.backDelay=e.options.backDelay,e.fadeOut=e.options.fadeOut,e.fadeOutClass=e.options.fadeOutClass,e.fadeOutDelay=e.options.fadeOutDelay,e.isPaused=!1,e.strings=e.options.strings.map(function(t){return t.trim()}),e.stringsElement="string"==typeof e.options.stringsElement?document.querySelector(e.options.stringsElement):e.options.stringsElement,e.stringsElement){e.strings=[],e.stringsElement.style.cssText="clip: rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;";var r=Array.prototype.slice.apply(e.stringsElement.children),o=r.length;if(o)for(var a=0;a<o;a+=1)e.strings.push(r[a].innerHTML.trim())}for(var u in e.strPos=0,e.currentElContent=this.getCurrentElContent(e),e.currentElContent&&e.currentElContent.length>0&&(e.strPos=e.currentElContent.length-1,e.strings.unshift(e.currentElContent)),e.sequence=[],e.strings)e.sequence[u]=u;e.arrayPos=0,e.stopNum=0,e.loop=e.options.loop,e.loopCount=e.options.loopCount,e.curLoop=0,e.shuffle=e.options.shuffle,e.pause={status:!1,typewrite:!0,curString:"",curStrPos:0},e.typingComplete=!1,e.autoInsertCss=e.options.autoInsertCss,e.autoInsertCss&&(this.appendCursorAnimationCss(e),this.appendFadeOutAnimationCss(e))},n.getCurrentElContent=function(t){return t.attr?t.el.getAttribute(t.attr):t.isInput?t.el.value:"html"===t.contentType?t.el.innerHTML:t.el.textContent},n.appendCursorAnimationCss=function(t){var s="data-typed-js-cursor-css";if(t.showCursor&&!document.querySelector("["+s+"]")){var e=document.createElement("style");e.setAttribute(s,"true"),e.innerHTML="\n        .typed-cursor{\n          opacity: 1;\n        }\n        .typed-cursor.typed-cursor--blink{\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      ",document.body.appendChild(e)}},n.appendFadeOutAnimationCss=function(t){var s="data-typed-fadeout-js-css";if(t.fadeOut&&!document.querySelector("["+s+"]")){var e=document.createElement("style");e.setAttribute(s,"true"),e.innerHTML="\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n        }\n        .typed-cursor.typed-cursor--blink.typed-fade-out{\n          -webkit-animation: 0;\n          animation: 0;\n        }\n      ",document.body.appendChild(e)}},e}()),n=new(/*#__PURE__*/function(){function t(){}var s=t.prototype;return s.typeHtmlChars=function(t,s,e){if("html"!==e.contentType)return s;var n=t.substring(s).charAt(0);if("<"===n||"&"===n){var i;for(i="<"===n?">":";";t.substring(s+1).charAt(0)!==i&&!(1+ ++s>t.length););s++}return s},s.backSpaceHtmlChars=function(t,s,e){if("html"!==e.contentType)return s;var n=t.substring(s).charAt(0);if(">"===n||";"===n){var i;for(i=">"===n?"<":"&";t.substring(s-1).charAt(0)!==i&&!(--s<0););s--}return s},t}()),i=/*#__PURE__*/function(){function t(t,s){e.load(this,s,t),this.begin()}var s=t.prototype;return s.toggle=function(){this.pause.status?this.start():this.stop()},s.stop=function(){this.typingComplete||this.pause.status||(this.toggleBlinking(!0),this.pause.status=!0,this.options.onStop(this.arrayPos,this))},s.start=function(){this.typingComplete||this.pause.status&&(this.pause.status=!1,this.pause.typewrite?this.typewrite(this.pause.curString,this.pause.curStrPos):this.backspace(this.pause.curString,this.pause.curStrPos),this.options.onStart(this.arrayPos,this))},s.destroy=function(){this.reset(!1),this.options.onDestroy(this)},s.reset=function(t){void 0===t&&(t=!0),clearInterval(this.timeout),this.replaceText(""),this.cursor&&this.cursor.parentNode&&(this.cursor.parentNode.removeChild(this.cursor),this.cursor=null),this.strPos=0,this.arrayPos=0,this.curLoop=0,t&&(this.insertCursor(),this.options.onReset(this),this.begin())},s.begin=function(){var t=this;this.options.onBegin(this),this.typingComplete=!1,this.shuffleStringsIfNeeded(this),this.insertCursor(),this.bindInputFocusEvents&&this.bindFocusEvents(),this.timeout=setTimeout(function(){0===t.strPos?t.typewrite(t.strings[t.sequence[t.arrayPos]],t.strPos):t.backspace(t.strings[t.sequence[t.arrayPos]],t.strPos)},this.startDelay)},s.typewrite=function(t,s){var e=this;this.fadeOut&&this.el.classList.contains(this.fadeOutClass)&&(this.el.classList.remove(this.fadeOutClass),this.cursor&&this.cursor.classList.remove(this.fadeOutClass));var i=this.humanizer(this.typeSpeed),r=1;!0!==this.pause.status?this.timeout=setTimeout(function(){s=n.typeHtmlChars(t,s,e);var i=0,o=t.substring(s);if("^"===o.charAt(0)&&/^\^\d+/.test(o)){var a=1;a+=(o=/\d+/.exec(o)[0]).length,i=parseInt(o),e.temporaryPause=!0,e.options.onTypingPaused(e.arrayPos,e),t=t.substring(0,s)+t.substring(s+a),e.toggleBlinking(!0)}if("`"===o.charAt(0)){for(;"`"!==t.substring(s+r).charAt(0)&&(r++,!(s+r>t.length)););var u=t.substring(0,s),p=t.substring(u.length+1,s+r),c=t.substring(s+r+1);t=u+p+c,r--}e.timeout=setTimeout(function(){e.toggleBlinking(!1),s>=t.length?e.doneTyping(t,s):e.keepTyping(t,s,r),e.temporaryPause&&(e.temporaryPause=!1,e.options.onTypingResumed(e.arrayPos,e))},i)},i):this.setPauseStatus(t,s,!0)},s.keepTyping=function(t,s,e){0===s&&(this.toggleBlinking(!1),this.options.preStringTyped(this.arrayPos,this));var n=t.substring(0,s+=e);this.replaceText(n),this.typewrite(t,s)},s.doneTyping=function(t,s){var e=this;this.options.onStringTyped(this.arrayPos,this),this.toggleBlinking(!0),this.arrayPos===this.strings.length-1&&(this.complete(),!1===this.loop||this.curLoop===this.loopCount)||(this.timeout=setTimeout(function(){e.backspace(t,s)},this.backDelay))},s.backspace=function(t,s){var e=this;if(!0!==this.pause.status){if(this.fadeOut)return this.initFadeOut();this.toggleBlinking(!1);var i=this.humanizer(this.backSpeed);this.timeout=setTimeout(function(){s=n.backSpaceHtmlChars(t,s,e);var i=t.substring(0,s);if(e.replaceText(i),e.smartBackspace){var r=e.strings[e.arrayPos+1];e.stopNum=r&&i===r.substring(0,s)?s:0}s>e.stopNum?(s--,e.backspace(t,s)):s<=e.stopNum&&(e.arrayPos++,e.arrayPos===e.strings.length?(e.arrayPos=0,e.options.onLastStringBackspaced(),e.shuffleStringsIfNeeded(),e.begin()):e.typewrite(e.strings[e.sequence[e.arrayPos]],s))},i)}else this.setPauseStatus(t,s,!1)},s.complete=function(){this.options.onComplete(this),this.loop?this.curLoop++:this.typingComplete=!0},s.setPauseStatus=function(t,s,e){this.pause.typewrite=e,this.pause.curString=t,this.pause.curStrPos=s},s.toggleBlinking=function(t){this.cursor&&(this.pause.status||this.cursorBlinking!==t&&(this.cursorBlinking=t,t?this.cursor.classList.add("typed-cursor--blink"):this.cursor.classList.remove("typed-cursor--blink")))},s.humanizer=function(t){return Math.round(Math.random()*t/2)+t},s.shuffleStringsIfNeeded=function(){this.shuffle&&(this.sequence=this.sequence.sort(function(){return Math.random()-.5}))},s.initFadeOut=function(){var t=this;return this.el.className+=" "+this.fadeOutClass,this.cursor&&(this.cursor.className+=" "+this.fadeOutClass),setTimeout(function(){t.arrayPos++,t.replaceText(""),t.strings.length>t.arrayPos?t.typewrite(t.strings[t.sequence[t.arrayPos]],0):(t.typewrite(t.strings[0],0),t.arrayPos=0)},this.fadeOutDelay)},s.replaceText=function(t){this.attr?this.el.setAttribute(this.attr,t):this.isInput?this.el.value=t:"html"===this.contentType?this.el.innerHTML=t:this.el.textContent=t},s.bindFocusEvents=function(){var t=this;this.isInput&&(this.el.addEventListener("focus",function(s){t.stop()}),this.el.addEventListener("blur",function(s){t.el.value&&0!==t.el.value.length||t.start()}))},s.insertCursor=function(){this.showCursor&&(this.cursor||(this.cursor=document.createElement("span"),this.cursor.className="typed-cursor",this.cursor.setAttribute("aria-hidden",!0),this.cursor.innerHTML=this.cursorChar,this.el.parentNode&&this.el.parentNode.insertBefore(this.cursor,this.el.nextSibling)))},t}();
//# sourceMappingURL=typed.module.js.map


/***/ }),

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _er_custom_main_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./er-custom/main.js */ "./src/js/er-custom/main.js");
/* harmony import */ var _er_custom_er_geo_popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./er-custom/er-geo-popup.js */ "./src/js/er-custom/er-geo-popup.js");
/* harmony import */ var _er_custom_announcement_timer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./er-custom/announcement-timer.js */ "./src/js/er-custom/announcement-timer.js");




/***/ }),

/***/ "./src/js/er-custom/announcement-timer.js":
/*!************************************************!*\
  !*** ./src/js/er-custom/announcement-timer.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function getCurrentTimeSeconds() {
  return Math.floor(Date.now() / 1000);
}
function initializeAnnouncementTimer(config) {
  try {
    var updateTimerDisplay = function updateTimerDisplay(days, hours, minutes, seconds) {
      var elements = [daysElement, hoursElement, minutesElement, secondsElement, daysElementMob, hoursElementMob, minutesElementMob, secondsElementMob];
      var values = [days, hours, minutes, seconds, days, hours, minutes, seconds];
      elements.forEach(function (element, index) {
        if (element) {
          element.textContent = values[index];
        }
      });
    };
    var hideElement = function hideElement(element, className) {
      if (!element) return;
      element.classList.add(className);
    };
    var hideBanner = function hideBanner() {
      if (isHidden) return;
      updateTimerDisplay('00', '00', '00', '00');

      // If timer has nav menu, only hide the timer wrappers
      if (hasNavMenu) {
        if (timerWrapper && !timerWrapper.classList.contains(hiddenTimerClass)) {
          hideElement(timerWrapper, hiddenTimerClass);
        }
        if (timerWrapperMob && !timerWrapperMob.classList.contains(hiddenTimerClass)) {
          hideElement(timerWrapperMob, hiddenTimerClass);
        }
      } else {
        if (bannerElement && bannerElement.parentElement && !bannerElement.parentElement.classList.contains(hiddenBannerClass)) {
          hideElement(bannerElement.parentElement, hiddenBannerClass);
          bannerElement.parentElement.classList.remove('announcement-visible');
        }
      }
      isHidden = true;
    };
    var updateTimer = function updateTimer() {
      var currentServerTime = getCurrentTimeSeconds() + timeOffset;
      var timeLeft = expiryTimestamp - currentServerTime;
      if (timeLeft <= 0) {
        // Timer expired - hide the banner
        hideBanner();
        return false;
      }
      var days = Math.floor(timeLeft / 86400);
      var hours = Math.floor(timeLeft % 86400 / 3600);
      var minutes = Math.floor(timeLeft % 3600 / 60);
      var seconds = timeLeft % 60;
      var daysStr = String(days).padStart(2, '0');
      var hoursStr = String(hours).padStart(2, '0');
      var minutesStr = String(minutes).padStart(2, '0');
      var secondsStr = String(seconds).padStart(2, '0');
      updateTimerDisplay(daysStr, hoursStr, minutesStr, secondsStr);
      return true; // Return true to continue interval
    };
    var expiryTimestamp = config.expiryTimestamp,
      sectionId = config.sectionId,
      serverTimestamp = config.serverTimestamp;
    if (!expiryTimestamp) return;
    var bannerElement = document.getElementById('announcement-bar-' + sectionId);
    var timerWrapper = document.getElementById('announcement-timer-' + sectionId);
    var timerWrapperMob = document.getElementById('announcement-timer-mob-' + sectionId);
    var navMenuElement = bannerElement ? bannerElement.querySelector('.top-header-usp__nav') : null;
    var hasNavMenu = timerWrapper && timerWrapper.classList.contains('timer-with-nav') || navMenuElement !== null;
    var clientTimeOnLoad = getCurrentTimeSeconds();
    var timeOffset = serverTimestamp - clientTimeOnLoad;
    var hiddenTimerClass = 'announcement-timer-hidden';
    var hiddenBannerClass = 'announcement-banner-hidden';
    var daysElement = document.getElementById('timer-days-' + sectionId);
    var hoursElement = document.getElementById('timer-hours-' + sectionId);
    var minutesElement = document.getElementById('timer-minutes-' + sectionId);
    var secondsElement = document.getElementById('timer-seconds-' + sectionId);
    var daysElementMob = document.getElementById('timer-days-mob-' + sectionId);
    var hoursElementMob = document.getElementById('timer-hours-mob-' + sectionId);
    var minutesElementMob = document.getElementById('timer-minutes-mob-' + sectionId);
    var secondsElementMob = document.getElementById('timer-seconds-mob-' + sectionId);
    var isHidden = false;
    var currentServerTime = getCurrentTimeSeconds() + timeOffset;
    if (expiryTimestamp - currentServerTime <= 0) {
      hideBanner();
      return;
    }
    if (!updateTimer()) return;
    var timerInterval = setInterval(function () {
      if (!updateTimer()) {
        clearInterval(timerInterval);
      }
    }, 1000);
  } catch (error) {
    console.warn('Timer initialization failed:', error);
  }
}

// Initialize all timers on page load
(function () {
  function initAllTimers() {
    var timerElements = document.querySelectorAll('[data-announcement-timer]');
    timerElements.forEach(function (element) {
      var expiryTimestamp = parseInt(element.getAttribute('data-expiry-timestamp'), 10);
      var sectionId = element.getAttribute('data-section-id');
      var serverTimestamp = parseInt(element.getAttribute('data-server-timestamp'), 10);
      if (expiryTimestamp && sectionId && serverTimestamp) {
        initializeAnnouncementTimer({
          expiryTimestamp: expiryTimestamp,
          sectionId: sectionId,
          serverTimestamp: serverTimestamp
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTimers);
  } else {
    initAllTimers();
  }
})();
/* harmony default export */ __webpack_exports__["default"] = (initializeAnnouncementTimer);

/***/ }),

/***/ "./src/js/er-custom/carousel.js":
/*!**************************************!*\
  !*** ./src/js/er-custom/carousel.js ***!
  \**************************************/
/*! exports provided: carousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "carousel", function() { return _carousel; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slick-carousel/slick/slick.min.js */ "./node_modules/slick-carousel/slick/slick.min.js");
/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var typed_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! typed.js */ "./node_modules/typed.js/dist/typed.module.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var carousel = {
  defaults: {
    productCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-wrapper:not(.product-carousel-glowing)'),
    productCarouselNav: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-nav:not(.product-carousel-nav-glowing):not(.vertical-slider)'),
    productCarouselNavVertical: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-nav.vertical-slider:not(.product-carousel-nav-glowing)'),
    productCarouselGlow: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-glowing'),
    productCarouselNavGlow: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-nav-glowing'),
    homeHeroCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.hero-slider-wrapper'),
    collectionCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slick-collection'),
    collectionBundle: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slick-collection-bundle'),
    subscriptionCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slick-subscription-collection'),
    textSlide: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.sliding-text'),
    blogCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.blogpost-slick'),
    relatedArticle: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.related_article_slider'),
    logoSlide: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.sliding-logo'),
    relatedProd: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.related-products-carousel'),
    ingredientsCol: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ingredients-column-slick'),
    columnedContent: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.column-content-slick'),
    frontSlideshow: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.front-page-slideshow'),
    bacteriaSlide: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.bacteria-column-slick'),
    floraColumn: jquery__WEBPACK_IMPORTED_MODULE_0___default()('#shopify-section-fc-column .mystory-textcontent-area'),
    instafeedApp: jquery__WEBPACK_IMPORTED_MODULE_0___default()('#insta-feed'),
    glowingTestimonials: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.testimonial-slider'),
    glowingTestimonialsContent: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.testimonial-slider-content'),
    announcementBar: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.announcement-slick'),
    announcementBarMob: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.announcement-slick-mob'),
    featuredBestSeller1: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_1'),
    featuredBestSeller2: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_2'),
    featuredBestSeller3: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_3'),
    featuredBestSeller4: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_4'),
    featuredBestSeller5: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_5'),
    featuredBestSeller6: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_6'),
    imageTextCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.images_carousel_on_text'),
    upsellCarousel: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.upsell-carousel-wrapper')
  },
  onInit: function onInit() {
    var vm = this;
    vm.onResize();
  },
  onResize: function onResize() {
    var vm = this;
    var el = vm.defaults;
    vm.homeHeaderCarouselInit();
    vm.productCarouselInit();
    vm.productCarouselNavInit();
    vm.productVerticalCarouselNavInit();
    vm.productCarouselGlow();
    vm.productCarouselNavGlow();
    vm.sameHeightCarousel(el.productCarousel);
    vm.collectionCarousel();
    vm.collectionBundle();
    vm.subscriptionCarousel();
    vm.textSlide();
    vm.blogCarousel();
    vm.relatedArticle();
    vm.logoSlide();
    vm.relatedProd();
    vm.ingredientsCol();
    vm.columnedContent();
    vm.bacteriaSlide();
    vm.glowingTestimonials();
    vm.glowingTestimonialsContent();
    vm.announcementBar();
    vm.announcementBarMob();
    vm.featuredBestSeller1();
    vm.featuredBestSeller2();
    vm.featuredBestSeller3();
    vm.featuredBestSeller4();
    vm.featuredBestSeller5();
    vm.featuredBestSeller6();
    vm.imageTextCarousel();
    vm.upsellCarouselInit();
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').on('DOMSubtreeModified', '#insta-feed', function () {
      setTimeout(function () {
        vm.instafeedApp();
      }, 1000);
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.collection_title_1', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(".collection_title").removeClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_1').slick('setPosition');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.collection_title_2', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(".collection_title").removeClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_2').slick('setPosition');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.collection_title_3', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(".collection_title").removeClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_3').slick('setPosition');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.collection_title_4', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(".collection_title").removeClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_4').slick('setPosition');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.collection_title_5', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(".collection_title").removeClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_5').slick('setPosition');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.collection_title_6', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(".collection_title").removeClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('active_btn');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.featured_best_seller_slick_6').slick('setPosition');
    });
    el.frontSlideshow.on("init", function (slick) {
      slick = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slick.currentTarget);
      setTimeout(function () {
        vm.playPauseVideo(slick, "play");
      }, 1000);
      vm.resizePlayer(16 / 9);
    });
    el.frontSlideshow.on("beforeChange", function (event, slick) {
      slick = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slick.$slider);
      vm.playPauseVideo(slick, "pause");
    });
    el.frontSlideshow.on("afterChange", function (event, slick) {
      slick = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slick.$slider);
      vm.playPauseVideo(slick, "play");
    });
    vm.frontSlideshow();
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("resize.slickVideoPlayer", function () {
      vm.resizePlayer(16 / 9);
    });
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 768) {
      vm.floraColumn();
    }
    var slickTrack = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.hero-slider-wrapper .slick-track');
    var allHeight = [];
    slickTrack.find('.hero-slide').each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('height', 'auto');
      var thisHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).outerHeight();
      allHeight.push(thisHeight);
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.hero-slider-wrapper .hero-slide').each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('height', Math.max.apply(Math, allHeight) + 'px');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slick-collection').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slick-collection-bundle').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slick-subscription-collection').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.sliding-logo').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.blogpost-slick').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-nav-glowing').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-glowing').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      lazyLoadInstance.update();
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load', function () {
      el.frontSlideshow.on("init", function (slick) {
        slick = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slick.currentTarget);
        setTimeout(function () {
          vm.playPauseVideo(slick, "play");
        }, 1000);
        vm.resizePlayer(16 / 9);
      });
    });
  },
  glowingTestimonials: function glowingTestimonials() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.glowingTestimonials,
      config: {
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.testimonial-slider-content',
        adaptiveHeight: true
      }
    });
  },
  glowingTestimonialsContent: function glowingTestimonialsContent() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.glowingTestimonialsContent,
      config: {
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.testimonial-slider',
        adaptiveHeight: true
      }
    });
  },
  typingHeader: function typingHeader() {
    var vm = this;
    var loop = vm.defaults.frontSlideshow.data('typingloop');
    var slickPlay = 'slickPlay';
    if (loop) {
      slickPlay = 'slickPause';
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.typinga').each(function (index, item) {
      var id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(item).attr('id');
      var options = {
        stringsElement: "#string_element_".concat(id),
        typeSpeed: 100,
        backSpeed: 100,
        backDelay: 500,
        startDelay: 1000,
        loop: loop,
        onBegin: function onBegin(self) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('.front-page-slideshow').slick('slickPause');
        },
        onComplete: function onComplete(self) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('.front-page-slideshow').slick(slickPlay);
        }
      };
    });
  },
  homeHeaderCarouselInit: function homeHeaderCarouselInit() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.homeHeroCarousel,
      config: {
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-arrow slick-prev"></div>',
        nextArrow: '<div class="slick-arrow slick-next"></div>'
      }
    });
  },
  productCarouselInit: function productCarouselInit() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.productCarousel,
      config: {
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.product-carousel-nav',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: true
          }
        }]
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ghost-product-carousel-wrapper').remove();
    vm.defaults.productCarousel.on('afterChange', function (event, slick, currentSlide) {
      vm.defaults.productCarousel.find('video').each(function () {
        var video = this;
        if (!video.paused) {
          video.pause();
        }
      });
      var $currentSlide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slick.$slides[currentSlide]);
      var $video = $currentSlide.find('video');
      if ($video.length > 0) {
        var video = $video[0];
        if (video.paused) {
          video.play()["catch"](function (error) {
            console.log('Video autoplay revented:', error);
          });
        }
      }
    });
    setTimeout(function () {
      var $firstSlide = vm.defaults.productCarousel.find('.slick-slide.slick-active');
      var $video = $firstSlide.find('video');
      if ($video.length > 0) {
        var video = $video[0];
        if (video.paused) {
          video.play()["catch"](function (error) {
            console.log('Video autoplay prevented:', error);
          });
        }
      }
    }, 500);
  },
  productCarouselNavInit: function productCarouselNavInit() {
    var vm = this;
    var itemLength = vm.defaults.productCarouselNav.find('.product-nav-slide').length;
    if (itemLength < 5) {
      vm.defaults.productCarouselNav.addClass('lessthanfive');
    }
    vm.carouselInit({
      container: vm.defaults.productCarouselNav,
      config: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.product-carousel-wrapper',
        focusOnSelect: true,
        centerPadding: '0',
        speed: 500,
        cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)'
      }
    });
  },
  productVerticalCarouselNavInit: function productVerticalCarouselNavInit() {
    var vm = this;
    var itemLength = vm.defaults.productCarouselNavVertical.find('.product-nav-slide').length;
    if (itemLength < 5) {
      vm.defaults.productCarouselNavVertical.addClass('lessthanfive');
    }
    vm.carouselInit({
      container: vm.defaults.productCarouselNavVertical,
      config: {
        slidesToShow: 5,
        slidesToScroll: 3,
        arrows: false,
        asNavFor: '.product-carousel-wrapper',
        focusOnSelect: true,
        centerPadding: '0',
        speed: 500,
        accessibility: false,
        vertical: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        infinite: false
      }
    });
  },
  productCarouselGlow: function productCarouselGlow() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.productCarouselGlow,
      config: {
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.product-carousel-nav-glowing',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: true
          }
        }]
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ghost-product-carousel-wrapper').remove();
    vm.defaults.productCarouselGlow.on('afterChange', function (event, slick, currentSlide) {
      vm.defaults.productCarouselGlow.find('video').each(function () {
        var video = this;
        if (!video.paused) {
          video.pause();
        }
      });
      var $currentSlide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slick.$slides[currentSlide]);
      var $video = $currentSlide.find('video');
      if ($video.length > 0) {
        var video = $video[0];
        if (video.paused) {
          video.play()["catch"](function (error) {
            // Handle autoplay restrictions
            console.log('Video autoplay prevented:', error);
          });
        }
      }
    });
    setTimeout(function () {
      var $firstSlide = vm.defaults.productCarouselGlow.find('.slick-slide.slick-active');
      var $video = $firstSlide.find('video');
      if ($video.length > 0) {
        var video = $video[0];
        if (video.paused) {
          video.play()["catch"](function (error) {
            console.log('Video autoplay prevented:', error);
          });
        }
      }
    }, 500);
  },
  productCarouselNavGlow: function productCarouselNavGlow() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.productCarouselNavGlow,
      config: {
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.product-carousel-glowing',
        focusOnSelect: true,
        centerPadding: '0',
        speed: 500,
        cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
        vertical: true
      }
    });
  },
  carouselInit: function carouselInit(params) {
    params.container.not('.slick-initialized').slick(params.config);
  },
  sameHeightCarousel: function sameHeightCarousel(carouselDiv) {
    var slickTrack = carouselDiv;
    var allHeight = [];
    slickTrack.find('.slick-slide').each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('height', 'auto');
      var thisHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).outerHeight();
      allHeight.push(thisHeight);
    });
    carouselDiv.find('.slick-slide').each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('height', Math.max.apply(Math, allHeight) + 'px');
    });
  },
  subscriptionCarousel: function subscriptionCarousel() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.subscriptionCarousel,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product'), "nextArrow", '.next-product'), "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }])
    });
  },
  collectionCarousel: function collectionCarousel() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.collectionCarousel,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product'), "nextArrow", '.next-product'), "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }])
    });
  },
  announcementBar: function announcementBar() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.announcementBar,
      config: {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4500,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        lazyLoad: 'ondemand'
      }
    });
  },
  announcementBarMob: function announcementBarMob() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.announcementBarMob,
      config: {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4500,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        lazyLoad: 'ondemand'
      }
    });
  },
  featuredBestSeller1: function featuredBestSeller1() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.featuredBestSeller1,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product_1'), "nextArrow", '.next-product_1'), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }])
    });
  },
  featuredBestSeller2: function featuredBestSeller2() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.featuredBestSeller2,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product_2'), "nextArrow", '.next-product_2'), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }])
    });
  },
  featuredBestSeller3: function featuredBestSeller3() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.featuredBestSeller3,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product_3'), "nextArrow", '.next-product_3'), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }])
    });
  },
  featuredBestSeller4: function featuredBestSeller4() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.featuredBestSeller4,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product_4'), "nextArrow", '.next-product_4'), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }])
    });
  },
  featuredBestSeller5: function featuredBestSeller5() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.featuredBestSeller5,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product_5'), "nextArrow", '.next-product_5'), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }])
    });
  },
  featuredBestSeller6: function featuredBestSeller6() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.featuredBestSeller6,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-product_6'), "nextArrow", '.next-product_6'), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }])
    });
  },
  imageTextCarousel: function imageTextCarousel() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.imageTextCarousel,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-navi'), "nextArrow", '.next-navi'), "arrows", true), "responsive", [{
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '70px'
        }
      }])
    });
  },
  collectionBundle: function collectionBundle() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.collectionBundle,
      config: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerPadding: '0'
      }, "focusOnSelect", false), "prevArrow", '.prev-bundle'), "nextArrow", '.next-bundle'), "responsive", [{
        breakpoint: 1199,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }])
    });
  },
  textSlide: function textSlide() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.textSlide,
      config: {
        centerPadding: '530px',
        infinite: true,
        dots: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        fade: false,
        autoplay: false,
        autoplaySpeed: 3000,
        prevArrow: '.testi-slide-prev',
        nextArrow: '.testi-slide-next',
        responsive: [{
          breakpoint: 1567,
          settings: {
            centerPadding: '500px'
          }
        }, {
          breakpoint: 1480,
          settings: {
            centerPadding: '470px'
          }
        }, {
          breakpoint: 1395,
          settings: {
            centerPadding: '440px'
          }
        }, {
          breakpoint: 1305,
          settings: {
            centerPadding: '410px'
          }
        }, {
          breakpoint: 1215,
          settings: {
            centerPadding: '380px'
          }
        }, {
          breakpoint: 1130,
          settings: {
            centerPadding: '350px'
          }
        }, {
          breakpoint: 1045,
          settings: {
            centerPadding: '330px'
          }
        }, {
          breakpoint: 992,
          settings: {
            centerPadding: '0px',
            dots: false,
            arrows: false,
            adaptiveHeight: true
          }
        }, {
          breakpoint: 768,
          settings: {
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      }
    });
  },
  blogCarousel: function blogCarousel() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.blogCarousel,
      config: {
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow: '.prev-blog',
        nextArrow: '.next-blog',
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }]
      }
    });
    vm.matchHeight('.blog-post .slick-track .blog-post__item', 0);
  },
  relatedArticle: function relatedArticle() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.relatedArticle,
      config: {
        infinite: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow: '.prev-blog',
        nextArrow: '.next-blog',
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }]
      }
    });
    vm.matchHeight('.related_article_slider .slick-track .slick-slide', 0);
  },
  logoSlide: function logoSlide() {
    var vm = this;
    if (vm.defaults.logoSlide.length > 0) {
      vm.carouselInit({
        container: vm.defaults.logoSlide,
        config: {
          infinite: true,
          dots: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          fade: false,
          autoplay: true,
          autoplaySpeed: 3000,
          prevArrow: '.prev-logo',
          nextArrow: '.next-logo',
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          }]
        }
      });
    }
  },
  relatedProd: function relatedProd() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.relatedProd,
      config: {
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerPadding: '0',
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }]
      }
    });
  },
  ingredientsCol: function ingredientsCol() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.ingredientsCol,
      config: {
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerMode: true
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true
          }
        }]
      }
    });
  },
  columnedContent: function columnedContent() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.columnedContent,
      config: {
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerMode: true
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '70px'
          }
        }]
      }
    });
  },
  frontSlideshow: function frontSlideshow() {
    var vm = this;
    var autoscroll = vm.defaults.frontSlideshow.data('autoplay');
    var autoscroll_speed = vm.defaults.frontSlideshow.data('autoplay-speed');
    vm.carouselInit({
      container: vm.defaults.frontSlideshow,
      config: {
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false,
        pauseOnHover: true,
        fade: true,
        autoplay: autoscroll,
        autoplaySpeed: parseInt(autoscroll_speed),
        adaptiveHeight: true
      }
    });
  },
  bacteriaSlide: function bacteriaSlide() {
    var vm = this;
    if (vm.defaults.bacteriaSlide.length > 0) {
      vm.carouselInit({
        container: vm.defaults.bacteriaSlide,
        config: {
          infinite: true,
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          fade: false,
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }]
        }
      });
    }
  },
  floraColumn: function floraColumn() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.floraColumn,
      config: {
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false,
        pauseOnHover: false
      }
    });
  },
  matchHeight: function matchHeight(container, padding) {
    var highestBox = 0;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).each(function () {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() > highestBox) {
        highestBox = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height();
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).css({
      'height': highestBox + padding
    });
  },
  postMessageToPlayer: function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  },
  playPauseVideo: function playPauseVideo(slick, control) {
    var vm = this;
    var currentSlide, slideType, startTime, player, video;
    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[2];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if (startTime != null && startTime > 0 && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            vm.postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value": startTime
            });
          }
          vm.postMessageToPlayer(player, {
            "method": "play",
            "value": 1
          });
          break;
        case "pause":
          vm.postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          vm.postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          vm.postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          vm.postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 768) {
        video = currentSlide.children("video").get(1);
      }
      if (video != null) {
        if (control === "play") {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  },
  resizePlayer: function resizePlayer(ratio) {
    var vm = this;
    var iframes = vm.defaults.frontSlideshow.find('iframe');
    if (!iframes[0]) return;
    var win = vm.defaults.frontSlideshow,
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16 / 9;
    iframes.each(function () {
      var current = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
      var video_has_holder = current.parent();
      if (video_has_holder.hasClass('video-iframe-holder')) {
        current.attr('width', '1920');
        current.attr('hegiht', '580');
        video_has_holder.css('opacity', '1');
      } else {
        if (width / ratio < height) {
          playerWidth = Math.ceil(height * ratio);
          current.width(playerWidth).height(height).css({
            left: (width - playerWidth) / 2,
            top: 0
          });
        } else {
          playerHeight = Math.ceil(width / ratio);
          current.width(width).height(playerHeight).css({
            left: 0,
            top: (height - playerHeight) / 2
          });
        }
      }
    });
  },
  instafeedApp: function instafeedApp() {
    var vm = this;
    vm.carouselInit({
      container: vm.defaults.instafeedApp,
      config: _defineProperty(_defineProperty(_defineProperty({
        speed: 8000,
        infinite: true,
        autoplay: false,
        cssEase: 'linear',
        slidesToShow: 5,
        slidesToScroll: 1,
        pauseOnHover: true,
        arrows: false
      }, "autoplay", true), "autoplaySpeed", 0), "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '100px',
          slidesToShow: 1,
          autoplaySpeed: 2000
        }
      }])
    });
    var curentMatrix = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#insta-feed .slick-track').css("-webkit-transform");
    var matrixArray = curentMatrix.substr(7, curentMatrix.length - 8).split(', ');
    var currentPosition = matrixArray[4];
    var trackWidth = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#insta-feed .slick-track').width();
    vm.defaults.instafeedApp.find('.slick-track a').each(function () {
      var img = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('img');
      var newsrc = img.data('src');
      img.attr('src', newsrc);
    });
  },
  upsellCarouselInit: function upsellCarouselInit() {
    var vm = this;
    var addonSlides = document.querySelectorAll('.drawer-row-item.is-upsell');
    if (addonSlides.length >= 1) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.checkout-box').addClass('has-items');
      vm.carouselInit({
        container: vm.defaults.upsellCarousel,
        config: {
          infinite: false,
          arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<div class="slick-arrow slick-prev"></div>',
          nextArrow: '<div class="slick-arrow slick-next"></div>'
        }
      });
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.checkout-box').removeClass('has-items');
    }
  }
};
var _carousel = carousel;


/***/ }),

/***/ "./src/js/er-custom/cart-subscription.js":
/*!***********************************************!*\
  !*** ./src/js/er-custom/cart-subscription.js ***!
  \***********************************************/
/*! exports provided: cartAdd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cartAdd", function() { return cartAdd; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/*
 *  Cart Drawer Subscription Widget
 *
 */

var CART_PAGE_WIDGET = '[data-cart-page-subscription]';
var CART_WIDGET_CHECKBOX = '[data-cart-subscribe-checkbox]';
var CART_WIDGET_SELECT = '[data-cart-subscribe-select]';
var CART_LINES = '[data-cart-lines]';
var SELLING_PLAN_DATA = '[data-product-recharge-selling-plans]';
var cartWidgets = document.querySelectorAll(CART_PAGE_WIDGET);
var cartLines = document.querySelector(CART_LINES);
var currentCart;

// Util functions
var cartAdd = function cartAdd(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/cart/add.js',
      dataType: "json",
      method: 'POST',
      data: params,
      action: 'add',
      success: function success(res) {
        resolve(res);
      }
    });
  });
};
var removeItemByKey = function removeItemByKey(key) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });
};
var getCurrentCart = function getCurrentCart() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/cart.js',
      dataType: "json",
      method: 'GET',
      success: function success(res) {
        resolve(res);
      }
    });
  });
};
var replaceCartHTML = function replaceCartHTML() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: location.href,
      dataType: 'html',
      method: 'GET',
      async: true,
      success: function success(res) {
        // swap out entire cart drawer
        var cart_slide = $(res).find("#site-slidecart-inner");
        $('#site-slide-cart-drawer').html(cart_slide);

        // Recalculate savings after HTML is replaced
        // Use a small delay to ensure DOM is fully rendered
        setTimeout(function () {
          getCurrentCart().then(function (cart_obj) {
            var subtotalPrice = parseFloat(cart_obj.items_subtotal_price / 100);
            $('.checkout-box .subtotal-amount').text('$' + subtotalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));

            // Calculate savings by reading from DOM (most reliable method)
            var totalItemPrice = 0;
            var totalOriginalPrice = 0;
            $('.cart-drawer .cart-items .drawer-row-item').each(function () {
              // Get item-total price (current price)
              var itemTotalText = $(this).find('.item-total').text().replace(/[^0-9.]/g, '');
              if (itemTotalText) {
                var itemPrice = parseFloat(itemTotalText);
                totalItemPrice += itemPrice;
              }

              // Get undiscounte-price (original price, if visible)
              var undiscountedElement = $(this).find('.undiscounte-price');
              if (undiscountedElement.length && !undiscountedElement.hasClass('d-none') && undiscountedElement.is(':visible')) {
                var undiscountedText = undiscountedElement.text().replace(/[^0-9.]/g, '');
                if (undiscountedText) {
                  var originalPrice = parseFloat(undiscountedText);
                  totalOriginalPrice += originalPrice;
                }
              } else {
                // No discount, use item-total as original
                if (itemTotalText) {
                  totalOriginalPrice += parseFloat(itemTotalText);
                }
              }
            });
            var totalSavings = totalOriginalPrice - totalItemPrice;
            if (totalSavings > 0.01) {
              var savingsAmount = '$' + totalSavings.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
              $('.checkout-box .cart-savings .savings-amount').text(savingsAmount);
              $('.checkout-box .cart-savings').attr('style', 'display: flex !important').show();

              // Update original price in subtotal
              var originalSubtotalText = '$' + totalOriginalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
              $('.checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price').text(originalSubtotalText).css('display', 'inline').show();
            } else {
              $('.checkout-box .cart-savings').attr('style', 'display: none !important');
              $('.checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price').attr('style', 'display: none !important');
            }
          });
        }, 200);
        resolve(res);
      }
    });
  });
};
var updateSubscription = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item, enabled, plan) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return getCurrentCart();
        case 1:
          currentCart = _context.v;
          if (cartLines) {
            cartLines.classList.add('is-disabled');
          }
          _context.n = 2;
          return removeItemByKey(item.key);
        case 2:
          _context.n = 3;
          return cartAdd({
            items: [{
              id: item.variant_id,
              quantity: item.quantity,
              selling_plan: enabled && plan ? plan : undefined,
              properties: item.properties
            }]
          });
        case 3:
          replaceCartHTML();
        case 4:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function updateSubscription(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var instantiateWidgets = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return getCurrentCart();
        case 1:
          currentCart = _context2.v;
          cartWidgets = document.querySelectorAll(CART_PAGE_WIDGET);
          cartLines = document.querySelector(CART_LINES);
          cartWidgets.forEach(function (widget) {
            var itemId = widget.dataset.cartPageSubscription;
            if (!itemId) return;
            var itemIdNum = parseInt(itemId);
            var lineItem = currentCart.items[itemIdNum];
            if (!lineItem) return;
            var itemSellingPlanDataElement = widget.querySelector(SELLING_PLAN_DATA);
            if (!itemSellingPlanDataElement) return;
            var widgetSelect = widget.querySelector(CART_WIDGET_SELECT);
            var planOptions = null;
            var itemSellingPlanData = JSON.parse(itemSellingPlanDataElement.innerHTML);
            var sellingPlanGroups = itemSellingPlanData.selling_plan_groups;
            var sellingPlans = sellingPlanGroups.reduce(function (plans, group) {
              return [].concat(_toConsumableArray(plans), _toConsumableArray(group.selling_plans));
            }, []);
            lineItem.properties = _objectSpread(_objectSpread({}, lineItem.properties), {}, {
              '_selling_plans': JSON.stringify(sellingPlans)
            });
            if (lineItem.properties && lineItem.properties['_selling_plans']) {
              planOptions = JSON.parse(lineItem.properties['_selling_plans']);
            }

            // hide the widget if no subscription options, don't do anything else
            if (!planOptions || !planOptions.length) {
              widget.classList.add('is-hidden');
              return;
            }

            // if checkbox toggled, update item and refresh
            var widgetCheckbox = widget.querySelector(CART_WIDGET_CHECKBOX);
            if (!widgetCheckbox) return;
            widgetCheckbox.addEventListener('change', function () {
              if (!widgetCheckbox || !planOptions) return;
              var isWidgetChecked = widgetCheckbox.checked;

              // update expanded state
              if (widgetCheckbox.checked) {
                widget.classList.add('is-expanded');
              } else {
                widget.classList.remove('is-expanded');
              }

              // reset selector to first item
              widgetSelect.selectedIndex = 0;
              updateSubscription(currentCart.items[itemIdNum], isWidgetChecked, planOptions[0].id);
            });

            // collapse the widget if not currently subscription
            if (!currentCart.items[itemIdNum].selling_plan_allocation) {
              widget.classList.remove('is-expanded');
            } else {
              widget.classList.add('is-expanded');
            }

            // populate the select with options
            var planAllocation = currentCart.items[itemIdNum].selling_plan_allocation;
            if (!widgetSelect) return;
            var userPlanId = 0;
            if (planAllocation && planAllocation.selling_plan) {
              userPlanId = planAllocation.selling_plan.id;
            }
            var widgetOptions = '';
            planOptions.forEach(function (e) {
              var frequencyName = e.name.replace(/^Deliver every\s*/i, '');
              widgetOptions += "<option value=\"".concat(e.id, "\" ").concat(e.id === userPlanId ? "selected" : "", ">\n        ").concat(frequencyName, "\n      </option>");
            });
            widgetSelect.innerHTML = widgetOptions;

            // if select changed, update item and refresh
            widgetSelect.addEventListener('change', function () {
              if (!widgetSelect || !widgetCheckbox) return;
              var widgetSelectValue = widgetSelect.value;
              var isWidgetChecked = widgetCheckbox.checked;
              updateSubscription(currentCart.items[itemIdNum], isWidgetChecked, parseInt(widgetSelectValue));
            });
          });
        case 2:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function instantiateWidgets() {
    return _ref2.apply(this, arguments);
  };
}();

/* 
Because the cart is redrawn by ajax requesting the current page, extracting the html from the cart and dumping on the page
the safest way to rerun this code was to add an event to the cart html
*/
instantiateWidgets();
document.addEventListener('cartRedraw', function () {
  instantiateWidgets();
});

/***/ }),

/***/ "./src/js/er-custom/cart.js":
/*!**********************************!*\
  !*** ./src/js/er-custom/cart.js ***!
  \**********************************/
/*! exports provided: cartajax */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cartajax", function() { return _cartajax; });
var cartajax = {};
cartajax = {
  defaults: {
    cartajaxElement: $('.cart-drawer')
  },
  onInit: function onInit(e) {
    var vm = this;
  }
};
var _cartajax = cartajax;


/***/ }),

/***/ "./src/js/er-custom/er-accordion.js":
/*!******************************************!*\
  !*** ./src/js/er-custom/er-accordion.js ***!
  \******************************************/
/*! exports provided: erAccordion */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "erAccordion", function() { return _erAccordion; });
$.fn.eraccordion = function () {
  var startHeight = this.find('.accordion-header').outerHeight();
  this.addClass('accordion-group');
  this.find('.accordion-content:not(.openload)').hide();
  this.css({
    'height': startHeight + 'px'
  });
};
$.fn.eraccordion_faq = function () {
  var startHeight = this.find('.accordion-header').outerHeight();
  this.addClass('accordion-group');
  this.find('.accordion-content').hide();
  this.css({
    'height': startHeight + 'px'
  });
};
var erAccordion = {};
erAccordion = {
  defaults: {
    erAccordionElement: $('.filter-accordion'),
    productAccordion: $('.product-accordion'),
    productAccordionAmplify: $('.product-accordion-amplify'),
    filterAcc: $('.mob-filter-inner'),
    faqAcc: $('.faq-accordion-group'),
    ibfaq: $('.ib-faq-acc')
  },
  onInit: function onInit(e) {
    var vm = this;
    var el = vm.defaults;
    el.erAccordionElement.each(function () {
      $(this).eraccordion();
    });
    el.productAccordion.each(function () {
      $(this).eraccordion();
    });
    el.filterAcc.each(function () {
      $(this).eraccordion();
    });
    el.faqAcc.each(function () {
      $(this).eraccordion();
    });
    el.productAccordionAmplify.each(function () {
      $(this).eraccordion();
    });
    el.ibfaq.each(function () {
      $(this).eraccordion();
    });
    vm.onAccordionToggle();
    if ($('.glowing-template--product-faq').length) {
      vm.productFAQ();
    }
  },
  onAccordionToggle: function onAccordionToggle() {
    var vm = this;
    $(document).on('click', '.accordion-group .accordion-header', function (e) {
      e.preventDefault();
      var accordHeaderHeight = $(this).outerHeight();
      var accordContentHeight = $(this).siblings('.accordion-content').outerHeight();
      $(this).parent().siblings('.accordion-group').removeClass('open');
      if ($(this).parent().hasClass('open-load')) {
        $(this).parent().removeClass('open-load');
      }
      vm.hideAccordionContent($(this).parent().siblings().find('.accordion-content'));

      // $(this).parent().siblings('.accordion-group').css({'height': accordHeaderHeight + 'px'});

      $(this).parent().siblings('.accordion-group').each(function () {
        $(this).css({
          'height': $(this).find('.accordion-header').outerHeight() + 'px'
        });
      });
      if ($(this).parent().hasClass('open')) {
        $(this).parent().css({
          'height': accordHeaderHeight + 'px'
        });
        $(this).parent().removeClass('open');
        var accordContent = $(this).siblings('.accordion-content');
        setTimeout(function () {
          vm.hideAccordionContent(accordContent);
        }, 400);
      } else {
        $(this).parent().addClass('open');
        $(this).parent().css({
          'height': accordContentHeight + accordHeaderHeight + 'px'
        });
        $(this).siblings('.accordion-content').show();
      }
      if ($('.filter-d-wrapper').length > 0) {
        $(this).parent().parent().siblings('.filter-d-wrapper').find('.accordion-group').removeClass('open');
        vm.hideAccordionContent($(this).parent().parent().siblings('.filter-d-wrapper').find('.accordion-group').find('.accordion-content'));
        $(this).parent().parent().siblings('.filter-d-wrapper').find('.accordion-group').css({
          'height': accordHeaderHeight + 'px'
        });
      }
    });
    // setTimeout(function() {
    // 	$('.accordion-group.open-on-load .accordion-header').trigger('click');
    // }, 100);
  },
  hideAccordionContent: function hideAccordionContent(accordContent) {
    accordContent.hide();
  },
  productFAQ: function productFAQ() {
    var vm = this;
    var el = vm.defaults;
    $(document).on('click', '.product-faq-more', function (e) {
      e.preventDefault();
      $('.product-faq-more').parent().siblings('.accordion-group').removeClass('d-none');
      $(this).parent().hide();
      $('.product-faq-more').parent().siblings('.accordion-group').each(function () {
        $(this).eraccordion();
      });
    });
  }
};
var _erAccordion = erAccordion;


/***/ }),

/***/ "./src/js/er-custom/er-cart-drawer.js":
/*!********************************************!*\
  !*** ./src/js/er-custom/er-cart-drawer.js ***!
  \********************************************/
/*! exports provided: cartDrawer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cartDrawer", function() { return _cartDrawer; });
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./product */ "./src/js/er-custom/product.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! slick-carousel/slick/slick.min.js */ "./node_modules/slick-carousel/slick/slick.min.js");
/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2__);



var cartDrawer = {};
cartDrawer = {
  defaults: {
    prodjs: _product__WEBPACK_IMPORTED_MODULE_0__,
    cartDrawerElement: jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer')
  },
  onInit: function onInit(e) {
    var vm = this;
    vm.toggleCartDrawer();
    vm.removeItemRow();
  },
  toggleCartDrawer: function toggleCartDrawer() {
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-toggle').on('click', function (e) {
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('body').addClass('slide-cart');
    });
    jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).on('click', '.close-cart', function (e) {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('body').removeClass('slide-cart');
    });
  },
  buildItemRows: function buildItemRows(cart_obj) {
    var cart_line_item = cart_obj['items'];
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-toggle .cart-item-count').text(cart_obj.item_count);
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .total-cart').text(cart_obj.item_count);
    if (cart_obj.item_count > 1) {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .item-title').text("Items");
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .item-title').text("Item");
    }

    // Update subtotal
    var subtotalPrice = parseFloat(cart_obj.items_subtotal_price / 100);
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .subtotal-amount').text('$' + subtotalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));

    // Calculate and update savings
    var totalSavings = 0;
    cart_line_item.forEach(function (item) {
      // Use compare_at_price as original price
      if (item.compare_at_price && item.compare_at_price > item.price) {
        totalSavings += (item.compare_at_price - item.price) * item.quantity;
      }
    });
    if (totalSavings > 0) {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .savings-amount').text('$' + parseFloat(totalSavings / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .cart-savings').show();

      // Update original price using subtotal + savings
      var originalPrice = subtotalPrice + parseFloat(totalSavings / 100);
      var originalPriceHtml = '<span class="undiscounte-price">$' + originalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</span>';
      if (jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .subtotal-price-wrapper .undiscounte-price').length) {
        jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .subtotal-price-wrapper .undiscounte-price').text('$' + originalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .subtotal-amount').before(originalPriceHtml);
      }
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .cart-savings').hide();
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box .subtotal-price-wrapper .undiscounte-price').remove();
    }
    cart_line_item.forEach(function (item_obj) {
      var itemRow = jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .cart-items .drawer-row-item[data-lineitem-key="' + item_obj.key + '"]');
      if (itemRow.length > 0) {
        itemRow.find('.quantity-wrapper input').val(item_obj.quantity);
        var itemPrice = parseFloat(item_obj.line_price / 100);
        itemRow.find('.item-total').text('$' + itemPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      } else {
        var itemRowHtml = '';
        var itemPrice = parseFloat(item_obj.line_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        itemRowHtml += "<div class=\"drawer-row-item\" data-productid=\"".concat(item_obj.id, "\" data-price=\"").concat(item_obj.price, "\" data-lineitem-key=\"").concat(item_obj.key, "\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-4 cart-item--thumb\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"grid-item grid-thumb\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"product-thumbnail\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"product-image align-middle\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"").concat(item_obj.url, "\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<canvas width=\"114\" height=\"125\" style=\"background-image: url(").concat(item_obj.featured_image.url.replace(/(\.[^\.]+)$/, '_120x$1'), ")\" class=\"canvas-image heightbase\"></canvas>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-8 cart-item--description\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"grid-item grid-desc grid-x\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"product-details\" style=\"width: 90%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"").concat(item_obj.url, "\">").concat(item_obj.title, "</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"grid-item grid-price-remove\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"d-flex justify-content-between align-items-end cart-item--bottom\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"quantity-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"btn-quantity-control btn-reduce-quantity drawer-reduce\">\u2013</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"number\" name=\"updates[]\" id=\"updates_").concat(item_obj.key, "\" value=\"").concat(item_obj.quantity, "\" min=\"0\" aria-label=\"Item quantity\" class=\"input-quantity\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"btn-quantity-control btn-add-quantity drawer-add\">+</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"display: flex;justify-content: flex-start;align-items: center;width: 45%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"btn-remove-item\" style=\"font-size:12px;\"><u>Remove</u></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"cart-price--wrapper text-right\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"item-total\">").concat(itemPrice, "</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>");
        jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .cart-items').prepend(itemRowHtml);
      }
    });
  },
  updateCartDrawerTotal: function updateCartDrawerTotal(cart) {
    var cartOriginalTotal = parseFloat(cart.original_total_price / 100);
    var cartTotal = parseFloat(cart.total_price / 100);
    var itemCount = cart.item_count;
    var totalText = '$' + cartTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

    // Update subtotal
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .subtotal-amount').text(totalText);
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .total-cart').text(itemCount);
    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-item-count').text(itemCount);
    if (itemCount > 1) {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .item-title').text("Items");
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .item-title').text("Item");
    }

    // Calculate and update savings - use cart level totals
    var totalSavings = cartOriginalTotal - cartTotal;
    if (totalSavings > 0) {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .savings-amount').text('$' + totalSavings.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .cart-savings').show();

      // Update original price using subtotal + savings
      var originalPrice = cartTotal + totalSavings;
      var originalPriceHtml = '<span class="undiscounte-price">$' + originalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</span>';
      if (jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .subtotal-price-wrapper .undiscounte-price').length) {
        jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .subtotal-price-wrapper .undiscounte-price').text('$' + originalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .subtotal-amount').before(originalPriceHtml);
      }
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .cart-savings').hide();
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .subtotal-price-wrapper .undiscounte-price').remove();
    }
    if (cartTotal.toFixed(0) == 0) {
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .total-cart').text('');
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .subtotal-amount').text('');
      jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-drawer .checkout-box .cart-savings').hide();
    }
  },
  removeItemRow: function removeItemRow() {
    var vm = this;
    var el = vm.defaults;
    var product = el.prodjs.product;
    jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).on('click', '.btn-remove-item', function (e) {
      e.preventDefault();
      var prodID = jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).parent().closest('.drawer-row-item').attr('data-productid');
      var line_item_key = jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).parent().closest('.drawer-row-item').attr('data-lineitem-key');
      var rowClass = 'drawer-row-item';
      var rowData = {
        rowclass: rowClass,
        product_id: prodID,
        line_item_key: line_item_key
      };
      product.removeItemRowAjax(rowData);
    });
    jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).on('click', '.ajax-remove-lineitem', function (e) {
      e.preventDefault();
      var prodID = jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).parent().closest('.drawer-row-item').attr('data-productid');
      var line_item_key = jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).parent().closest('.drawer-row-item').attr('data-lineitem-key');
      var rowClass = 'drawer-row-item';
      var rowData = {
        rowclass: rowClass,
        product_id: prodID,
        line_item_key: line_item_key
      };
      product.removeItemRowAjax(rowData);
    });
  },
  inputQuantityChange: function inputQuantityChange(rowData) {
    var vm = this;
    // change API for 1 ID and new qty for that ID
    jquery__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: "quantity=" + rowData.quantity + '&id=' + rowData.line_item_key,
      beforeSend: function beforeSend(data) {},
      success: function success(data) {
        // gets new cart and run the following callback function with it as cart var
        Shopify.getCart(function (cart) {
          // update item count in header
          jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-item-count').text(cart.item_count);
          // if on cart page:
          if (jquery__WEBPACK_IMPORTED_MODULE_1___default()('.template-cart').length) {
            jquery__WEBPACK_IMPORTED_MODULE_1___default.a.getJSON('/cart.js', function (cart) {
              vm.updateCartDrawerTotal(cart);
            });
          }
        });
        jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-items').addClass('is-disabled');
        // re-get current page html
        jquery__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
          method: 'GET',
          url: location.href,
          async: true,
          dataType: 'html',
          success: function success(data) {
            // swap out entire cart drawer
            var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_1___default()(data).find("#site-slidecart-inner");
            jquery__WEBPACK_IMPORTED_MODULE_1___default()('#site-slide-cart-drawer').html(cart_slide);
            jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-items').removeClass('is-disabled');

            // for cart page
            var cartPageItems = jquery__WEBPACK_IMPORTED_MODULE_1___default()(data).find('.main-cart-rows');
            if (cartPageItems.length) {
              jquery__WEBPACK_IMPORTED_MODULE_1___default()('.main-cart-rows').html(cartPageItems.html());
            }
            var cartPageTotal = jquery__WEBPACK_IMPORTED_MODULE_1___default()(data).find('.cart-subtotal-row');
            if (cartPageTotal.length) {
              jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-subtotal-row').html(cartPageTotal.html());
            }
            var addonSlides = document.querySelectorAll('.drawer-row-item.is-upsell');
            if (addonSlides.length >= 1) {
              jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box').addClass('has-items');
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box').removeClass('has-items');
            }
            jquery__WEBPACK_IMPORTED_MODULE_1___default()('.upsell-carousel-wrapper').slick({
              infinite: false,
              arrows: true,
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow: '<div class="slick-arrow slick-prev"></div>',
              nextArrow: '<div class="slick-arrow slick-next"></div>'
            });

            // Trigger cart update events for GWP progress bar
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).trigger('cartUpdated');
            document.dispatchEvent(new Event('cartRedraw'));
          }
        });
      }
    });
  }
};
var _cartDrawer = cartDrawer;


/***/ }),

/***/ "./src/js/er-custom/er-geo-popup.js":
/*!******************************************!*\
  !*** ./src/js/er-custom/er-geo-popup.js ***!
  \******************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! js-cookie */ "./node_modules/js-cookie/dist/js.cookie.js");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _geo_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./geo.js */ "./src/js/er-custom/geo.js");
/* harmony import */ var _geo_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_geo_js__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 *  Geo Location Popup
 *    Custom GeoLocation Popup Code
 *
 *  Version:
 *    1.0.0 - 2024/01/22
 */
var GEO_POPUP_REMEMBER_COOKIE = 'GeoPopupRemember';



function GeoPopup(container) {
  this.container = container;
  this.id = container.attr('data-section-id');
  this.remember = !!container.attr('data-remember');
  this.content = this.container.find('[data-geo-content]');
  this.closeButton = this.container.find('[data-popup-close]');
  this.title = this.container.find('[data-geo-title]');
  this.popupDelay = this.container.attr('data-geo-delay') * 1000;
  this.popupExpire = this.container.attr('data-geo-expire');

  //Load in data
  this.data = window.GeoPopupData || [];

  //Event Handlers
  this.container.on('click', '[data-popup-close]', this.onGeoClose.bind(this));
  var shouldFetch = true;

  //Check for ref=0 (saves cross domain double up)
  try {
    var x = window.location.search.split('&');
    if (x && x.length) x[0] = x[0].substring(1);
    for (var i = 0; i < x.length; i++) {
      var t = x[i].split('=');
      if (t[0] != 'ref') continue;
      if (t[1] != '0' && t[1] != 0) continue;
      shouldFetch = false;
      break;
    }
  } catch (e) {
    console.error(e);
  }

  //GoogleBot avoiding :fingers_crossed:
  try {
    if (navigator.userAgent.toLowerCase().indexOf('googlebot') !== -1) shouldFetch = false;
  } catch (e) {
    console.error(e);
  }
  if (shouldFetch) Geo.fetchGeo(this.onGeo.bind(this));
}
GeoPopup.prototype = {
  onGeo: function onGeo(geo) {
    var countryData = null;
    var intData = null;
    for (var i = 0; i < this.data.length; i++) {
      var data = this.data[i];
      var countryCodeArray = data.code.replace(/\s/g, '').split(',');
      var isCountry = false;
      for (var x = 0; x < countryCodeArray.length; x++) {
        var code = countryCodeArray[x];
        if (code == 'INT') {
          intData = data;
        }
        if (code != geo.country_code) continue;
        isCountry = true;
        break;
      }
      if (!isCountry) continue;
      //Is country
      countryData = data;
      break;
    }
    if (!countryData && !intData) return;
    this.useGeoData(countryData || intData, geo, isCountry);
  },
  useGeoData: function useGeoData(data, geo, isCountry) {
    //Determine URL
    var url = data.domain;
    url = url.replace(/^(http(s)?)?(:)?(\/)?(\/)?/gim, '//');
    if (this.container.attr('data-relative')) {
      url += window.location.pathname;
      url += window.location.search;
      if (window.location.search.length) {
        url += '&ref=0';
      } else {
        url += '?ref=0';
      }
      url += window.location.hash;
    } else {
      url += '?ref=0';
    }
    if (data.domain === window.location.origin) return;
    var remember = js_cookie__WEBPACK_IMPORTED_MODULE_1___default.a.get(GEO_POPUP_REMEMBER_COOKIE);
    if (this.remember && remember === data.domain) return;

    //Generate popup title
    var y = (window.GeoPopupTitle || "").replace(/\%country\%/gi, geo.country);
    y = y.replace('\n', '<br />');

    //Generate popup content
    var x = (window.GeoPopupMessage || "").replace(/\%country\%/gi, geo.country);
    x = x.replace('\n', '<br />');
    this.title.html(y);
    this.content.html(x);

    //Show popups
    this.openPopup();
  },
  openPopup: function openPopup() {
    var remember = js_cookie__WEBPACK_IMPORTED_MODULE_1___default.a.get(GEO_POPUP_REMEMBER_COOKIE);
    setTimeout(function () {
      if (!remember) {
        var popup = document.querySelector('[data-geo-popup]');
        document.body.classList.add('popup-active');
        popup.classList.remove('popup--hide');
      }
    }, this.popupDelay);
  },
  closePopup: function closePopup() {
    var popup = document.querySelector('[data-geo-popup]');
    document.body.classList.remove('popup-active');
    popup.classList.add('popup--hide');
  },
  onGeoClose: function onGeoClose(e) {
    e.preventDefault();
    e.stopPropagation();
    this.closePopup();
    this.rememberData(this.popupExpire);
  },
  rememberData: function rememberData(d) {
    js_cookie__WEBPACK_IMPORTED_MODULE_1___default.a.set(GEO_POPUP_REMEMBER_COOKIE, d);
  }
};
(function ($) {
  if (_typeof($) === ( true ? "undefined" : undefined)) return;
  $(document).ready(function () {
    $('[data-geo-popup]').each(function (e) {
      window.GeoPopups = window.GeoPopups || [];
      window.GeoPopups.push(new GeoPopup($(this)));
    });
  });
})(jQuery);

/***/ }),

/***/ "./src/js/er-custom/er-js-load.js":
/*!****************************************!*\
  !*** ./src/js/er-custom/er-js-load.js ***!
  \****************************************/
/*! exports provided: erModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "erModule", function() { return erModule; });
var erModule = {
  searchBar: __webpack_require__(/*! ./search-bar */ "./src/js/er-custom/search-bar.js").searchBar,
  megamenu: __webpack_require__(/*! ./megamenu */ "./src/js/er-custom/megamenu.js").megamenu,
  carousel: __webpack_require__(/*! ./carousel */ "./src/js/er-custom/carousel.js").carousel,
  cartDrawer: __webpack_require__(/*! ./er-cart-drawer */ "./src/js/er-custom/er-cart-drawer.js").cartDrawer,
  quantityInput: __webpack_require__(/*! ./er-product-quantity-input */ "./src/js/er-custom/er-product-quantity-input.js").quantityInput,
  product: __webpack_require__(/*! ./product */ "./src/js/er-custom/product.js").product,
  cartajax: __webpack_require__(/*! ./cart */ "./src/js/er-custom/cart.js").cartajax,
  erModal: __webpack_require__(/*! ./er-modal */ "./src/js/er-custom/er-modal.js").erModal,
  erAccordion: __webpack_require__(/*! ./er-accordion */ "./src/js/er-custom/er-accordion.js").erAccordion,
  featprod_addajax: __webpack_require__(/*! ./featuredproduct-addajax */ "./src/js/er-custom/featuredproduct-addajax.js").featprod_addajax,
  video_popup: __webpack_require__(/*! ./video-popup */ "./src/js/er-custom/video-popup.js").video_popup,
  review_slider: __webpack_require__(/*! ./review-slider */ "./src/js/er-custom/review-slider.js").review_slider,
  postFilter: __webpack_require__(/*! ./post-filter */ "./src/js/er-custom/post-filter.js").postFilter,
  scrollLockJs: __webpack_require__(/*! ./er-lockscroll */ "./src/js/er-custom/er-lockscroll.js").scrollLockJs,
  redirectLogin: __webpack_require__(/*! ./redirect-login */ "./src/js/er-custom/redirect-login.js").redirectLogin,
  trackorder: __webpack_require__(/*! ./trackorder */ "./src/js/er-custom/trackorder.js").trackorder,
  cartSubscription: __webpack_require__(/*! ./cart-subscription */ "./src/js/er-custom/cart-subscription.js").cartSubscription,
  octaneAiQuiz: __webpack_require__(/*! ./octane-ai-quiz */ "./src/js/er-custom/octane-ai-quiz.js").octaneAiQuiz,
  upsellItem: __webpack_require__(/*! ./upsell-item */ "./src/js/er-custom/upsell-item.js"),
  scienceSection: __webpack_require__(/*! ./science-section */ "./src/js/er-custom/science-section.js"),
  predictiveSearch: __webpack_require__(/*! ./predictive-search */ "./src/js/er-custom/predictive-search.js"),
  gwpAutoAdd: __webpack_require__(/*! ./gwp-auto-add */ "./src/js/er-custom/gwp-auto-add.js").gwpAutoAdd
};


/***/ }),

/***/ "./src/js/er-custom/er-lockscroll.js":
/*!*******************************************!*\
  !*** ./src/js/er-custom/er-lockscroll.js ***!
  \*******************************************/
/*! exports provided: scrollLockJs */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollLockJs", function() { return _scrollLockJs; });
var scrollLockJs = {};
scrollLockJs = {
  defaults: {
    winTop: 0
  },
  onInit: function onInit(e) {
    var vm = this;
    var el = vm.defaults;
  },
  lockScroll: function lockScroll() {
    var vm = this;
    var el = vm.defaults;
    el.winTop = $(window).scrollTop();
    $('body').addClass('lock-scroll');
    $('body').css({
      'top': el.winTop * -1 + 'px'
    });
  },
  unlockScroll: function unlockScroll() {
    var vm = this;
    var el = vm.defaults;
    $('body').removeClass('lock-scroll');
    $('body').css({
      'top': ''
    });
    $(window).scrollTop(el.winTop);
  }
};
var _scrollLockJs = scrollLockJs;


/***/ }),

/***/ "./src/js/er-custom/er-modal.js":
/*!**************************************!*\
  !*** ./src/js/er-custom/er-modal.js ***!
  \**************************************/
/*! exports provided: erModal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "erModal", function() { return _erModal; });
$.fn.ermodal = function () {
  this.addClass('modal-main-wrapper');
  $('.modal-main-wrapper').append('<div class="btn-modal-close"></div>');
  $('.er-modal-popup').append(this);
  console.log("");
};
var erModal = {};
erModal = {
  defaults: {
    erModalElement: $('.er-modal'),
    lastScrollTop: 0
  },
  onInit: function onInit(e) {
    var vm = this;
    var el = vm.defaults;
    vm.modalTrigger();
    el.erModalElement.each(function () {
      $('.er-modal-library').append($(this));
    });
  },
  modalTrigger: function modalTrigger(modalPanel) {
    $(document).on('click', '.modal-close, .btn-modal-close', function () {
      $('body').removeClass('modal-active');
      $('.er-modal-library').append($('.er-modal-popup .modal-main-wrapper').removeClass('modal-main-wrapper'));
      $('.modal-main-wrapper .btn-modal-close').remove();
      $('.er-modal-library .btn-modal-close').remove();
    });
    $('a.modal-cta').on('click', function (e) {
      e.preventDefault();
      var modalName = $(this).attr('href');
      $(modalName).ermodal();
      $('body').addClass('modal-active');
    });
  }
};
var _erModal = erModal;


/***/ }),

/***/ "./src/js/er-custom/er-product-quantity-input.js":
/*!*******************************************************!*\
  !*** ./src/js/er-custom/er-product-quantity-input.js ***!
  \*******************************************************/
/*! exports provided: quantityInput */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quantityInput", function() { return _quantityInput; });
/* harmony import */ var _er_cart_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./er-cart-drawer */ "./src/js/er-custom/er-cart-drawer.js");
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./product */ "./src/js/er-custom/product.js");


var quantityInput = {};
quantityInput = {
  defaults: {
    cartdrawerjs: _er_cart_drawer__WEBPACK_IMPORTED_MODULE_0__,
    productjs: _product__WEBPACK_IMPORTED_MODULE_1__
  },
  onInit: function onInit(e) {
    var vm = this;
    vm.decreaseQuantity();
    vm.addQuantity();
    vm.inputQuantityChange();
  },
  decreaseQuantity: function decreaseQuantity() {
    var vm = this;
    var productJS = this.defaults.productjs;
    $(document).on('click', '.quantity-wrapper .btn-reduce-quantity', function (e) {
      e.preventDefault();
      var quantityInput = $(this).siblings('input.input-quantity');
      var quantity = quantityInput.val();
      var parentSubs = $(this).parent().hasClass('subscribe-qty-wrapper');

      //cart mobile 
      var item_price_cart_mobile = $(this).siblings('.item_price_cart_mobile');
      var selected_key = $(this).siblings('.item_key_mobile');
      var selected_key_val = selected_key.text();

      //getPrice();
      if ($(this).parent().closest('.shopify-product-form').length) {
        if (quantity != 1) {
          quantity--;
          quantityInput.val(quantity);
          quantityInput.trigger('change');
          vm.subscribeBtnChangePrice(quantity);
          return;
        }
      } else {
        if (quantity != 1 && quantity > 0) {
          quantity--;
          quantityInput.val(quantity);
          quantityInput.trigger('change');

          //mobile 
          setTimeout(function () {
            $.getJSON('/cart.js', function (cart) {}).done(function (cart) {
              var result = cart.item_count;
              var maxqty = quantityInput.data("qtylimit") - 1;
              var getQtyCartLimit = localStorage.getItem("max_variant_cart");
              if (getQtyCartLimit != null) {
                //when SKU Limit 5 is ON
                if (result < getQtyCartLimit) {
                  if (quantity <= maxqty) {
                    //cart mobile 
                    var total_price = item_price_cart_mobile.text().replace("$", "");
                    var cartTotal = total_price * quantity;
                    cart.items.forEach(function (item) {
                      if (selected_key_val == item.key) {
                        $('[data-prod-key="' + item.key + '"] .item-total').text('$' + cartTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                      }
                    });
                    $("[name='checkout']").html("Checkout Now | <span class='cart-total-amount'> $" + (cart.total_price / 100).toFixed(2) + "</span>");
                  }
                }
              }
            });
          }, 600);
          if (parentSubs) {
            vm.subscribeBtnChangePrice(quantity);
          }
          //vm.subscribeBtnChangePrice(quantity);
          return;
        }
        if (quantity == 1) {
          //quantityInput.val(0)

          var prodID = $(this).parents().closest('.drawer-row-item').attr('data-productid');
          var line_item_key = $(this).parent().closest('.drawer-row-item').data('lineitem-key');
          var rowClass = 'drawer-row-item';
          if ($('.main-cart-rows').length) {
            var prodID = $(this).parents().closest('.cart-row-item').attr('data-productid');
            var line_item_key = $(this).parent().closest('.cart-row-item').data('lineitem-key');
            var rowClass = 'cart-row-item';
          }
          setTimeout(function () {
            $('.btn-remove-item[data-id=' + prodID + ']').trigger("click");
          }, 1000);
          var rowData = {
            rowclass: rowClass,
            product_id: prodID,
            line_item_key: line_item_key
          };
          productJS.product.removeItemRowAjax(rowData);
          return;
        }
      }
    });
  },
  addQuantity: function addQuantity() {
    var vm = this;
    $(document).on('click', '.drawer-row-item .quantity-wrapper .btn-add-quantity, .cart-row-item .quantity-wrapper .btn-add-quantity, .prod-right-section .quantity-wrapper .btn-add-quantity', function (e) {
      console.log('test button');
      e.preventDefault();
      var quantityInput = $(this).siblings('input.input-quantity');
      var quantity = quantityInput.val();
      quantity++;
      quantityInput.val(quantity);
      quantityInput.trigger('change');
      console.log("quan is: " + quantity);

      //cart mobile 
      var item_price_cart_mobile = $(this).siblings('.item_price_cart_mobile');
      var selected_key = $(this).siblings('.item_key_mobile');
      var selected_key_val = selected_key.text();
      setTimeout(function () {
        $.getJSON('/cart.js', function (cart) {}).done(function (cart) {
          //cart mobile 
          var total_price = item_price_cart_mobile.text().replace("$", "");
          var cartTotal = total_price * quantity;
          cart.items.forEach(function (item) {
            if (selected_key_val == item.key) {
              $('[data-prod-key="' + item.key + '"] .item-total').text('$' + cartTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
            }
          });
          $("[name='checkout']").html("Checkout Now | <span class='cart-total-amount'> $" + (cart.total_price / 100).toFixed(2) + "</span>");
        });
      }, 600);
    });
    $(document).on('click', '.drawer-row-item .quantity-wrapper .btn-add-quantity, .cart-row-item .quantity-wrapper .btn-add-quantity', function (e) {
      e.preventDefault();
      $('.btn-add-quantity').css("pointer-events", "none");
      var getCartItems = $('.mobile-cart .cart-item-count').text();
      var quantityInput = $(this).siblings('input.input-quantity');
      var quantity = quantityInput.val();
      var maxqty = quantityInput.data("qtylimit") - 1;
      var parentSubs = $(this).parent().hasClass('subscribe-qty-wrapper');
      var setDefaultQuant = maxqty - quantity;
      var getQtyCartLimit = localStorage.getItem("max_variant_cart");

      //cart mobile 
      var item_price_cart_mobile = $(this).siblings('.item_price_cart_mobile');
      var selected_key = $(this).siblings('.item_key_mobile');
      var selected_key_val = selected_key.text();
      if (getQtyCartLimit != null) {
        //when SKU Limit 5 is ON
        if (getCartItems < getQtyCartLimit) {
          setTimeout(function () {
            $.getJSON('/cart.js', function (cart) {}).done(function (cart) {
              var result = cart.item_count;
              var getQtyCartLimit = localStorage.getItem("max_variant_cart");
              if (getQtyCartLimit != null) {
                //when SKU Limit 5 is ON
                if (result < getQtyCartLimit) {
                  if (quantity <= maxqty) {
                    quantity++;
                    quantityInput.val(quantity);
                    quantityInput.trigger('change');

                    //cart mobile 
                    var total_price = item_price_cart_mobile.text().replace("$", "");
                    var cartTotal = total_price * quantity;
                    cart.items.forEach(function (item) {
                      if (selected_key_val == item.key) {
                        $('[data-prod-key="' + item.key + '"] .item-total').text('$' + cartTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                      }
                    });
                    if (parentSubs) {
                      vm.subscribeBtnChangePrice(quantity);
                    }
                  }
                }
              } else {
                //when SKU Limit 5 is off
                quantity++;
                quantityInput.val(quantity);
                quantityInput.trigger('change');
                if (parentSubs) {
                  vm.subscribeBtnChangePrice(quantity);
                }
              }
              if (setDefaultQuant >= 1) {
                $('.product-form .input-quantity').val(1);
              } else {
                $('.product-form .input-quantity').val(1);
              }
              $('.btn-add-quantity').css("pointer-events", "auto");
            });
          }, 600);
          setTimeout(function () {
            var total = $(".getTotalAmt").text();
            $("[name='checkout']").html("Checkout Now | <span class='cart-total-amount'> " + total + "</span>");
          }, 3700);
        }
      } else {
        //when SKU Limit 5 is off
        setTimeout(function () {
          $.getJSON('/cart.js', function (cart) {}).done(function (cart) {
            var result = cart.item_count;
            var getQtyCartLimit = localStorage.getItem("max_variant_cart");
            if (getQtyCartLimit != null) {
              //when SKU Limit 5 is ON
              if (result < getQtyCartLimit) {
                if (quantity <= maxqty) {
                  quantity++;
                  quantityInput.val(quantity);
                  quantityInput.trigger('change');
                  if (parentSubs) {
                    vm.subscribeBtnChangePrice(quantity);
                  }
                }
              }
            } else {
              //when SKU Limit 5 is off
              quantity++;
              quantityInput.val(quantity);
              quantityInput.trigger('change');
              if (parentSubs) {
                vm.subscribeBtnChangePrice(quantity);
              }
            }
            if (setDefaultQuant >= 1) {
              $('.product-form .input-quantity').val(1);
            } else {
              $('.product-form .input-quantity').val(1);
            }
            $('.btn-add-quantity').css("pointer-events", "auto");
          });
        }, 600);
      }
    });
  },
  inputQuantityChange: function inputQuantityChange() {
    var cartDrawer = this.defaults.cartdrawerjs.cartDrawer;
    var productJS = this.defaults.productjs;
    $(document).on('change', '.quantity-wrapper input.input-quantity', function () {
      var quantity = $(this).val();
      if (!$(this).parent().hasClass('subscribe-qty-wrapper') && !$(this).parent().hasClass('drawer-qty-wrapper')) {
        productJS.product.onChangeQuantity(quantity);
      }
      // var product_id = $(this).closest('.drawer-row-item').attr('data-productid');
      // var product_price = $(this).closest('.drawer-row-item').attr('data-price');
      var line_item_key = $(this).closest('[data-productid]').attr('data-lineitem-key');
      var product_id = $(this).closest('[data-productid]').attr('data-productid');
      var product_price = $(this).closest('[data-price]').attr('data-price');
      if ($(this).closest('[data-productid]').length > 0 && $(this).closest('[data-price]').length > 0) {
        var rowData = {
          quantity: quantity,
          product_id: product_id,
          line_item_key: line_item_key,
          product_price: product_price
        };
        var lineTotal = parseFloat(rowData.quantity) * parseFloat(rowData.product_price / 100);
        //$('.cart-items-content .cart-row-item[data-productid="'+rowData.product_id+'"] .item-total').text('$'+lineTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
        cartDrawer.inputQuantityChange(rowData);
        setTimeout(function () {
          $.getJSON('/cart.js', function (cart) {
            if (cart.total_price != cart.original_total_price) {
              // $('.cart-items-content .cart-row-items .item-giftNote').html('<br>Spend $100 and get $15 off!');
              // $('.you-are-saving').html("<p>You're saving $15.00</p>");

              $('#cart-total-amount-disc').css("display", "block");

              //mobile
              //$('.cart-items .drawer-row-item .item-giftNote').html('<br>Spend $100 and get $15 off!');

              jQuery.each(cart.items, function (index, item) {
                //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .item-disc').css("display", "block");
                $('.cart-items-content .cart-row-items[data-productid="' + item.variant_id + '"] .item-giftNote').css("display", "block");
                $('.you-are-saving').css("display", "block");

                //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .item-total').text('$'+parseFloat(item.line_price/100).toFixed(2));

                if (item.line_price != item.original_line_price) {
                  //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .item-disc').html('<s style="color: #909090;">$'+parseFloat(item.original_line_price/100).toFixed(2)+'</s>');
                  //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .single-item-price').html('<span>$'+parseFloat(item.discounted_price/100).toFixed(2)+'</span><br><span><s style="color: #909090;">$'+parseFloat(item.price/100).toFixed(2)+'</s></span>');
                  //mobile
                  //$('.cart-items .drawer-row-item[data-productid="'+item.variant_id+'"] .item-disc').html('<s style="color: #909090;">$'+parseFloat(item.original_line_price/100).toFixed(2)+'</s>');
                }

                //mobile 
                //$('.cart-items .drawer-row-item[data-productid="'+item.variant_id+'"] .item-total').text('$'+parseFloat(item.line_price/100).toFixed(2));
                //$('.cart-items .drawer-row-item[data-productid="'+item.variant_id+'"] .item-disc').css("display", "block");
                $('.cart-items .drawer-row-item[data-productid="' + item.variant_id + '"] .item-giftNote').css("display", "block");
                jQuery.each(item.line_level_discount_allocations, function (x, y) {
                  $('.cart-items-content .cart-row-items[data-productid="' + item.variant_id + '"] .item-giftNote').html('' + y.discount_application.title);
                  $('.you-are-saving').html("<p>You're saving $" + parseFloat(y.amount / 100).toFixed(2) + "</p>");

                  //mobile
                  $('.cart-items .drawer-row-item[data-productid="' + item.variant_id + '"] .item-giftNote').html('' + y.discount_application.title);
                });
              });
              $('#cart-total-amount-disc').html('<s style="color: #909090;">$' + parseFloat(cart.original_total_price / 100).toFixed(2) + '</s>');
            } else {
              jQuery.each(cart.items, function (index, item) {
                //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .item-total').text('$'+parseFloat(item.final_line_price/100).toFixed(2));
                //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .item-disc').css("display", "none");
                $('#cart-total-amount-disc').css("display", "none");
                $('.you-are-saving').css("display", "none");
                $('.item-giftNote').css("display", "none");
                //$('.cart-items-content .cart-row-item[data-productid="'+item.variant_id+'"] .single-item-price').html('<span>$'+parseFloat(item.price/100).toFixed(2)+'</span>');

                //mobile 
                //$('.cart-items .drawer-row-item[data-productid="'+item.variant_id+'"] .item-total').text('$'+parseFloat(item.final_line_price/100).toFixed(2));
                //$('.cart-items .drawer-row-item[data-productid="'+item.variant_id+'"] .item-disc').css("display", "none");
              });
            }
          });
        }, 2000);
      }
    });
  },
  subscribeBtnChangePrice: function subscribeBtnChangePrice(quantity) {
    //subs
    //var price = $('#rc_duplicate_selector').find(':selected').attr('data-discount-price');
    var price_subs = $(".rc_widget__price--subsave").text();
    if (price_subs != undefined) {
      price_subs = price_subs.replace("US", "");
      price_subs = price_subs.replace("$", "");
      var price_per_quantity_subs_btn = price_subs * quantity;
      var discAmt = $(".rc_widget__option__discount").text();
      if (discAmt != undefined) {
        $(".subscribe-cart-btn").empty().append("<div class='add-to-cart-text'> <span data-submit-button-text>Subscribe Now</span> </div> <span class='divider'>|</span> $" + price_per_quantity_subs_btn + " <span class='divider'>|</span> <span style='display: inline-block;vertical-align: middle;'>Every delivery</span>");
      } else {
        //$('.subscribe-cart-btn .product-price').html('$' + price_per_quantity);
        $(".subscribe-cart-btn").empty().append("<div class='add-to-cart-text'> <span data-submit-button-text>Subscribe Now</span> </div> <span class='divider'>|</span> $" + price_per_quantity_subs_btn.toFixed(2) + " <span class='divider'>|</span> <span style='display: inline-block;vertical-align: middle;'>Every delivery</span>");
      }
    }
    if ($(".rc-container-wrapper")[0]) {
      //with buttons 
      // var c = $(".rc_widget__price--onetime").text();
      // c = c.replace("US", "");
      // c = c.replace("$", "");

      // var price_per_quantity_single_btn = c * quantity;

      // $(".add-to-cart-btn").empty().append("<span data-submit-button-text> Add to Cart </span> <span class='divider'>|</span> $"+price_per_quantity_single_btn.toFixed(2));

      var data_price = $("#rc_duplicate_selector").find(':selected').attr('data-price');
      var data_discount_price = $("#rc_duplicate_selector").find(':selected').attr('data-discount-price');
      var quan = parseInt($("#Quantity").val());
      var p = (data_price / 100).toFixed(2);
      var btnPrice = quan * p;
      $(".add-to-cart-btn").html('<span data-submit-button-text >ADD TO CART <span> <span class="divider">|</span> $' + btnPrice.toFixed(2));
      $(".subscribe-cart-btn").html('<div class="add-to-cart-text"><span data-submit-button-text="">Subscribe Now</span></div> <span class="divider">|</span> $' + data_discount_price + ' <span class="divider">|</span> <span style="display: inline-block;vertical-align: middle;">Every delivery</span>');
    } else {
      //buy once
      var hasVariant = $('#Option1').find(':selected').attr('data-single-discount');
      if (hasVariant != undefined) {
        var price_single = parseInt($('#Option1').find(':selected').attr('data-single-discount').replace("$", ""));
        var price_per_quantity_single = price_single * quantity;
        $('.add-to-cart-btn span[data-product-price]').html('$' + price_per_quantity_single);
      }
    }
  }
};
function getPrice() {
  setTimeout(function () {
    var priceGet = Number($('.getTotalAmt').html().replace(/[^0-9\.-]+/g, ""));
    if (priceGet > 250) {
      $('.to-add-afterpay').removeClass("hideThis");
      $('.to-add-afterpay').addClass("showThis");
      $('.to-add-afterpay').html("Afterpay not available if your spend more than $250 however we offer a split invoice option.");
    } else {
      $('.to-add-afterpay').removeClass("showThis");
      $('.to-add-afterpay').addClass("hideThis");
    }
  }, 2000);
}
var _quantityInput = quantityInput;


/***/ }),

/***/ "./src/js/er-custom/featuredproduct-addajax.js":
/*!*****************************************************!*\
  !*** ./src/js/er-custom/featuredproduct-addajax.js ***!
  \*****************************************************/
/*! exports provided: featprod_addajax */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "featprod_addajax", function() { return _featprod_addajax; });
/* harmony import */ var _update_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./update-cart */ "./src/js/er-custom/update-cart.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! slick-carousel/slick/slick.min.js */ "./node_modules/slick-carousel/slick/slick.min.js");
/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_2__);



var featprod_addajax = {};
featprod_addajax = {
  defaults: {
    updateCart: _update_cart__WEBPACK_IMPORTED_MODULE_0__
  },
  onInit: function onInit(e) {
    var vm = this;
    var el = vm.defaults;
    var updateCart = el.updateCart.updateCart;
    jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).on('click', '.addtocart-featured-product, #addToCartFeatured', function (e) {
      e.preventDefault();
      var add_btn = jquery__WEBPACK_IMPORTED_MODULE_1___default()(this),
        var_id = add_btn.attr('data-varid');
      var data = {
        "quantity": 1,
        "id": var_id
      };
      jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).css("pointer-events", "none");
      jquery__WEBPACK_IMPORTED_MODULE_1___default.a.getJSON('/cart.js', function (cart) {
        jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).css("pointer-events", "none");
      }).done(function (cart) {
        jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).css("pointer-events", "none");
        var cartItem = cart.item_count;
        var getQtyCartLimit = localStorage.getItem("max_variant_cart");
        if (getQtyCartLimit != null) {
          //when SKU Limit 5 is ON
          if (cartItem < getQtyCartLimit) {
            add_btn.html('<div class="adding-loader">Adding<span>.</span><span>.</span><span>.</span></div>');
            jquery__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
              type: 'post',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function success(data) {
                //updateCart.updateCartItem();
                Shopify.getCart(function (cart) {
                  jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-item-count').text(cart.item_count);
                  var addonSlides = document.querySelectorAll('.drawer-row-item.is-upsell');
                  if (addonSlides.length >= 1) {
                    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box').addClass('has-items');
                  } else {
                    jquery__WEBPACK_IMPORTED_MODULE_1___default()('.checkout-box').removeClass('has-items');
                  }
                  jquery__WEBPACK_IMPORTED_MODULE_1___default()('.upsell-carousel-wrapper').slick({
                    infinite: false,
                    arrows: true,
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '<div class="slick-arrow slick-prev"></div>',
                    nextArrow: '<div class="slick-arrow slick-next"></div>'
                  });
                });
              }
            }).done(function (data) {
              jquery__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
                method: 'GET',
                url: location.href,
                async: true,
                dataType: 'html',
                success: function success(data) {}
              }).done(function (data) {
                var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_1___default()(data).find("#site-slidecart-inner");
                jquery__WEBPACK_IMPORTED_MODULE_1___default()('#site-slide-cart-drawer').html(cart_slide);
                add_btn.html('Add to Cart');
                jquery__WEBPACK_IMPORTED_MODULE_1___default()('body').removeClass('empty-cart');
                jquery__WEBPACK_IMPORTED_MODULE_1___default()('body').addClass('slide-cart');
                jquery__WEBPACK_IMPORTED_MODULE_1___default()(".quickadd-with-variant").css("pointer-events", "auto");
              });
            });
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_1___default()(this).css("pointer-events", "none");
          }
        } else {
          //when SKU Limit 5 is off
          add_btn.html('<div class="adding-loader">Adding<span>.</span><span>.</span><span>.</span></div>');
          jquery__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
            type: 'post',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function success(data) {
              //updateCart.updateCartItem();
              Shopify.getCart(function (cart) {
                jquery__WEBPACK_IMPORTED_MODULE_1___default()('.cart-item-count').text(cart.item_count);
              });
              jquery__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
                method: 'GET',
                url: location.href,
                async: true,
                dataType: 'html',
                success: function success(data) {
                  var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_1___default()(data).find("#site-slidecart-inner");
                  jquery__WEBPACK_IMPORTED_MODULE_1___default()('#site-slide-cart-drawer').html(cart_slide);
                  add_btn.html('Add to Cart');
                  jquery__WEBPACK_IMPORTED_MODULE_1___default()('body').removeClass('empty-cart');
                  jquery__WEBPACK_IMPORTED_MODULE_1___default()('body').addClass('slide-cart');

                  // Trigger cart update events for GWP progress bar
                  jquery__WEBPACK_IMPORTED_MODULE_1___default()(document).trigger('cartUpdated');
                  document.dispatchEvent(new Event('cartRedraw'));
                }
              });
            }
          });
        }
      });
    });
  }
};
var _featprod_addajax = featprod_addajax;


/***/ }),

/***/ "./src/js/er-custom/geo.js":
/*!*********************************!*\
  !*** ./src/js/er-custom/geo.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 *  Geo Tools
 *    Provides common tools and funcitons for geo related items, including
 *    callbacks etc.
 *
 *  Dependencies:
 *    js-cookie - Cookies is used to cache data.
 *
 *  Version:
 *    1.0.0 - 2018/09/20
 */

var GEO_CACHE_COOKIE_NAME = 'GeoDataCache';
function geoTools() {
  this.callbacks = [];

  //Check the cookie first and then we can start tracking geodata.
  if ((typeof Cookies === "undefined" ? "undefined" : _typeof(Cookies)) !== ( true ? "undefined" : undefined) && typeof Cookies.get === "function") {
    var data = Cookies.get(GEO_CACHE_COOKIE_NAME);

    //Cookie may store it as a JSON object... test.
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.error(e);
        return;
      }
    }
    this.geoData = data;
  }
}
geoTools.prototype = {
  fetchGeo: function fetchGeo(callback) {
    //First let's check if we already have the geo data
    if (_typeof(this.geoData) !== ( true ? "undefined" : undefined)) {
      return callback(this.geoData); //Immediately callback
    }

    //We don't have it, let's fetch and append the callback
    this.callbacks.push(callback);

    //Are we already fetching?
    if (_typeof(this.geoFetch) !== ( true ? "undefined" : undefined)) return;

    //Not fetching, fetch!
    this.geoFetch = $.ajax({
      url: '//pro.ip-api.com/json/',
      data: {
        'key': '6pOBPLtWwxnT4qZ'
      },
      method: 'GET',
      contentType: 'application/json',
      success: this.onGeoFetched.bind(this),
      error: this.onGeoError.bind(this)
    });
  },
  onGeoError: function onGeoError(e) {
    console.error('geoerror', e);
  },
  onGeoFetched: function onGeoFetched(data) {
    //Geo fetched
    data.country_code = data.countryCode;
    this.geoData = data;
    for (var i = 0; i < this.callbacks.length; i++) {
      //Fire callback
      this.callbacks[i](data);
    }

    //Fire event
    $(document).trigger('onGeo', data);

    //Store the cookie
    if ((typeof Cookies === "undefined" ? "undefined" : _typeof(Cookies)) !== ( true ? "undefined" : undefined) && typeof Cookies.set === "function") {
      Cookies.set(GEO_CACHE_COOKIE_NAME, data, {
        expires: 1
      });
    }
  },
  clear: function clear() {
    this.geoData = null;
    Cookies.set(GEO_CACHE_COOKIE_NAME, '');
    window.location.reload();
  }
};
window.Geo = new geoTools();

/***/ }),

/***/ "./src/js/er-custom/gwp-auto-add.js":
/*!******************************************!*\
  !*** ./src/js/er-custom/gwp-auto-add.js ***!
  \******************************************/
/*! exports provided: gwpAutoAdd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gwpAutoAdd", function() { return _gwpAutoAdd; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var gwpAutoAdd = {
  defaults: {
    isProcessing: false,
    isRefreshingCart: false,
    lastCheckTime: 0
  },
  debounce: function debounce(func, delay) {
    var timeoutId;
    return function () {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        return func.apply(_this, args);
      }, delay);
    };
  },
  /**
   * Helper function to check if an item has the _free_gift property
   */
  hasFreeGiftProperty: function hasFreeGiftProperty(item) {
    if (!item.properties || _typeof(item.properties) !== 'object') {
      return false;
    }
    var freeGiftValue = null;
    if (Array.isArray(item.properties)) {
      for (var propertyIndex = 0; propertyIndex < item.properties.length; propertyIndex++) {
        var prop = item.properties[propertyIndex];
        if (prop) {
          var propKey = prop.first || prop[0] || prop.key || null;
          var propVal = prop.last || prop[1] || prop.value || null;
          if (propKey === '_free_gift') {
            freeGiftValue = propVal;
            break;
          }
        }
      }
    } else {
      freeGiftValue = item.properties['_free_gift'] || item.properties._free_gift || null;
    }
    return freeGiftValue === 'true' || freeGiftValue === true;
  },
  /**
   * Get checkmark SVG HTML
   */
  getCheckmarkSvg: function getCheckmarkSvg() {
    return '<span class="gwp-checkmark">' + '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<circle cx="10" cy="10" r="9" stroke="#ae7857" stroke-width="2" fill="none"/>' + '<path d="M6 10l3 3 5-5" stroke="#ae7857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '</svg></span>';
  },
  onInit: function onInit() {
    var vm = this;
    vm.checkFreeGiftStatus();
    vm.debouncedCheckGiftFromUpdated = vm.debounce(function () {
      vm.checkFreeGiftStatus();
    }, 500);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cartUpdated', vm.debouncedCheckGiftFromUpdated);
    vm.debouncedCheckGift = vm.debounce(function () {
      vm.checkFreeGiftStatus();
    }, 500);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cartRedraw', vm.debouncedCheckGift);

    // Recalculate progress bar on window resize and on load (for mobile/desktop switching)
    var updateProgressOnResize = function updateProgressOnResize() {
      var $gwpContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.gwp-progress-container');
      if ($gwpContainer.length) {
        var cartTotal = parseInt($gwpContainer.data('cart-total')) || 0;
        vm.updateProgressBar(cartTotal);
      }
    };
    var debouncedResize = vm.debounce(updateProgressOnResize, 250);

    // Function to update progress bar when container is available
    var ensureProgressBarUpdated = function ensureProgressBarUpdated() {
      var $gwpContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.gwp-progress-container');
      if ($gwpContainer.length) {
        var cartTotal = parseInt($gwpContainer.data('cart-total')) || 0;
        vm.updateProgressBar(cartTotal);
        return true;
      }
      return false;
    };
    ensureProgressBarUpdated();
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(function () {
      if (!ensureProgressBarUpdated()) {
        setTimeout(function () {
          ensureProgressBarUpdated();
        }, 100);
        setTimeout(function () {
          ensureProgressBarUpdated();
        }, 300);
        setTimeout(function () {
          ensureProgressBarUpdated();
        }, 500);
        setTimeout(function () {
          ensureProgressBarUpdated();
        }, 1000);
      }
    });

    // Watch for cart drawer to open
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var $body = jquery__WEBPACK_IMPORTED_MODULE_0___default()(mutation.target);
          if ($body.hasClass('slide-cart')) {
            setTimeout(function () {
              ensureProgressBarUpdated();
            }, 100);
            setTimeout(function () {
              ensureProgressBarUpdated();
            }, 300);
          }
        }
      });
    });
    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('cartRedraw cartUpdated', function () {
      setTimeout(function () {
        ensureProgressBarUpdated();
      }, 50);
    });
    var containerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            var $node = jquery__WEBPACK_IMPORTED_MODULE_0___default()(node);
            if ($node.hasClass('gwp-progress-container') || $node.find('.gwp-progress-container').length) {
              // GWP container was added, update progress bar
              setTimeout(function () {
                ensureProgressBarUpdated();
              }, 50);
            }
          }
        });
      });
    });
    if (document.body) {
      containerObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Run on resize
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', debouncedResize);
  },
  /**
   * Check if free gift should be added to cart
   */
  checkFreeGiftStatus: function checkFreeGiftStatus() {
    var vm = this;

    // Prevent recursive calls
    if (vm.defaults.isProcessing || vm.defaults.isRefreshingCart) {
      return;
    }

    // Throttle: prevent checking more than once per 500ms
    var now = Date.now();
    if (now - vm.defaults.lastCheckTime < 500) {
      return;
    }
    vm.defaults.lastCheckTime = now;
    var $gwpContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.gwp-progress-container');
    if (!$gwpContainer.length) {
      return;
    }
    var freeGiftEnabled = $gwpContainer.data('free-gift-enabled');
    // Get tier values
    var freeGiftValueTier1 = parseInt($gwpContainer.data('free-gift-value-tier1')) || 0;
    var freeGiftValueTier2 = parseInt($gwpContainer.data('free-gift-value-tier2')) || 0;
    var freeGiftValueTier3 = parseInt($gwpContainer.data('free-gift-value-tier3')) || 0;

    // Get tier-specific variant IDs
    var freeGiftVariantIdTier1 = parseInt($gwpContainer.data('free-gift-variant-id-tier1')) || 0;
    var freeGiftVariantIdTier2 = parseInt($gwpContainer.data('free-gift-variant-id-tier2')) || 0;
    var freeGiftVariantIdTier3 = parseInt($gwpContainer.data('free-gift-variant-id-tier3')) || 0;

    // Get discount percentages
    var tier1DiscountPercent = parseInt($gwpContainer.data('tier1-discount-percent')) || 0;
    var tier2DiscountPercent = parseInt($gwpContainer.data('tier2-discount-percent')) || 0;
    var tier3DiscountPercent = parseInt($gwpContainer.data('tier3-discount-percent')) || 0;
    var cartTotal = parseInt($gwpContainer.data('cart-total')) || 0;

    // Get setting for including shipping in GWP tiers
    var includeShippingInGwpTiersAttr = $gwpContainer.attr('data-include-shipping-in-gwp-tiers');
    var includeShippingInGwpTiers = includeShippingInGwpTiersAttr && (includeShippingInGwpTiersAttr === 'true' || includeShippingInGwpTiersAttr === true || String(includeShippingInGwpTiersAttr).toLowerCase() === 'true');

    // Determine tier count to check if we should include shipping
    var tierCount = 0;
    if (freeGiftValueTier1 > 0) {
      tierCount = 1;
      if (freeGiftValueTier2 > 0) {
        tierCount = 2;
        if (freeGiftValueTier3 > 0) {
          tierCount = 3;
        }
      }
    }

    // Use GWP cart total (with shipping if enabled and less than 3 tiers) for tier calculations
    var gwpCartTotal = cartTotal;
    if (includeShippingInGwpTiers && tierCount < 3) {
      // Get GWP cart total from data attribute (calculated in Liquid with free shipping value as shipping cost)
      var gwpCartTotalFromData = parseInt($gwpContainer.data('gwp-cart-total')) || cartTotal;
      gwpCartTotal = gwpCartTotalFromData;

      // If gwp_cart_total equals cart_total, try to add free shipping value as shipping cost
      if (gwpCartTotal === cartTotal) {
        var freeShippingValue = parseInt($gwpContainer.data('free-shipping-value')) || 0;
        if (freeShippingValue > 0) {
          gwpCartTotal = cartTotal + freeShippingValue;
        }
      }
    }

    // Check if auto-add is disabled - read directly from attribute to avoid jQuery data() conversion issues
    var disableAutoAddAttr = $gwpContainer.attr('data-disable-auto-add-free-gift');
    var disableAutoAdd = disableAutoAddAttr && (disableAutoAddAttr === 'true' || disableAutoAddAttr === true || String(disableAutoAddAttr).toLowerCase() === 'true');

    // Always fetch cart data for logging, even if auto-add is disabled
    // Get cart items to check eligibility
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON('/cart.js', function (cart) {
      if (!cart || !cart.items) {
        return;
      }
      var cartItems = cart.items;
      // Use actual cart total from API response
      var actualCartTotal = cart.total_price || 0;
      var freeShippingValue = parseInt($gwpContainer.data('free-shipping-value')) || 0;

      // Calculate tier information for logging
      // Use actual cart total - free shipping is a threshold, not something to add
      var cartTotalForTierCheck = actualCartTotal;
      var effectiveTier1Threshold = freeGiftValueTier1;
      var effectiveTier2Threshold = freeGiftValueTier2;
      var effectiveTier3Threshold = freeGiftValueTier3;

      // Determine next threshold - check against ORIGINAL thresholds using ACTUAL cart total
      // This shows what the user needs to spend in real dollars, not the adjusted amounts
      var nextThreshold = null;
      var nextThresholdName = '';
      if (actualCartTotal < freeGiftValueTier1) {
        nextThreshold = freeGiftValueTier1; // Use original threshold for display
        nextThresholdName = 'Tier 1';
      } else if (freeGiftValueTier2 > 0 && actualCartTotal < freeGiftValueTier2) {
        nextThreshold = freeGiftValueTier2; // Use original threshold for display
        nextThresholdName = 'Tier 2';
      } else if (freeGiftValueTier3 > 0 && actualCartTotal < freeGiftValueTier3) {
        nextThreshold = freeGiftValueTier3; // Use original threshold for display
        nextThresholdName = 'Tier 3';
      }

      // Calculate difference using actual cart total against original threshold
      var difference = null;
      if (nextThreshold !== null) {
        difference = nextThreshold - actualCartTotal;
      }

      // If feature not fully configured, stop here
      if (!freeGiftEnabled || freeGiftValueTier1 === 0) {
        return;
      }
      if (disableAutoAdd) {
        return;
      }
      var tiersToAdd = [];
      var tiersProcessed = false;

      // Helper to process tiers
      function processTiersAfterChecks() {
        // Prevent multiple processing
        if (tiersProcessed) {
          return;
        }
        tiersProcessed = true;

        // Double-check we're not already processing
        if (vm.defaults.isProcessing || vm.defaults.isRefreshingCart) {
          return;
        }

        // Get all tier variant IDs once
        var allTierVariantIds = [freeGiftVariantIdTier1, freeGiftVariantIdTier2, freeGiftVariantIdTier3].filter(function (id) {
          return id > 0;
        });

        // Remove free gifts if below all thresholds
        if (tiersToAdd.length === 0) {
          // Check all tier variants and remove any that are in cart
          for (var variantIndex = 0; variantIndex < allTierVariantIds.length; variantIndex++) {
            vm.isGiftInCart(allTierVariantIds[variantIndex], function (isInCart, lineItemKey) {
              if (isInCart && lineItemKey) {
                vm.removeFreeGiftFromCart(lineItemKey);
              }
            });
          }
          return;
        }
        var achievedVariantIds = tiersToAdd.map(function (t) {
          return t.variantId;
        });
        for (var variantIndex = 0; variantIndex < allTierVariantIds.length; variantIndex++) {
          var variantId = allTierVariantIds[variantIndex];
          if (achievedVariantIds.indexOf(variantId) === -1) {
            vm.isGiftInCart(variantId, function (isInCart, lineItemKey) {
              if (isInCart && lineItemKey) {
                vm.removeFreeGiftFromCart(lineItemKey);
              }
            });
          }
        }
        var giftsToAddQueue = [];
        var giftsToAddChecked = 0;
        var totalChecksNeeded = tiersToAdd.length;
        var queueProcessingStarted = false;
        if (totalChecksNeeded === 0) {
          return;
        }
        for (var tierIndex = 0; tierIndex < tiersToAdd.length; tierIndex++) {
          (function (tierInfo) {
            vm.isGiftInCart(tierInfo.variantId, function (isInCart, lineItemKey, quantity) {
              if (!isInCart) {
                // Check if the variant is already in cart (manually added)
                vm.isVariantInCart(tierInfo.variantId, function (hasManualItem, manualLineItemKey) {
                  if (!hasManualItem) {
                    giftsToAddQueue.push({
                      variantId: tierInfo.variantId,
                      discountPercent: tierInfo.discountPercent,
                      tier: tierInfo.tier
                    });
                  }
                  giftsToAddChecked++;
                  if (giftsToAddChecked === totalChecksNeeded && !queueProcessingStarted) {
                    queueProcessingStarted = true;
                    vm.addGiftsSequentially(giftsToAddQueue, 0);
                  }
                });
              } else if (quantity && quantity > 1 && lineItemKey) {
                vm.removeFreeGiftFromCart(lineItemKey);
                giftsToAddChecked++;
                if (giftsToAddChecked === totalChecksNeeded && !queueProcessingStarted) {
                  queueProcessingStarted = true;
                  vm.addGiftsSequentially(giftsToAddQueue, 0);
                }
              } else {
                giftsToAddChecked++;
                if (giftsToAddChecked === totalChecksNeeded && !queueProcessingStarted) {
                  queueProcessingStarted = true;
                  vm.addGiftsSequentially(giftsToAddQueue, 0);
                }
              }
            });
          })(tiersToAdd[tierIndex]);
        }
      }

      // Add tiers directly when thresholds are met (no eligibility checks needed)
      // Use the already calculated cartTotalForTierCheck and effective thresholds from above
      if (cartTotalForTierCheck >= effectiveTier1Threshold && freeGiftVariantIdTier1 > 0) {
        tiersToAdd.push({
          tier: 1,
          variantId: freeGiftVariantIdTier1,
          discountPercent: tier1DiscountPercent
        });
      }
      if (freeGiftValueTier2 > 0 && cartTotalForTierCheck >= effectiveTier2Threshold && freeGiftVariantIdTier2 > 0) {
        tiersToAdd.push({
          tier: 2,
          variantId: freeGiftVariantIdTier2,
          discountPercent: tier2DiscountPercent
        });
      }
      if (freeGiftValueTier3 > 0 && cartTotalForTierCheck >= effectiveTier3Threshold && freeGiftVariantIdTier3 > 0) {
        tiersToAdd.push({
          tier: 3,
          variantId: freeGiftVariantIdTier3,
          discountPercent: tier3DiscountPercent
        });
      }
      processTiersAfterChecks();
    });
  },
  /**
   * Check if free gift product is already in cart
   */
  isGiftInCart: function isGiftInCart(variantId, callback) {
    var vm = this;
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON('/cart.js', function (cart) {
      var isInCart = false;
      var lineItemKey = null;
      var quantity = 0;
      if (cart && cart.items) {
        for (var itemIndex = 0; itemIndex < cart.items.length; itemIndex++) {
          var item = cart.items[itemIndex];
          if (item.variant_id === variantId && vm.hasFreeGiftProperty(item)) {
            isInCart = true;
            lineItemKey = item.key;
            quantity = item.quantity || 1;
            break;
          }
        }
      }
      if (typeof callback === 'function') {
        callback(isInCart, lineItemKey, quantity);
      }
    }).fail(function () {
      if (typeof callback === 'function') {
        callback(false, null, 0);
      }
    });
  },
  /**
   * Check if variant is in cart (regardless of properties - for detecting manually added items)
   */
  isVariantInCart: function isVariantInCart(variantId, callback) {
    var vm = this;
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON('/cart.js', function (cart) {
      var isInCart = false;
      var lineItemKey = null;
      if (cart && cart.items) {
        for (var itemIndex = 0; itemIndex < cart.items.length; itemIndex++) {
          var item = cart.items[itemIndex];
          if (item.variant_id === variantId && !vm.hasFreeGiftProperty(item)) {
            isInCart = true;
            lineItemKey = item.key;
            break;
          }
        }
      }
      if (typeof callback === 'function') {
        callback(isInCart, lineItemKey);
      }
    }).fail(function () {
      if (typeof callback === 'function') {
        callback(false, null);
      }
    });
  },
  /**
   * Add multiple gifts sequentially (one after another)
   */
  addGiftsSequentially: function addGiftsSequentially(giftsQueue, index) {
    var vm = this;
    if (index === 0) {
      vm.defaults.isProcessing = true;
      vm.defaults.isRefreshingCart = true;
    }
    if (!giftsQueue || giftsQueue.length === 0 || index >= giftsQueue.length) {
      if (giftsQueue && giftsQueue.length > 0) {
        vm.refreshCartDrawer();
      } else {
        vm.defaults.isProcessing = false;
        vm.defaults.isRefreshingCart = false;
      }
      return;
    }
    var gift = giftsQueue[index];
    vm.addFreeGiftToCartSequential(gift.variantId, gift.discountPercent, gift.tier, function (success) {
      setTimeout(function () {
        vm.addGiftsSequentially(giftsQueue, index + 1);
      }, 500);
    });
  },
  /**
   * Add free gift product to cart (sequential version - calls callback when done)
   */
  addFreeGiftToCartSequential: function addFreeGiftToCartSequential(variantId, discountPercent, tierNumber, callback) {
    var vm = this;
    var properties = {
      '_free_gift': 'true',
      '_gwp_tier': String(tierNumber || 1)
    };
    if (discountPercent && discountPercent > 0) {
      properties['_gwp_discount_percent'] = String(discountPercent);
    }
    var addData = {
      id: variantId,
      quantity: 1,
      properties: properties
    };
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: addData,
      success: function success(response) {
        if (typeof callback === 'function') {
          callback(true);
        }
      },
      error: function error(xhr, status, _error) {
        console.error('[GWP] Error adding free gift to cart:', {
          variantId: variantId,
          tier: tierNumber,
          error: _error,
          xhr: xhr,
          status: status
        });
        if (typeof callback === 'function') {
          callback(false);
        }
      }
    });
  },
  /**
   * Add free gift product to cart
   */
  addFreeGiftToCart: function addFreeGiftToCart(variantId, discountPercent, tierNumber) {
    var vm = this;
    if (vm.defaults.isProcessing || vm.defaults.isRefreshingCart) {
      return;
    }
    vm.defaults.isProcessing = true;
    var properties = {
      '_free_gift': 'true',
      '_gwp_tier': String(tierNumber || 1)
    };

    // Add discount percentage if provided
    if (discountPercent && discountPercent > 0) {
      properties['_gwp_discount_percent'] = String(discountPercent);
    }
    var addData = {
      id: variantId,
      quantity: 1,
      properties: properties
    };
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: addData,
      success: function success(response) {
        vm.refreshCartDrawer();
      },
      error: function error(xhr, status, _error2) {
        console.error('Error adding free gift to cart:', _error2);
        vm.defaults.isProcessing = false;
      }
    });
  },
  /**
   * Remove free gift product from cart using line item key
   */
  removeFreeGiftFromCart: function removeFreeGiftFromCart(lineItemKey) {
    var vm = this;
    if (vm.defaults.isProcessing || vm.defaults.isRefreshingCart) {
      return;
    }
    vm.defaults.isProcessing = true;
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: lineItemKey,
        quantity: 0
      },
      success: function success() {
        vm.refreshCartDrawer();
      },
      error: function error() {
        vm.defaults.isProcessing = false;
      }
    });
  },
  /**
   * Refresh cart drawer after adding gift
   */
  refreshCartDrawer: function refreshCartDrawer() {
    var vm = this;
    vm.defaults.isRefreshingCart = true;
    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
      method: 'GET',
      url: location.href,
      async: true,
      dataType: 'html',
      success: function success(data) {
        var cartSlide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(data).find("#site-slidecart-inner");
        if (cartSlide.length) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('#site-slide-cart-drawer').html(cartSlide);
          jquery__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON('/cart.js', function (cart) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.cart-item-count').text(cart.item_count);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.cart-drawer .total-cart').text(cart.item_count);
            if (cart.item_count > 1) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('.cart-drawer .item-title').text("Items");
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('.cart-drawer .item-title').text("Item");
            }
            var cartTotal = cart.total_price || 0;
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.gwp-progress-container').attr('data-cart-total', cartTotal);
            vm.updateProgressBar(cartTotal);
          });
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cartUpdated');
          document.dispatchEvent(new Event('cartRedraw'));
          setTimeout(function () {
            vm.defaults.isRefreshingCart = false;
          }, 300);
        } else {
          vm.defaults.isRefreshingCart = false;
          vm.defaults.isProcessing = false;
        }
        vm.defaults.isProcessing = false;
      },
      error: function error() {
        vm.defaults.isProcessing = false;
        vm.defaults.isRefreshingCart = false;
      }
    });
  },
  /**
   * Update progress bars dynamically - separate for free shipping and GWP with 3 tiers
   */
  updateProgressBar: function updateProgressBar(cartTotal) {
    var vm = this;
    var $gwpContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.gwp-progress-container');
    if (!$gwpContainer.length) {
      return;
    }
    var freeShippingEnabled = $gwpContainer.data('free-shipping-enabled');
    var freeGiftEnabled = $gwpContainer.data('free-gift-enabled');
    var freeShippingValue = parseInt($gwpContainer.data('free-shipping-value')) || 0;

    // Get setting for including shipping in GWP tiers
    var includeShippingInGwpTiersAttr = $gwpContainer.attr('data-include-shipping-in-gwp-tiers');
    var includeShippingInGwpTiers = includeShippingInGwpTiersAttr && (includeShippingInGwpTiersAttr === 'true' || includeShippingInGwpTiersAttr === true || String(includeShippingInGwpTiersAttr).toLowerCase() === 'true');

    // Determine tier count
    var tierCount = 1;
    if (freeGiftValueTier2 > 0) {
      tierCount = 2;
      if (freeGiftValueTier3 > 0) {
        tierCount = 3;
      }
    }

    // Determine if free shipping should be integrated into GWP tiers
    var integrateFreeShipping = false;
    var effectiveTierCount = tierCount;
    if (includeShippingInGwpTiers && tierCount < 3 && freeShippingValue > 0) {
      integrateFreeShipping = true;
      effectiveTierCount = tierCount + 1;
    }
    // Get GWP tier values FIRST (before calculating tier count)
    var freeGiftValueTier1 = parseInt($gwpContainer.data('free-gift-value-tier1')) || 0;
    var freeGiftValueTier2 = parseInt($gwpContainer.data('free-gift-value-tier2')) || 0;
    var freeGiftValueTier3 = parseInt($gwpContainer.data('free-gift-value-tier3')) || 0;
    // Fallback to legacy value
    var freeGiftValue = parseInt($gwpContainer.data('free-gift-value')) || 0;
    if (freeGiftValueTier1 === 0 && freeGiftValue > 0) {
      freeGiftValueTier1 = freeGiftValue;
    }

    // Determine tier count (now that we have tier values)
    var tierCount = 1;
    if (freeGiftValueTier2 > 0) {
      tierCount = 2;
      if (freeGiftValueTier3 > 0) {
        tierCount = 3;
      }
    }

    // Determine if free shipping should be integrated into GWP tiers
    var integrateFreeShipping = false;
    var effectiveTierCount = tierCount;
    if (includeShippingInGwpTiers && tierCount < 3 && freeShippingValue > 0) {
      integrateFreeShipping = true;
      effectiveTierCount = tierCount + 1;
    }
    var gwpCartTotal = cartTotal;
    if (includeShippingInGwpTiers && tierCount < 3) {
      var gwpCartTotalFromData = parseInt($gwpContainer.data('gwp-cart-total')) || cartTotal;
      gwpCartTotal = gwpCartTotalFromData;
      if (gwpCartTotal === cartTotal) {
        if (freeShippingValue > 0) {
          gwpCartTotal = cartTotal + freeShippingValue;
        }
      }
    }

    // Get tier messages
    var tier1ProgressMessage = $gwpContainer.data('tier1-progress-message') || 'Spend #money# more to unlock tier 1';
    var tier2ProgressMessage = $gwpContainer.data('tier2-progress-message') || 'Spend #money# more to unlock tier 2';
    var tier3ProgressMessage = $gwpContainer.data('tier3-progress-message') || 'Spend #money# more to unlock tier 3';
    var freeShippingProgressMessage = $gwpContainer.data('free-shipping-progress-message') || 'Spend #money# extra to achieve free shipping';
    var gwpSuccessMessage = $gwpContainer.data('gwp-success-message') || "Congrats! You've earned a reward";

    // Only update separate free shipping bar if not integrated
    if (freeShippingEnabled && freeShippingValue > 0 && !integrateFreeShipping) {
      var hasFreeShipping = cartTotal >= freeShippingValue;
      var freeShippingProgress = 0;
      if (hasFreeShipping) {
        freeShippingProgress = 100;
      } else {
        freeShippingProgress = cartTotal / freeShippingValue * 100;
      }
      if (freeShippingProgress > 100) {
        freeShippingProgress = 100;
      }

      // Update free shipping progress bar
      $gwpContainer.find('.free-shipping-progress-line-fill').css('width', freeShippingProgress + '%');

      // Update free shipping checkmark
      var vm = this;
      var $freeShippingCheck = $gwpContainer.find('.free-shipping-stage-check');
      if (hasFreeShipping) {
        $freeShippingCheck.addClass('is-complete');
        if (!$freeShippingCheck.find('.free-shipping-checkmark').length) {
          $freeShippingCheck.html('<span class="free-shipping-checkmark">' + vm.getCheckmarkSvg() + '</span>');
        }
      } else {
        $freeShippingCheck.removeClass('is-complete').empty();
      }

      // Update message
      var $freeShippingMessage = $gwpContainer.find('.free-shipping-message-text');
      if (hasFreeShipping) {
        $freeShippingMessage.addClass('is-complete');
      } else {
        $freeShippingMessage.removeClass('is-complete');
      }
    }
    if (freeGiftEnabled && freeGiftValueTier1 > 0) {
      var isMobile = window.innerWidth <= 768;
      var freeShippingPosition = 0;
      var tier1Position, tier2Position, tier3Position;
      if (effectiveTierCount === 1) {
        if (integrateFreeShipping) {
          freeShippingPosition = 100;
        } else {
          tier1Position = 100;
        }
      } else if (effectiveTierCount === 2) {
        if (integrateFreeShipping) {
          freeShippingPosition = 50;
          tier1Position = 100;
        } else {
          tier1Position = 50;
          tier2Position = 100;
        }
      } else if (effectiveTierCount === 3) {
        if (integrateFreeShipping) {
          if (isMobile) {
            freeShippingPosition = 25;
            tier1Position = 66;
            tier2Position = 100;
          } else {
            freeShippingPosition = 50;
            tier1Position = 75;
            tier2Position = 100;
          }
        } else {
          if (isMobile) {
            tier1Position = 33;
            tier2Position = 66;
            tier3Position = 100;
          } else {
            tier1Position = 50;
            tier2Position = 75;
            tier3Position = 100;
          }
        }
      } else if (effectiveTierCount === 4) {
        freeShippingPosition = 25;
        tier1Position = 50;
        tier2Position = 75;
        tier3Position = 100;
      }

      // Always use actual cart total for tier checks - don't add free shipping value
      var cartTotalForTiers = cartTotal;

      // Check if free shipping is achieved (when integrated)
      var hasFreeShipping = false;
      if (integrateFreeShipping) {
        hasFreeShipping = cartTotal >= freeShippingValue;
      }
      var hasTier1 = cartTotalForTiers >= freeGiftValueTier1;
      var hasTier2 = freeGiftValueTier2 > 0 && cartTotalForTiers >= freeGiftValueTier2 && hasTier1; // Tier 2 requires tier 1
      var hasTier3 = freeGiftValueTier3 > 0 && cartTotalForTiers >= freeGiftValueTier3 && hasTier2; // Tier 3 requires tier 2

      var freeShippingProgressGwp = 0;
      var tier1Progress = 0;
      var tier2Progress = 0;
      var tier3Progress = 0;

      // Calculate progressbased on effective tier count (including free shipping if integrated)
      if (integrateFreeShipping) {
        if (effectiveTierCount === 2) {
          if (cartTotal < freeShippingValue) {
            freeShippingProgressGwp = cartTotal / freeShippingValue * 50;
          } else {
            freeShippingProgressGwp = 50;
            if (cartTotalForTiers < freeGiftValueTier1) {
              var tier1Range = freeGiftValueTier1 - freeShippingValue;
              var tier1ProgressAmount = cartTotalForTiers - freeShippingValue;
              tier1Progress = tier1ProgressAmount / tier1Range * 50;
            } else {
              tier1Progress = 50;
            }
          }
        } else if (effectiveTierCount === 3) {
          if (isMobile) {
            if (cartTotal < freeShippingValue) {
              freeShippingProgressGwp = cartTotal / freeShippingValue * 33;
              tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
            } else {
              freeShippingProgressGwp = 33;
              if (cartTotalForTiers < freeGiftValueTier1) {
                var tier1Range = freeGiftValueTier1 - freeShippingValue;
                var tier1ProgressAmount = cartTotalForTiers - freeShippingValue;
                tier1Progress = tier1ProgressAmount / tier1Range * 33;
                tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
              } else {
                tier1Progress = 33;
                // Only calculate tier 2 progress if tier 1 has been reached
                if (cartTotalForTiers >= freeGiftValueTier1 && cartTotalForTiers < freeGiftValueTier2) {
                  var tier2Range = freeGiftValueTier2 - freeGiftValueTier1;
                  var tier2ProgressAmount = cartTotalForTiers - freeGiftValueTier1;
                  tier2Progress = tier2ProgressAmount / tier2Range * 34;
                } else if (cartTotalForTiers >= freeGiftValueTier2) {
                  tier2Progress = 34;
                } else {
                  tier2Progress = 0; // Tier 1 not reached yet
                }
              }
            }
          } else {
            if (cartTotal < freeShippingValue) {
              freeShippingProgressGwp = cartTotal / freeShippingValue * 50;
              tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
            } else {
              freeShippingProgressGwp = 50;
              if (cartTotalForTiers < freeGiftValueTier1) {
                var tier1Range = freeGiftValueTier1 - freeShippingValue;
                var tier1ProgressAmount = cartTotalForTiers - freeShippingValue;
                tier1Progress = tier1ProgressAmount / tier1Range * 25;
                tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
              } else {
                tier1Progress = 25;
                // Only calculate tier 2 progress if tier 1 has been reached
                if (cartTotalForTiers >= freeGiftValueTier1 && cartTotalForTiers < freeGiftValueTier2) {
                  var tier2Range = freeGiftValueTier2 - freeGiftValueTier1;
                  var tier2ProgressAmount = cartTotalForTiers - freeGiftValueTier1;
                  tier2Progress = tier2ProgressAmount / tier2Range * 25;
                } else if (cartTotalForTiers >= freeGiftValueTier2) {
                  tier2Progress = 25;
                } else {
                  tier2Progress = 0; // Tier 1 not reached yet
                }
              }
            }
          }
        } else if (effectiveTierCount === 4) {
          if (cartTotal >= freeShippingValue) {
            freeShippingProgressGwp = 25;
            if (cartTotalForTiers < freeGiftValueTier1) {
              var tier1Range = freeGiftValueTier1 - freeShippingValue;
              var tier1ProgressAmount = cartTotalForTiers - freeShippingValue;
              tier1Progress = tier1ProgressAmount / tier1Range * 25;
              tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
              tier3Progress = 0; // Tier 3 progress is 0 until tier 2 is reached
            } else {
              tier1Progress = 25;
              // Only calculate tier 2 progress if tier 1 has been reached
              if (cartTotalForTiers >= freeGiftValueTier1 && cartTotalForTiers < freeGiftValueTier2) {
                var tier2Range = freeGiftValueTier2 - freeGiftValueTier1;
                var tier2ProgressAmount = cartTotalForTiers - freeGiftValueTier1;
                tier2Progress = tier2ProgressAmount / tier2Range * 25;
                tier3Progress = 0; // Tier 3 progress is 0 until tier 2 is reached
              } else if (cartTotalForTiers >= freeGiftValueTier2) {
                tier2Progress = 25;
                if (cartTotalForTiers < freeGiftValueTier3) {
                  var tier3Range = freeGiftValueTier3 - freeGiftValueTier2;
                  var tier3ProgressAmount = cartTotalForTiers - freeGiftValueTier2;
                  tier3Progress = tier3ProgressAmount / tier3Range * 25;
                } else {
                  tier3Progress = 25;
                }
              } else {
                tier2Progress = 0; // Tier 1 not reached yet
                tier3Progress = 0;
              }
            }
          }
        }
      } else if (tierCount === 1) {
        if (cartTotalForTiers < freeGiftValueTier1) {
          tier1Progress = cartTotalForTiers / freeGiftValueTier1 * 100;
        } else {
          tier1Progress = 100;
        }
      } else if (tierCount === 2) {
        if (cartTotalForTiers < freeGiftValueTier1) {
          tier1Progress = cartTotalForTiers / freeGiftValueTier1 * 50;
          tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
        } else {
          tier1Progress = 50;
          // Only calculate tier 2 progress if tier 1 has been reached
          if (cartTotalForTiers >= freeGiftValueTier1 && cartTotalForTiers < freeGiftValueTier2) {
            var tier2Range = freeGiftValueTier2 - freeGiftValueTier1;
            var tier2ProgressAmount = cartTotalForTiers - freeGiftValueTier1;
            tier2Progress = tier2ProgressAmount / tier2Range * 50;
          } else if (cartTotalForTiers >= freeGiftValueTier2) {
            tier2Progress = 50;
          } else {
            tier2Progress = 0; // Tier 1 not reached yet
          }
        }
      } else if (tierCount === 3) {
        if (isMobile) {
          if (cartTotalForTiers < freeGiftValueTier1) {
            tier1Progress = cartTotalForTiers / freeGiftValueTier1 * 33;
            tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
            tier3Progress = 0; // Tier 3 progress is 0 until tier 2 is reached
          } else {
            tier1Progress = 33;
            // Only calculate tier 2 progress if tier 1 has been reached
            if (cartTotalForTiers >= freeGiftValueTier1 && cartTotalForTiers < freeGiftValueTier2) {
              var tier2Range = freeGiftValueTier2 - freeGiftValueTier1;
              var tier2ProgressAmount = cartTotalForTiers - freeGiftValueTier1;
              tier2Progress = tier2ProgressAmount / tier2Range * 33;
              tier3Progress = 0; // Tier 3 progress is 0 until tier 2 is reached
            } else if (cartTotalForTiers >= freeGiftValueTier2) {
              tier2Progress = 33;
              if (cartTotalForTiers < freeGiftValueTier3) {
                var tier3Range = freeGiftValueTier3 - freeGiftValueTier2;
                var tier3ProgressAmount = cartTotalForTiers - freeGiftValueTier2;
                tier3Progress = tier3ProgressAmount / tier3Range * 34;
              } else {
                tier3Progress = 34;
              }
            }
          }
        } else {
          if (cartTotalForTiers < freeGiftValueTier1) {
            tier1Progress = cartTotalForTiers / freeGiftValueTier1 * 50;
            tier2Progress = 0; // Tier 2 progress is 0 until tier 1 is reached
            tier3Progress = 0; // Tier 3 progress is 0 until tier 2 is reached
          } else {
            tier1Progress = 50;
            // Only calculate tier 2 progress if tier 1 has been reached
            if (cartTotalForTiers >= freeGiftValueTier1 && cartTotalForTiers < freeGiftValueTier2) {
              var tier2Range = freeGiftValueTier2 - freeGiftValueTier1;
              var tier2ProgressAmount = cartTotalForTiers - freeGiftValueTier1;
              tier2Progress = tier2ProgressAmount / tier2Range * 25;
              tier3Progress = 0; // Tier 3 progress is 0 until tier 2 is reached
            } else if (cartTotalForTiers >= freeGiftValueTier2) {
              tier2Progress = 25;
              if (cartTotalForTiers < freeGiftValueTier3) {
                var tier3Range = freeGiftValueTier3 - freeGiftValueTier2;
                var tier3ProgressAmount = cartTotalForTiers - freeGiftValueTier2;
                tier3Progress = tier3ProgressAmount / tier3Range * 25;
              } else {
                tier3Progress = 25;
              }
            }
          }
        }
      }

      // Update free shipping progress when integrated
      if (integrateFreeShipping) {
        var $freeShippingFill = $gwpContainer.find('.gwp-progress-line-fill-free-shipping');
        if ($freeShippingFill.length) {
          $freeShippingFill.css('width', freeShippingProgressGwp + '%');
        }

        // Update free shipping checkmark 
        var $freeShippingCheck = $gwpContainer.find('.gwp-stage-check-free-shipping');
        if ($freeShippingCheck.length) {
          var freeShippingCheckPosition = freeShippingPosition;
          if (effectiveTierCount === 3) {
            if (isMobile) {
              freeShippingCheckPosition = 33;
            } else {
              freeShippingCheckPosition = 50;
            }
          }
          $freeShippingCheck.css('left', freeShippingCheckPosition + '%');
          var $existingCheckmark = $freeShippingCheck.find('.gwp-checkmark');
          var hasExistingCheckmark = $existingCheckmark.length > 0;
          if (hasExistingCheckmark) {
            $freeShippingCheck.addClass('is-complete');
          } else if (hasFreeShipping) {
            $freeShippingCheck.addClass('is-complete');
            $freeShippingCheck.html(vm.getCheckmarkSvg());
          } else {
            $freeShippingCheck.removeClass('is-complete').empty();
          }
        }
      }

      // Update tier 1 progress
      var $tier1Fill = $gwpContainer.find('.gwp-progress-line-fill-1');
      if ($tier1Fill.length) {
        if (integrateFreeShipping && effectiveTierCount === 3) {
          if (isMobile) {
            $tier1Fill.css({
              'width': tier1Progress + '%',
              'left': '33%'
            });
          } else {
            $tier1Fill.css({
              'width': tier1Progress + '%',
              'left': '50%'
            });
          }
        } else if (integrateFreeShipping) {
          $tier1Fill.css({
            'width': tier1Progress + '%',
            'left': freeShippingPosition + '%'
          });
        } else {
          $tier1Fill.css('width', tier1Progress + '%');
        }
      }

      // Update tier 2 progress - only if tier 1 has been reached
      // Also ensure tier2Progress is 0 if tier 1 hasn't been reached
      if (!hasTier1) {
        tier2Progress = 0;
      }

      // Always update tier 2 fill element - set to 0 if tier 1 not reached
      var $tier2Fill = $gwpContainer.find('.gwp-progress-line-fill-2');
      if ($tier2Fill.length && tierCount >= 2) {
        if (hasTier1 && (tier2Progress > 0 || hasTier2)) {
          if (integrateFreeShipping && effectiveTierCount === 3) {
            if (isMobile) {
              $tier2Fill.css({
                'width': tier2Progress + '%',
                'left': '66%'
              });
            } else {
              $tier2Fill.css({
                'width': tier2Progress + '%',
                'left': '75%'
              });
            }
          } else {
            $tier2Fill.css({
              'width': tier2Progress + '%',
              'left': tier1Position + '%'
            });
          }
        } else {
          // Tier 1 not reached - explicitly set width to 0
          $tier2Fill.css('width', '0%');
        }
      }

      // Update tier 3 progress
      if (tierCount === 3 && (tier3Progress > 0 || hasTier3)) {
        var $tier3Fill = $gwpContainer.find('.gwp-progress-line-fill-3');
        if ($tier3Fill.length) {
          $tier3Fill.css({
            'width': tier3Progress + '%',
            'left': tier2Position + '%'
          });
        }
      }

      // Update tier checkmarks
      var updateTierCheck = function updateTierCheck(tierNum, isComplete, position, isLastTier) {
        var $tierCheck = $gwpContainer.find('.gwp-stage-check-' + tierNum);
        if ($tierCheck.length) {
          if (position > 0) {
            $tierCheck.show();
            if (isLastTier) {
              $tierCheck.css({
                'right': '0',
                'left': 'auto'
              });
            } else {
              $tierCheck.css({
                'left': position + '%',
                'right': 'auto'
              });
            }
            if (isComplete) {
              $tierCheck.addClass('is-complete');
              if (!$tierCheck.find('.gwp-checkmark').length) {
                $tierCheck.html(vm.getCheckmarkSvg());
              }
            } else {
              $tierCheck.removeClass('is-complete').empty();
            }
          } else {
            $tierCheck.removeClass('is-complete').empty().hide();
          }
        }
      };

      // Update checks based on tier count
      if (integrateFreeShipping && effectiveTierCount === 3) {
        updateTierCheck(1, hasTier1, tier1Position, false);
        updateTierCheck(2, hasTier2, tier2Position, true);
        updateTierCheck(3, false, 0, false);
      } else if (tierCount === 1) {
        if (integrateFreeShipping && effectiveTierCount === 2) {
          updateTierCheck(1, hasTier1, tier1Position, true);
        } else {
          updateTierCheck(1, hasTier1, tier1Position, true);
        }
        updateTierCheck(2, false, 0, false);
        updateTierCheck(3, false, 0, false);
      } else if (tierCount === 2) {
        updateTierCheck(1, hasTier1, tier1Position, false);
        updateTierCheck(2, hasTier2, tier2Position, true);
        updateTierCheck(3, false, 0, false);
      } else if (tierCount === 3) {
        updateTierCheck(1, hasTier1, tier1Position, false);
        updateTierCheck(2, hasTier2, tier2Position, false);
        updateTierCheck(3, hasTier3, tier3Position, true);
      }

      // Update GWP message - check highest tier achieved
      var $gwpMessage = $gwpContainer.find('.gwp-message-text');
      var highestTierAchieved = hasTier3 ? 3 : hasTier2 ? 2 : hasTier1 ? 1 : 0;
      var newMessage = '';

      // Helper function to format money
      var formatMoney = function formatMoney(cents) {
        if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents);
        }
        // Fallback to simple format
        var amount = (cents / 100).toFixed(2);
        return '$' + amount.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      };

      // When free shipping is integrated, use cartTotal for message calculation if free shipping not reached
      var cartTotalForMessage = cartTotal;
      if (integrateFreeShipping && cartTotal < freeShippingValue) {
        // Free shipping not reached yet, use actual cart total for message
        cartTotalForMessage = cartTotal;
      } else {
        // Free shipping reached or not integrated, use cartTotalForTiers
        cartTotalForMessage = cartTotalForTiers;
      }
      if (hasTier3) {
        newMessage = gwpSuccessMessage;
      } else if (hasTier2) {
        if (tierCount === 3) {
          var calculateNextTier = freeGiftValueTier3 - cartTotalForMessage;
          var calculateNextTierMoney = formatMoney(calculateNextTier);
          newMessage = tier3ProgressMessage.replace(/#money#/g, calculateNextTierMoney);
        } else {
          newMessage = gwpSuccessMessage;
        }
      } else if (hasTier1) {
        if (tierCount >= 2) {
          var nextTierValue = freeGiftValueTier2;
          var calculateNextTier = nextTierValue - cartTotalForMessage;
          var calculateNextTierMoney = formatMoney(calculateNextTier);
          newMessage = tier2ProgressMessage.replace(/#money#/g, calculateNextTierMoney);
        } else {
          newMessage = gwpSuccessMessage;
        }
      } else {
        // Not reached any tier - show tier 1 progress message or free shipping message
        if (integrateFreeShipping && cartTotal < freeShippingValue) {
          // Free shipping not reached, show free shipping progress message
          var calculateNextTier = freeShippingValue - cartTotal;
          var calculateNextTierMoney = formatMoney(calculateNextTier);
          newMessage = freeShippingProgressMessage.replace(/#money#/g, calculateNextTierMoney);
        } else {
          // Free shipping reached or not integrated, show amount needed for tier 1
          var calculateNextTier = freeGiftValueTier1 - cartTotalForMessage;
          var calculateNextTierMoney = formatMoney(calculateNextTier);
          newMessage = tier1ProgressMessage.replace(/#money#/g, calculateNextTierMoney);
        }
      }
      if (newMessage) {
        $gwpMessage.text(newMessage);
      }
      if (highestTierAchieved === tierCount || highestTierAchieved > 0) {
        $gwpMessage.addClass('is-complete');
      } else {
        $gwpMessage.removeClass('is-complete');
      }
    }

    // Update cart total data attribute
    $gwpContainer.attr('data-cart-total', cartTotal);
  },
  /**
   * Update stage icon to show completed state
   */
  updateStageIcon: function updateStageIcon($icon, isComplete) {
    if (!$icon.length) {
      return;
    }
    var iconHtml = isComplete ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="#ae7857" stroke-width="2" fill="none"/><path d="M6 10l3 3 5-5" stroke="#ae7857" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="#999" stroke-width="2" fill="none"/></svg>';
    $icon.html(iconHtml);
  }
};
var _gwpAutoAdd = gwpAutoAdd;


/***/ }),

/***/ "./src/js/er-custom/main.js":
/*!**********************************!*\
  !*** ./src/js/er-custom/main.js ***!
  \**********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slick-carousel/slick/slick.min */ "./node_modules/slick-carousel/slick/slick.min.js");
/* harmony import */ var slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _er_js_load__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./er-js-load */ "./src/js/er-custom/er-js-load.js");
/* harmony import */ var _er_lockscroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./er-lockscroll */ "./src/js/er-custom/er-lockscroll.js");




var main = {};
var win = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window);
var doc = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document);
main = {
  defaults: {
    lastScrollTop: 0,
    scrollLock: _er_lockscroll__WEBPACK_IMPORTED_MODULE_3__
  },
  onInit: function onInit() {
    var vm = this;
    vm.mobileMenuNavToggle();
    vm.selectChangeSize();
    vm.selectChangeColor();
    vm.amplifySliderInit();
    vm.additionalContentToggle();
    vm.setStatistics();
  },
  onReady: function onReady(e) {
    var vm = this;
    vm.onInit();
    vm.onResize(); // call resize on ready to trigger initial resize functions on load. Not necessary all the time.

    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].searchBar.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].carousel.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].product.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].cartDrawer.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].quantityInput.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].erModal.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].erAccordion.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].featprod_addajax.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].cartajax.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].video_popup.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].review_slider.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].megamenu.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].postFilter.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].redirectLogin.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].trackorder.onInit();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].gwpAutoAdd.onInit();
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('#hidefaq-section').length > 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('#productFAQ').hide();
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tbn_deal_coin_ui_container img').attr('alt', 'image');
  },
  onLoad: function onLoad(e) {
    var vm = this;
    vm.onResize();
  },
  onResize: function onResize(e) {
    var vm = this;
    vm.onResizeProductGallery();
  },
  onScroll: function onScroll(e) {
    var vm = this;
    var st = win.scrollTop();
    _er_js_load__WEBPACK_IMPORTED_MODULE_2__["erModule"].erModal.onInit();
    if (st > vm.defaults.lastScrollTop) {
      // scroll down
    } else {
      // scroll up
    }
    if (st > 50) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('#headerSection').addClass('header-scrolled header-colored');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').addClass('sticky-nav-enabled');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.header-navigation.parent>li').removeClass('megamenu-active');
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('#headerSection').removeClass('header-scrolled header-colored');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').removeClass('sticky-nav-enabled');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.header-navigation.parent>li').removeClass('megamenu-active');
    }
    vm.defaults.lastScrollTop = st;
  },
  mobileMenuNavToggle: function mobileMenuNavToggle() {
    var vm = this;
    var el = vm.defaults;
    var scrollLock = el.scrollLock.scrollLockJs;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.menu-hamburger').on('click', function () {
      scrollLock.lockScroll();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').toggleClass('menu-active');
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').hasClass('menu-active')) {
        console.log('lock');
      } else {
        scrollLock.unlockScroll();
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mobile-cart .cart-toggle').on('click', function (e) {
      scrollLock.lockScroll();
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').hasClass('slide-cart')) {} else {
        scrollLock.unlockScroll();
      }
    });
  },
  getHeaderHeight: function getHeaderHeight() {
    return jquery__WEBPACK_IMPORTED_MODULE_0___default()('header[role="banner"]').outerHeight();
  },
  selectChangeSize: function selectChangeSize() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()("#width_tmp_option").html(jquery__WEBPACK_IMPORTED_MODULE_0___default()('#sort-by option:selected').text());
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#sort-by').width(jquery__WEBPACK_IMPORTED_MODULE_0___default()("#width_tmp_select").width() + 17);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#sort-by').change(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()("#width_tmp_option").html(jquery__WEBPACK_IMPORTED_MODULE_0___default()('#sort-by option:selected').text());
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).width(jquery__WEBPACK_IMPORTED_MODULE_0___default()("#width_tmp_select").width());
    });
  },
  selectChangeColor: function selectChangeColor() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('select').on('change', function () {
      if (this.selectedIndex > 0) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('changed-dark');
        setTimeout(function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON('/cart.js', function (cart) {
            var result = cart.item_count;
            //var getQtyCartLimit = $('.add-to-cart-text').data('qtycartlimit');
            var getQtyCartLimit = localStorage.getItem("max_variant_cart");
            if (getQtyCartLimit != null) {
              //when SKU Limit 5 is ON
              if (result < getQtyCartLimit) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()('.subscribe-cart-btn').removeAttr('disabled');
                //$('.product-form .input-quantity').val(setDefaultQuant);
              } else {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()('.subscribe-cart-btn').attr("disabled", true);
              }
            } else {
              //when SKU Limit 5 is off
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('.subscribe-cart-btn').removeAttr('disabled');
            }
          });
        }, 600);
      } else {
        //when SKU Limit 5 is off
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('changed-dark');
        jquery__WEBPACK_IMPORTED_MODULE_0___default()('.subscribe-cart-btn').addClass("disabled");
        jquery__WEBPACK_IMPORTED_MODULE_0___default()('.subscribe-cart-btn').prop("disabled", true);
      }
    });
  },
  setStatistics: function setStatistics() {
    // Sets the statistics circle animation
    var items = document.querySelectorAll('.c-statistics__item');
    var animateCircle = function animateCircle(item, percent) {
      var fgs = item.querySelectorAll('.fg');
      var radius = 66;
      var circumference = 2 * Math.PI * radius;
      fgs.forEach(function (fg) {
        fg.style.transition = 'all 1.25s ease-out';
        //fg.style.strokeDasharray = `${circumference}`;
        //fg.style.strokeDashoffset = `${circumference}`; // Start from empty (12 o'clock)

        // Force style reflow before animation
        void fg.offsetWidth;

        // Animate clockwise
        fg.style.strokeDashoffset = "".concat(circumference * (1 - percent / 100));
        fg.classList.add('is-visible');
      });
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var percent = parseFloat(entry.target.dataset.percent);
          animateCircle(entry.target, percent);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.6
    });
    items.forEach(function (item) {
      return observer.observe(item);
    });
  },
  amplifySliderInit: function amplifySliderInit() {
    var slider = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.aplify-with-row');
    if (slider[0] && slider[0].childElementCount > 2) {
      slider.slick({
        arrows: false,
        dots: false,
        slidesToScroll: 3,
        slidesToShow: 3,
        infinite: false,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    }
  },
  additionalContentToggle: function additionalContentToggle() {
    var innerContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.additional-content-wrapper .inner-container');
    var toggle = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.toggle-content');
    var openLabel = innerContent.data('open-label') !== "" ? innerContent.data('open-label') : 'Read More';
    var closeLabel = innerContent.data('close-label') !== "" ? innerContent.data('close-label') : 'Read Less';
    console.log('openLabel', openLabel);
    console.log('closeLabel', closeLabel);
    toggle.on('click', function (e) {
      e.preventDefault();
      var text = innerContent.is(':visible') ? openLabel : closeLabel;
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text(text);
      innerContent.slideToggle();
    });
  },
  onResizeProductGallery: function onResizeProductGallery() {
    var imageHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-wrapper').height();
    var thumbnails = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-carousel-nav');
    thumbnails.css('height', "".concat(imageHeight, "px"));
  }
};
doc.ready(function () {
  main.onReady();
  getCurrentFlag('.right-navigation .store-option');
  getCurrentFlag('.mobile-store-option .store-option');
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.right-navigation .store-option').on('change', function (e) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.right-navigation .store-option').parent().find('img').hide();
    getCurrentFlag('.right-navigation .store-option');
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mobile-store-option .store-option').on('change', function (e) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mobile-store-option .store-option').parent().find('img').hide();
    getCurrentFlag('.mobile-store-option .store-option');
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.product-accordion .accordion-header, .product-accordion-amplify .accordion-header', function () {
    console.log('asd');
    var pane = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('html,body').animate({
        scrollTop: pane.offset().top - 90
      }, 500);
    }, 400);
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.slide-cart .page-darkoverlay', function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('slide-cart');
  });
  if (window.outerWidth < 767) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".mobile-menu-nav .grandchild li a").on('click', function (e) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('href').split('#')[1] != null) {
        var aboutLink = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('href');
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('href').split('#')[1] == 'my-story') {
          e.preventDefault();
          aboutLink = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('href').split('#')[0];
          location.replace(aboutLink);
          return false;
        }
        location.replace(aboutLink);
      }
      window.location.reload(e.target.attr('href'));
      return false;
    });

    // $('html, body').animate({
    //   scrollTop: $(location.hash).offset().top - 10
    // }, 'fast');
    // return false;
  }
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '.faq-sidebar .floating-sidebar a', function (e) {
    e.preventDefault();
    var hash = this.hash;
    console.log(hash);
    var position = jquery__WEBPACK_IMPORTED_MODULE_0___default()(hash).offset().top - 70;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('html,body').animate({
      scrollTop: position
    }, 1);
    return false;
  });

  // $(document).on('mouseleave', '.cart-drawer', function() {
  //   if($('body').hasClass('mouseEnterCart')) {
  //     $('body').removeClass('mouseEnterCart')
  //     setTimeout(function() {
  //       $('body').removeClass('slide-cart')
  //       $('.cart-drawer').removeClass('success-add')
  //     }, 1000)
  //   }
  // })
});
function equalheight(container) {
  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el;
  var currentDiv = 0;
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).each(function () {
    $el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    $el.height('auto');
    var topPosition = $el.position().top;
    if (currentRowStart != topPosition) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}
function getCurrentFlag(menu_container) {
  var storeOption = jquery__WEBPACK_IMPORTED_MODULE_0___default()(menu_container);
  var selectedRegion = storeOption.find(":selected");
  var selectedRegionText = selectedRegion.data('title');
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(menu_container).parent().find("[data-region=".concat(selectedRegionText, "]")).show();
}
win.on('load', function () {
  main.onLoad();
  // equalheight(' .collection-list-row > .collection-grid > .product-card > .product-details > .col-md-3');
  // equalheight(' .collection-list-row > .collection-grid > .product-card > .product-details > .col-md-9');
  // equalheight(' .collection-list-row > .collection-grid > .product-card > .product-details');
  setTimeout(function () {
    hideCurr();
  }, 1000), setTimeout(function () {
    hideCurr();
  }, 1500), setTimeout(function () {
    hideCurr();
  }, 2000), setTimeout(function () {
    hideCurr();
  }, 2500), setTimeout(function () {
    hideCurr();
  }, 3000), setTimeout(function () {
    hideCurr();
  }, 4000), setTimeout(function () {
    hideCurr();
  }, 5000), setTimeout(function () {
    hideCurr();
  }, 6000), setTimeout(function () {
    hideCurr();
  }, 7000);
});
win.resize(function () {
  main.onResize();
  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mobile-filters').length > 0) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mob-filter-inner').each(function () {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() == 0) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css({
          'height': '100%'
        });
      } else {
        return;
      }
    });
  }
  if (window.innerWidth < 766) {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.prod-right-section').length > 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-accordion-amplify.open').each(function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css({
          'height': jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('.accordion-content').height() + 75
        });
      });
    }
  }
  resizeEqualHeight('.blog-post .slick-track .blog-post__item', 0);
  resizeEqualHeight('.related_article_slider .slick-track .slick-slide', 0);
  equalheight(' .collection-list-row > .collection-grid > .product-card > .product-details > .col-md-3');
  equalheight(' .collection-list-row > .collection-grid > .product-card > .product-details > .col-md-9');
  equalheight(' .collection-list-row > .collection-grid > .product-card > .product-details');
});
function resizeEqualHeight(container, padding) {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).height('auto');
  var highestBox = 0;
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).each(function () {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() > highestBox) {
      highestBox = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height();
    }
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).css({
    'height': highestBox + padding
  });
}
win.scroll(function () {
  main.onScroll();
});
function hideCurr() {
  var buyOnceP = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".rc_widget__price--onetime").text();
  var subSaveP = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".rc_widget__price--subsave").text();
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(".rc_widget__price--onetime").text(buyOnceP.replace('US', ''));
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(".rc_widget__price--subsave").text(subSaveP.replace('US', ''));
  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ghost-loading__banner').length > 0) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ghost-loading__banner').hide(100);
  }
}
jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).ready(function () {
  function hideSubNone() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".sub-none-hide .rc-container-wrapper").css("display", "none");
  }
  setInterval(hideSubNone, 500);
});

// new nav script
jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).ready(function () {
  appendMegaMenu();
  megaMenuPosition();
  megaMenuHover();
  checkHeightChange();
  var lastHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()("#headerSection").height();
  function checkHeightChange() {
    var newHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()("#headerSection").height();
    if (lastHeight != newHeight) {
      console.log("The element was resized" + newHeight);
      // assign the new dimensions
      lastHeight = newHeight;
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slide-out .tier-two--wrap').each(function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('top', lastHeight);
      });
    }
  }
  setInterval(checkHeightChange, 500);
});
jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).resize(function () {
  megaMenuPosition();
});
jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scroll(function () {
  megaMenuPosition();
});
function appendMegaMenu() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.nesting-two-wrap').each(function () {
    var megaMenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).html();
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mega-menu .col-two').append(megaMenu);
  });
}
function megaMenuPosition() {
  var position = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#top-header-navigation').outerHeight();
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.header-navigation .mega-menu').each(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('top', position);
  });
}
function megaMenuHover() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.parent.header-navigation > li').mouseenter(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mega-menu').each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('active-mega-menu');
    });
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('.mega-menu').addClass('active-mega-menu');
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('header').mouseleave(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mega-menu').each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('active-mega-menu');
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('.active-submenu').removeClass('active-submenu');
    });
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.nesting-one > .has-child').mouseenter(function () {
    var target = '#' + jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('target-submenu');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.col-two').find('.active-submenu').removeClass('active-submenu');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.col-two').find(target).addClass('active-submenu');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('.mega-menu').attr('data-target', target);
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.nesting-one > li:not(.has-child)').mouseenter(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.col-two').find('.active-submenu').removeClass('active-submenu');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('.mega-menu').attr('data-target', '');
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mega-menu').mouseleave(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.col-two').find('.active-submenu').removeClass('active-submenu');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('.mega-menu').attr('data-target', '');
  });
  var activeMenu = [];
  function initMenuslider($tierTwo) {
    var $menuslider = $tierTwo.find('.menuslider .mega_menu_images');
    if (!$menuslider.length || typeof jquery__WEBPACK_IMPORTED_MODULE_0___default.a.fn.slick === 'undefined') {
      return;
    }
    var $slides = $menuslider.find('.mega-menu-image');
    if ($slides.length <= 1) {
      return;
    }
    if (!$menuslider.hasClass('slick-initialized')) {
      setTimeout(function () {
        $menuslider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true,
          arrows: false,
          dots: false,
          swipe: true,
          speed: 300
        });
      }, 100);
    }
  }
  function getMenuKey($link) {
    var classAttr = $link.attr('class') || '';
    return classAttr.split(' ')[0];
  }
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mobile-menu-nav .tier-one > li.has-child > a').click(function (e) {
    e.preventDefault();
    var $parent = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.has-child');
    var menuKey = getMenuKey(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
    var isOpening = !$parent.hasClass('active-drop');
    var $openSiblings = $parent.siblings('.has-child.active-drop');
    $openSiblings.removeClass('active-drop').children('.tier-two').stop(true, true).slideUp(250);
    $openSiblings.each(function () {
      var siblingKey = getMenuKey(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).children('a'));
      var idx = activeMenu.indexOf(siblingKey);
      if (idx !== -1) {
        activeMenu.splice(idx, 1);
      }
    });
    if (isOpening) {
      $parent.addClass('active-drop');
      var $tierTwo = $parent.children('.tier-two');
      $tierTwo.stop(true, true).slideDown(250, function () {
        initMenuslider($tierTwo);
        setTimeout(function () {
          var newHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()("#headerSection").height();
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slide-out .tier-two--wrap').each(function () {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('top', newHeight);
          });
        }, 100);
      });
      activeMenu = [menuKey];
    } else {
      $parent.removeClass('active-drop');
      var $tierTwo = $parent.children('.tier-two');
      $tierTwo.stop(true, true).slideUp(250);
      activeMenu = [];
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.mobile-menu--inner').attr('data-menu', activeMenu.toString());
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tier-two > .accordion.has-child > a ').click(function (e) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.has-child').toggleClass('active-drop');
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.has-child').hasClass('active-drop')) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings('.tier-two--wrap').slideDown();
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings('.tier-two--wrap').slideUp();
    }
    e.preventDefault();
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tier-two > .slide-out.has-child > a ').click(function (e) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.has-child').addClass('active-slide');
    e.preventDefault();
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tier-two--wrap .back--btn').click(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('.active-slide').removeClass('active-slide');
  });
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.menu-hamburger').click(function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tier-two .slide-out').removeClass('active-slide');
  });
}

// Footer subscribe popup
doc.ready(function () {
  footerSubscribe();
});
function footerSubscribe() {
  window._klOnsite = window._klOnsite || [];
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-btn-footer-subscribe').on('click', function (e) {
    e.preventDefault();
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() > 767) {
      window._klOnsite.push(['openForm', 'U9YH6Q']);
    } else {
      window._klOnsite.push(['openForm', 'RJxLXJ']);
    }
  });
}

/***/ }),

/***/ "./src/js/er-custom/megamenu.js":
/*!**************************************!*\
  !*** ./src/js/er-custom/megamenu.js ***!
  \**************************************/
/*! exports provided: megamenu */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "megamenu", function() { return _megamenu; });
var megamenu = {};
megamenu = {
  defaults: {
    searchBarContainer: $('.header-search')
  },
  onInit: function onInit(e) {
    var vm = this;
    vm.megamenuHover();
    vm.mobilemenuFunc();
    vm.emptyNochildLinks();
    vm.ipadMenuDoubleTap();
  },
  megamenuHover: function megamenuHover() {
    $('.header-menu-wrapper ul li a').hover(function () {
      $(this).parent().siblings('li').removeClass('megamenu-active');
      $(this).parent().siblings('li').removeClass('childmenu-active');
      if ($(this).siblings('.mega-menu-wrapper').length > 0) {
        $(this).parent().addClass('megamenu-active');
        $('#headerSection').addClass('header-colored');
      }
      if ($(this).siblings('.child').length > 0) {
        $(this).parent().addClass('childmenu-active');
      }
    });
    $('.header-menu-wrapper ul li .mega-menu-wrapper').hover(function () {}, function () {
      $(this).closest('li.megamenu-active').removeClass('megamenu-active');
      $('#headerSection').removeClass('header-colored');
    });
    $('.header-menu-wrapper ul li > .child').hover(function () {}, function () {
      $(this).closest('li.childmenu-active').removeClass('childmenu-active');
    });
  },
  mobilemenuFunc: function mobilemenuFunc() {
    var childtrigger = $('.mobile-parent .has-child:not(.blog-has-child) > a, .mobile-parent .blog-has-child > a > .plus ');
    $(childtrigger).click(function (e) {
      e.preventDefault();
      var thisparent = $(this);
      if ($(this).hasClass('plus')) {
        thisparent = $(this).parent();
      }
      var mobileParent = $('.mobile-parent');
      if (thisparent.hasClass('menu-active')) {
        thisparent.removeClass('menu-active');
        thisparent.removeClass('show-children-menu');
        mobileParent.removeClass('show-child-menu');
        $('.mobile-menu-footer').removeClass('enable-back');
      } else {
        thisparent.addClass('menu-active');
        thisparent.addClass('show-children-menu');
        mobileParent.addClass('show-child-menu');
        $('.mobile-menu-footer').addClass('enable-back');
      }
    });
    var backtoparent = $('.back-to-parent');
    $(backtoparent).click(function (e) {
      e.preventDefault();
      var mobileParent = $('.mobile-parent');
      mobileParent.removeClass('show-child-menu');
      $('.mobile-nav-menu .mobile-parent > li > a').removeClass('show-children-menu');
      $('.mobile-nav-menu .mobile-parent > li > a').removeClass('menu-active');
      $('.mobile-menu-footer').removeClass('enable-back');
    });
    var grandChild = $('.child .has-grandchildren > a');
    $(grandChild).click(function (e) {
      e.preventDefault();
      var grandChildren = $(this).next('.grandchild');
      var childHolder = $('.first-child-links');
      if (grandChildren.hasClass('show-grand')) {
        $(this).removeClass('menu-active');
        grandChildren.removeClass('show-grand');
        childHolder.removeClass('grandchild-active');
      } else {
        $('.child .has-grandchildren > a').removeClass('menu-active');
        $('.child .has-grandchildren > ul').removeClass('show-grand');
        $(this).addClass('menu-active');
        grandChildren.addClass('show-grand');
        childHolder.addClass('grandchild-active');
      }
    });
  },
  emptyNochildLinks: function emptyNochildLinks() {
    $(".no-childlinks").each(function () {
      var textwithin = $(this).text().trim().length;
      if (textwithin == 0) {
        $(this).remove();
      }
    });
  },
  ipadMenuDoubleTap: function ipadMenuDoubleTap() {
    var ctr = 0;
    $('.header-navigation.parent>li a.has-dropdown').click(function (e) {
      if ($(window).width() < 1100) {
        e.preventDefault();
        ctr++;
        var golocation = $(this).attr('href');
        if (ctr > 1) {
          location.replace(golocation);
        }
      }
    });
  }
};
var _megamenu = megamenu;


/***/ }),

/***/ "./src/js/er-custom/octane-ai-quiz.js":
/*!********************************************!*\
  !*** ./src/js/er-custom/octane-ai-quiz.js ***!
  \********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function updateCart() {
  return _updateCart.apply(this, arguments);
}
function _updateCart() {
  _updateCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          Shopify.getCart(function (cart) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.cart-item-count').text(cart.item_count);
          });
          jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
            method: 'GET',
            url: location.href,
            async: true,
            dataType: 'html',
            success: function success(data) {
              var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(data).find("#site-slidecart-inner");
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('#site-slide-cart-drawer').html(cart_slide);
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('empty-cart');
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('slide-cart');
            }
          });
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _updateCart.apply(this, arguments);
}
document.addEventListener('octane.quiz.addToCart', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return updateCart();
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), false);

/***/ }),

/***/ "./src/js/er-custom/post-filter.js":
/*!*****************************************!*\
  !*** ./src/js/er-custom/post-filter.js ***!
  \*****************************************/
/*! exports provided: postFilter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postFilter", function() { return _postFilter; });
/* harmony import */ var _er_lockscroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./er-lockscroll */ "./src/js/er-custom/er-lockscroll.js");

var postFilter = {};
postFilter = {
  defaults: {},
  onInit: function onInit(e) {
    var vm = this;
    vm.mobileFilter();
    vm.applyFilter();
    vm.desktopFilter();
    vm.blogPostaltered();
  },
  mobileFilter: function mobileFilter() {
    $(document).on('click', '.mob-filter-dropdown .filter-options', function () {
      var scrollLock = _er_lockscroll__WEBPACK_IMPORTED_MODULE_0__;
      if ($(this).parent().parent().hasClass('open')) {
        $(this).parent().parent().removeClass('open');
        $(this).parent().parent().siblings('.filter-mobile-slide').removeClass('filterPopup');
        //$('.mobile-filters').removeClass('openfilters');
        $('body').removeClass('overflow-hidden');
        scrollLock.unlockScroll();
      } else {
        $(this).parent().parent().addClass('open');
        $(this).parent().parent().siblings('.filter-mobile-slide').addClass('filterPopup');
        //$('.mobile-filters').addClass('openfilters');
        $('body').addClass('overflow-hidden');
        scrollLock.lockScroll();
      }
    });
    $(document).on('click', '.mobile-filters .close', function () {
      $('.mob-filter-dropdown .filter-options').trigger('click');
    });
  },
  applyFilter: function applyFilter() {
    $(document).on('click', '.applyfilter-btn', function (e) {
      e.preventDefault();
      var category = $('input[name=col_category]:checked').val();
      if (category != null) {
        location.replace(category);
      } else {
        var str = window.location.pathname;
        var result = str.split("/");
        if (result[1] == 'collections') {
          location.replace('/collections/shop-all');
        }
        if (result[1] == 'blogs') {
          location.replace('/blogs/blog/');
        }
      }
    });
    var category = $('input[name=col_category]:checked').val();
    var category_label = $('input[name=col_category]:checked').parent().text();
    if (category != null) {
      $('.selected-filters').append('<div class="selected-fil"><span class="removethis-filter remove-category-filter"></span> ' + category_label + '</div>');
    }
    $(document).on('click', '.remove-category-filter', function (e) {
      $('input[name=col_category]').prop('checked', false);
      $('.applyfilter-btn').trigger('click');
    });
  },
  desktopFilter: function desktopFilter() {
    $(document).mouseup(function (e) {
      var container = $(".filter-d-wrapper .accordion-group");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        container.find('.accordion-content').hide();
      }
    });
  },
  blogPostaltered: function blogPostaltered() {
    $('#s-4cd8b021-b123-4d99-a2e4-4b4594f35f13').insertBefore('#s-df864be6-7650-40d2-aa87-0779d9249781');
  }
};
var _postFilter = postFilter;


/***/ }),

/***/ "./src/js/er-custom/predictive-search.js":
/*!***********************************************!*\
  !*** ./src/js/er-custom/predictive-search.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function debounce(fn, wait) {
  var _this = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}
var SearchForm = /*#__PURE__*/function (_HTMLElement) {
  function SearchForm() {
    var _this2;
    _classCallCheck(this, SearchForm);
    _this2 = _callSuper(this, SearchForm);
    _this2.input = _this2.querySelector('input[type="search"]');
    //this.resetButton = this.querySelector('button[type="reset"]');

    if (_this2.input) {
      _this2.input.form.addEventListener('reset', _this2.onFormReset.bind(_this2));
      _this2.input.addEventListener('input', debounce(function (event) {
        _this2.onChange(event);
      }, 300).bind(_this2));
    }
    return _this2;
  }
  _inherits(SearchForm, _HTMLElement);
  return _createClass(SearchForm, [{
    key: "toggleResetButton",
    value: function toggleResetButton() {
      var resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      //this.toggleResetButton();
    }
  }, {
    key: "shouldResetForm",
    value: function shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }
  }, {
    key: "onFormReset",
    value: function onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('search-form', SearchForm);
var PredictiveSearch = /*#__PURE__*/function (_SearchForm) {
  function PredictiveSearch() {
    var _this3;
    _classCallCheck(this, PredictiveSearch);
    _this3 = _callSuper(this, PredictiveSearch);
    _this3.cachedResults = {};
    _this3.predictiveSearchResults = _this3.querySelector('[data-predictive-search]');
    _this3.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    _this3.isOpen = false;
    _this3.abortController = new AbortController();
    _this3.searchTerm = '';
    _this3.setupEventListeners();
    return _this3;
  }
  _inherits(PredictiveSearch, _SearchForm);
  return _createClass(PredictiveSearch, [{
    key: "setupEventListeners",
    value: function setupEventListeners() {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }
  }, {
    key: "attachCurrentEvents",
    value: function attachCurrentEvents() {
      var _this4 = this;
      this.main = this.querySelector('[data-predictive-search-main]');
      this.tabsMenus = this.querySelectorAll('[data-predictive-search-tab-menu]');
      this.tabsMenus.forEach(function (menu) {
        menu.addEventListener('click', _this4.onTabClick.bind(_this4));
      });
    }
  }, {
    key: "onTabClick",
    value: function onTabClick(event) {
      var _this$main$classList;
      (_this$main$classList = this.main.classList).remove.apply(_this$main$classList, _toConsumableArray(this.main.classList));
      var currentTab = event.currentTarget.getAttribute('data-predictive-search-tab-menu');
      this.main.classList.add("is-tab-".concat(currentTab));
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return this.input.value.trim();
    }
  }, {
    key: "onChange",
    value: function onChange() {
      _superPropGet(PredictiveSearch, "onChange", this, 3)([]);
      var newSearchTerm = this.getQuery();
      if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
        var _this$querySelector;
        // Remove the results when they are no longer relevant for the new search term
        // so they don't show up when the dropdown opens again
        (_this$querySelector = this.querySelector('#predictive-search-results-groups-wrapper')) === null || _this$querySelector === void 0 || _this$querySelector.remove();
      }

      // Update the term asap, don't wait for the predictive search query to finish loading
      this.updateSearchForTerm(this.searchTerm, newSearchTerm);
      this.searchTerm = newSearchTerm;
      if (!this.searchTerm.length) {
        this.close(true);
        return;
      }
      this.getSearchResults(this.searchTerm);
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
  }, {
    key: "onFormReset",
    value: function onFormReset(event) {
      _superPropGet(PredictiveSearch, "onFormReset", this, 3)([event]);
      if (_superPropGet(PredictiveSearch, "shouldResetForm", this, 3)([])) {
        this.searchTerm = '';
        this.abortController.abort();
        this.abortController = new AbortController();
        this.closeResults(true);
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var currentSearchTerm = this.getQuery();
      if (!currentSearchTerm.length) return;
      if (this.searchTerm !== currentSearchTerm) {
        // Search term was changed from other search input, treat it as a user change
        this.onChange();
      } else if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut() {
      var _this5 = this;
      setTimeout(function () {
        if (!_this5.contains(document.activeElement)) _this5.close();
      });
    }
  }, {
    key: "onKeyup",
    value: function onKeyup(event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();
      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      // Prevent the cursor from moving in the input when using the up and down arrow keys
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
      }
    }
  }, {
    key: "updateSearchForTerm",
    value: function updateSearchForTerm(previousTerm, newTerm) {
      var searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
      var currentButtonText = searchForTextElement === null || searchForTextElement === void 0 ? void 0 : searchForTextElement.innerText;
      if (currentButtonText) {
        if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
          // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
          return;
        }
        var newButtonText = currentButtonText.replace(previousTerm, newTerm);
        searchForTextElement.innerText = newButtonText;
      }
    }
  }, {
    key: "switchOption",
    value: function switchOption(direction) {
      if (!this.getAttribute('open')) return;
      var moveUp = direction === 'up';
      var selectedElement = this.querySelector('[aria-selected="true"]');

      // Filter out hidden elements (duplicated page and article resources) thanks
      // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
      var allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(function (element) {
        return element.offsetParent !== null;
      });
      var activeElementIndex = 0;
      if (moveUp && !selectedElement) return;
      var selectedElementIndex = -1;
      var i = 0;
      while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
        if (allVisibleElements[i] === selectedElement) {
          selectedElementIndex = i;
        }
        i++;
      }
      this.statusElement.textContent = '';
      if (!moveUp && selectedElement) {
        activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
      } else if (moveUp) {
        activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
      }
      if (activeElementIndex === selectedElementIndex) return;
      var activeElement = allVisibleElements[activeElementIndex];
      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }
  }, {
    key: "selectOption",
    value: function selectOption() {
      var selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (selectedOption) selectedOption.click();
    }
  }, {
    key: "getSearchResults",
    value: function getSearchResults(searchTerm) {
      var _this6 = this;
      var queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }
      fetch("".concat(routes.predictive_search_url, "?q=").concat(encodeURIComponent(searchTerm), "&section_id=predictive-search&resources[type]=query,product,article&resources[limit]=4&resources[limit_scope]=each"), {
        signal: this.abortController.signal
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error(response.status);
          _this6.close();
          throw error;
        }
        return response.text();
      }).then(function (text) {
        var resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        _this6.allPredictiveSearchInstances.forEach(function (predictiveSearchInstance) {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        _this6.renderSearchResults(resultsMarkup);
      })["catch"](function (error) {
        if ((error === null || error === void 0 ? void 0 : error.code) === 20) {
          // Code 20 means the call was aborted
          return;
        }
        _this6.close();
        throw error;
      });
    }
  }, {
    key: "setLiveRegionLoadingState",
    value: function setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }
  }, {
    key: "setLiveRegionText",
    value: function setLiveRegionText(statusText) {
      var _this7 = this;
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;
      setTimeout(function () {
        _this7.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  }, {
    key: "renderSearchResults",
    value: function renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.setLiveRegionResults();
      this.open();
      this.attachCurrentEvents();

      // reinitiate yotpo for reviews
      yotpo.initWidgets({
        selector: '#predictive-search-results'
      });
    }
  }, {
    key: "setLiveRegionResults",
    value: function setLiveRegionResults() {
      this.removeAttribute('loading');
      this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
  }, {
    key: "getResultsMaxHeight",
    value: function getResultsMaxHeight() {
      var _document$querySelect;
      this.resultsMaxHeight = window.innerHeight - ((_document$querySelect = document.querySelector('.section-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().bottom);
      return this.resultsMaxHeight;
    }
  }, {
    key: "open",
    value: function open() {
      this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || "".concat(this.getResultsMaxHeight(), "px");
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }
  }, {
    key: "close",
    value: function close() {
      var clearSearchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
    }
  }, {
    key: "closeResults",
    value: function closeResults() {
      var clearSearchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }
      var selected = this.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('loading');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      this.predictiveSearchResults.removeAttribute('style');
    }
  }]);
}(SearchForm);
customElements.define('predictive-search', PredictiveSearch);

/***/ }),

/***/ "./src/js/er-custom/product.js":
/*!*************************************!*\
  !*** ./src/js/er-custom/product.js ***!
  \*************************************/
/*! exports provided: product */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "product", function() { return _product; });
/* harmony import */ var _er_cart_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./er-cart-drawer */ "./src/js/er-custom/er-cart-drawer.js");
/* harmony import */ var _update_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./update-cart */ "./src/js/er-custom/update-cart.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! slick-carousel/slick/slick.min */ "./node_modules/slick-carousel/slick/slick.min.js");
/* harmony import */ var slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_3__);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




var CLASS_ZOOMED = "is-zoomed";
var MIN_DRAG_DELTA = 20;
var DEBOUNCE_COOLDOWN = 500;
var SELECTOR_ZOOM = '[data-zoom-wrap]';
var product = {};
product = {
  defaults: {
    selectedOptions: '',
    cartdrawerjs: _er_cart_drawer__WEBPACK_IMPORTED_MODULE_0__,
    productObj: productJson ? productJson : '',
    productCarousel: jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-carousel-wrapper'),
    form: jquery__WEBPACK_IMPORTED_MODULE_2___default()('form[action="/cart/add"]'),
    formVariantOptions: jquery__WEBPACK_IMPORTED_MODULE_2___default()('.js.select-options'),
    formQuantity: jquery__WEBPACK_IMPORTED_MODULE_2___default()('.shopify-product-form .quantity-wrapper .input-quantity'),
    formAddtoCartBtn: jquery__WEBPACK_IMPORTED_MODULE_2___default()('form[action="/cart/add"] button'),
    selectedVariant: 0,
    updateCart: _update_cart__WEBPACK_IMPORTED_MODULE_1__,
    isDragging: false,
    dragOriginX: 0,
    dragOriginY: 0,
    dragDx: 0,
    dragDy: 0,
    offsetStartX: 0,
    offsetStartY: 0,
    onDebounceCooldown: false
  },
  onInit: function onInit(e) {
    var vm = this;
    var el = vm.defaults;
    vm.onVariantChange();
    vm.getSelectedVariant(el.form);
    vm.changeTabPane();
    vm.btnAddClick();
    vm.warningScroll();
    vm.quickAddVariantSelector();
    vm.productPaymentOptions();
    // vm.onChangeQuantity();
    vm.subscriptionProduct();
    vm.rechargeRemoveAfterpay();
    if (jquery__WEBPACK_IMPORTED_MODULE_2___default()('.glowing-template--ingredients').length) {
      vm.ingredientDrawer();
    }
    vm.upsellAddToCart();
    vm.initializeReviewsCarousel();
    vm.handleVariantSwatches();
    vm.initializeZoom();
    vm.stickyProductATC();
    vm.insertSubSaveDetails();
    vm.initRechargeProductPricing();
    setTimeout(function () {
      var rcInterval = setInterval(function () {
        if (window.ReChargeWidget && jquery__WEBPACK_IMPORTED_MODULE_2___default()('[data-radio-onetime]').is(':checked')) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('[data-label-onetime]').trigger('click');
          clearInterval(rcInterval);
        }
      }, 300);
    }, 2000);
  },
  ingredientDrawer: function ingredientDrawer() {
    var vm = this;
    var el = vm.defaults;
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('click', '.full-ingredients-toggle', function (e) {
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.glowing-template--ingredients').addClass('show-drawer');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').css({
        'overflow': 'hidden'
      });
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('click', '.ingredient-close-drawer', function () {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.glowing-template--ingredients').removeClass('show-drawer');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').css({
        'overflow': 'auto'
      });
    });
  },
  onChangeQuantity: function onChangeQuantity(quantity) {
    var vm = this;
    var el = vm.defaults;
    var thisForm = el.form;
    vm.getSelectedVariantPrice(el.selectedVariant, quantity);
    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_2___default.a.getJSON('/cart.js', function (cart) {
        var result = cart.item_count;
        var getQtyCartLimit = localStorage.getItem("max_variant_cart");
        if (getQtyCartLimit != null) {
          //when SKU Limit 5 is ON
          if (result < getQtyCartLimit) {
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
          }
        } else {
          //when SKU Limit 5 is off
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
        }
      });
    }, 600);
  },
  onVariantChange: function onVariantChange(e) {
    var vm = this;
    var el = vm.defaults;
    var thisForm = el.form;

    // Select the current variant's image
    setTimeout(function () {
      if (el.productCarousel.hasClass('slick-initialized')) {
        vm.getSelectedVariantImage(el.selectedVariant);
      }
    }, 2000);
    thisForm.find(el.formVariantOptions).on('change', function () {
      el.selectedOptions = '';
      vm.getSelectedVariant(thisForm);
      vm.getSelectedVariantImage(el.selectedVariant);
      vm.getSelectedVariantPrice(el.selectedVariant);

      // Check variant availability and show/hide appropriate elements
      vm.checkVariantAvailability(el.selectedVariant);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('#BISvariantid').val(el.selectedVariant);

      // 24.02.24 Now that we have the correct variant ID, uncomment to change the url based on selected variant.
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + el.selectedVariant;
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    });
  },
  checkVariantAvailability: function checkVariantAvailability(variantId) {
    var vm = this;
    var el = vm.defaults;
    var selectedVariant = el.selectedVariant;
    if (el.productObj && el.productObj.variants) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default.a.each(el.productObj.variants, function (index, variant) {
        if (variant.id == variantId) {
          selectedVariant = variant;
          return false;
        }
      });
    }
    if (!selectedVariant) {
      console.warn("Variant with id ".concat(variantId, " not found"));
    }
    var isAvailable = selectedVariant && selectedVariant.available;
    if (isAvailable) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.back-in-stock-btn').addClass('hidden');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.rc-widget-injection-parent').removeClass('hidden');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeClass('hidden');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeClass('hidden');
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.back-in-stock-btn').removeClass('hidden');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.rc-widget-injection-parent').addClass('hidden');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').addClass('hidden');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').addClass('hidden');
    }
  },
  getSelectedVariant: function getSelectedVariant(form) {
    var vm = this;
    var el = vm.defaults;
    if (!jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').hasClass('template-product')) {
      return false;
    }
    form.find(el.formVariantOptions).each(function () {
      if (jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).next('.js.select-options').length > 0) {
        el.selectedOptions += jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).find('select').val() + ' / ';
      } else {
        el.selectedOptions += jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).find('select').val();
      }
    });

    // 24.02.24 Updated to get option value, rather than data-title which was returning underined.
    var currentVariant = form.find('#productDataSelect option[value="' + el.selectedOptions + '"]').val();
    el.formAddtoCartBtn.attr('data-product-id', currentVariant);
    el.selectedVariant = currentVariant;

    // 24.02.24 Updated to get option value, rather than data-title which was returning underined.
    var getDisabled = form.find('#productDataSelect option[value="' + el.selectedOptions + '"]').data('disabled');
    if (getDisabled != null) {
      el.formAddtoCartBtn.find('.add-to-cart-text').find('span').html('Sold Out');
      el.formAddtoCartBtn.attr('disabled', 'disabled');
    } else {
      el.formAddtoCartBtn.removeAttr('disabled');
      el.formAddtoCartBtn.find('.add-to-cart-text').find('span').html('Add to Cart');
    }
  },
  getSelectedVariantImage: function getSelectedVariantImage(variantId) {
    var el = this.defaults;
    if (jquery__WEBPACK_IMPORTED_MODULE_2___default()('form[action="/cart/add"]').data('product-handle') != 'the-beauty-chef-gift-voucher') {
      if (el.productCarousel.length > 0) {
        var imgIndex = el.productCarousel.find('.product-slide[data-img-id="' + variantId + '"]').attr('data-slick-index');
        if (!imgIndex) return;
        el.productCarousel.slick('slickGoTo', imgIndex);
      }
    }
  },
  getSelectedVariantPrice: function getSelectedVariantPrice(variantId, quantity) {
    var vm = this;
    var el = vm.defaults;
    var variantPrice = {};
    if (quantity) {
      var current_quantity = quantity;
    } else {
      var current_quantity = el.formQuantity.val();
    }
    var variantList = el.productObj.variants;
    jquery__WEBPACK_IMPORTED_MODULE_2___default.a.each(variantList, function (index, obj) {
      if (variantId == obj.id) {
        variantPrice['price'] = obj.price;
        if (obj.compare_at_price != null) {
          variantPrice['compare_at_price'] = obj.compare_at_price;
        } else {
          variantPrice['compare_at_price'] = '';
        }
      }
    });
    var pricewithquantity = variantPrice['price'] * current_quantity;
    var pricewithquantitycompare = variantPrice['compare_at_price'] * current_quantity;
    // $(`form button[data-product-id=${variantId}] div[data-price-wrapper] span[data-product-price]`).text('$'+( pricewithquantity / 100).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));

    if (variantPrice['compare_at_price']) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('form div[data-price-wrapper] s[data-compare-price]').text('$' + (pricewithquantitycompare / 100).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('form div[data-price-wrapper] s[data-compare-price]').text('');
    }
  },
  changeTabPane: function changeTabPane() {
    jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-tab-control li a').on('click', function (e) {
      e.preventDefault();
      var thisTab = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).attr('data-panel-id');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).parent().addClass('active').siblings().removeClass('active');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).parent().siblings().removeClass('active');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-tab-content ' + thisTab).addClass('active').siblings().removeClass('active');
    });
  },
  btnAddClick: function btnAddClick() {
    var vm = this;
    vm.defaults.formAddtoCartBtn.on('click', function (e) {
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
      var subs = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc-widget-injection-parent");
      if (subs.length) {
        var vartiantID = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".selected_variant_id_prod").val();
        if (vartiantID == undefined) {
          vartiantID = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-form-hybrid [name="id"]').val();
        }
        var cla_quantity = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).closest('.shopify-product-form').find('.quantity-wrapper').find('input[name="quantity"]').val();
        var subsDays = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.rc-container [name="selling_plan"]').val();
        vm.reChargeaddItemToCart(vartiantID, cla_quantity, subsDays);
      } else {
        var _vartiantID = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".selected_variant_id_prod").val();
        if (_vartiantID == undefined) {
          _vartiantID = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-form-hybrid [name="id"]').val();
        }
        var quantity = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).closest('.shopify-product-form').find('.quantity-wrapper').find('input[name="quantity"]').val();
        var formdata = {
          id: _vartiantID,
          quantity: quantity
        };
        vm.addToCartAjax(formdata);
      }
    });
  },
  addToCartAjax: function addToCartAjax(formdata) {
    jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
    jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
    var vm = this;
    var el = vm.defaults;
    var updateCart = el.updateCart.updateCart;
    console.log("data: " + JSON.stringify(formdata));
    jquery__WEBPACK_IMPORTED_MODULE_2___default.a.getJSON('/cart.js', function (cart) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
    }).done(function (cart) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
      var cartItem = cart.item_count;
      var getQtyCartLimit = localStorage.getItem("max_variant_cart");
      console.log("cartItem: " + cartItem);
      if (getQtyCartLimit != null) {
        //when SKU Limit 5 is ON
        if (cartItem < getQtyCartLimit) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: formdata,
            beforeSend: function beforeSend(data) {},
            success: function success(data) {
              Shopify.getCart(function (cart) {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-item-count').text(cart.item_count);
              });
            },
            error: function error() {}
          }).done(function (data) {
            jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
              method: 'GET',
              url: location.href,
              async: true,
              dataType: 'html',
              success: function success(data) {}
            }).done(function (data) {
              var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_2___default()(data).find("#site-slidecart-inner");
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('#site-slide-cart-drawer').html(cart_slide);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').removeClass('empty-cart');
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').addClass('slide-cart');
              var addonSlides = document.querySelectorAll('.drawer-row-item.is-upsell');
              if (addonSlides.length >= 1) {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.checkout-box').addClass('has-items');
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.upsell-carousel-wrapper').slick({
                  infinite: false,
                  arrows: true,
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  prevArrow: '<div class="slick-arrow slick-prev"></div>',
                  nextArrow: '<div class="slick-arrow slick-next"></div>'
                });
              } else {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.checkout-box').removeClass('has-items');
              }

              // Trigger cart update events for GWP progress bar
              jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).trigger('cartUpdated');
              document.dispatchEvent(new Event('cartRedraw'));
              var getCartItems = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.mobile-cart .cart-item-count').text();
              //var getQtyCartLimit = $('.add-to-cart-text').data('qtycartlimit');
              var getQtyCartLimit = localStorage.getItem("max_variant_cart");
              var setDefaultQuant = getQtyCartLimit - getCartItems;
              if (getQtyCartLimit != null) {
                //when SKU Limit 5 is ON
                if (getCartItems < getQtyCartLimit) {
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
                } else {
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
                }
              } else {
                //when SKU Limit 5 is off
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
              }
            });
          });
        } else {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
        }
      } else {
        //when SKU Limit 5 is off
        jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: formdata,
          beforeSend: function beforeSend(data) {},
          success: function success(data) {
            Shopify.getCart(function (cart) {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-item-count').text(cart.item_count);
            });
          },
          error: function error() {}
        }).done(function (data) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
            method: 'GET',
            url: location.href,
            async: true,
            dataType: 'html',
            success: function success(data) {}
          }).done(function (data) {
            var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_2___default()(data).find("#site-slidecart-inner");
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('#site-slide-cart-drawer').html(cart_slide);
            var addonSlides = document.querySelectorAll('.drawer-row-item.is-upsell');
            if (addonSlides.length >= 1) {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.checkout-box').addClass('has-items');
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.upsell-carousel-wrapper').slick({
                infinite: false,
                arrows: true,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<div class="slick-arrow slick-prev"></div>',
                nextArrow: '<div class="slick-arrow slick-next"></div>'
              });
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.checkout-box').removeClass('has-items');
            }
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').removeClass('empty-cart');
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').addClass('slide-cart');
            var getCartItems = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.mobile-cart .cart-item-count').text();
            //var getQtyCartLimit = $('.add-to-cart-text').data('qtycartlimit');
            var getQtyCartLimit = localStorage.getItem("max_variant_cart");
            var setDefaultQuant = getQtyCartLimit - getCartItems;
            if (getQtyCartLimit != null) {
              //when SKU Limit 5 is ON
              if (getCartItems < getQtyCartLimit) {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
              } else {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
              }
            } else {
              //when SKU Limit 5 is off
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
            }
          });
        });
      }
      // price when items added to cart re-set to original price
      // setTimeout(function() {
      // 	var data_price = $("#rc_duplicate_selector").find(':selected').attr('data-price');
      // 	var data_discount_price = $("#rc_duplicate_selector").find(':selected').attr('data-discount-price');
      // 	var quan = parseInt($("#Quantity").val());
      // 	var p = (data_price / 100).toFixed(2);
      // 	var btnPrice = quan * p;
      // 	console.log("btnPrice: add yo catr "+btnPrice);

      // }, 3000);
    });
  },
  updateCartTotal: function updateCartTotal() {
    // UPDATE TOTAL CART DRAWER
    var vm = this;
    var el = vm.defaults;
    var cartDrawer = el.cartdrawerjs.cartDrawer;
    jquery__WEBPACK_IMPORTED_MODULE_2___default.a.getJSON('/cart.js', function (cart) {
      var cartTotal = parseFloat(cart.total_price / 100);
      var itemCount = cart.item_count;
      if (itemCount > 0) {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').removeClass('empty-cart');
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').addClass('empty-cart');
      }
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-toggle .cart-item-count').text(itemCount);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-total-wrapper .cart-total-amount').text('$' + cartTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      cartDrawer.updateCartDrawerTotal(cart);
    });
  },
  insertSubSaveDetails: function insertSubSaveDetails() {
    var observer = new MutationObserver(function (mutationsList, observer) {
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'childList') {
            var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var node = _step2.value;
                if (node.nodeType === 1 && node.matches('[data-widget-container-wrapper], [data-widget-container-wrapper] *')) {
                  var wrapper = node.matches('[data-widget-container-wrapper]') ? node : node.closest('[data-widget-container-wrapper]');
                  if (wrapper) {
                    var subscriptionContainer = document.querySelector('[data-subscription-container]');
                    var subsaveSelector = document.querySelector('[data-selector-subsave]');
                    if (subscriptionContainer && subsaveSelector) {
                      subsaveSelector.parentNode.insertBefore(subscriptionContainer, subsaveSelector.nextSibling);
                      subscriptionContainer.style.display = 'block';
                    }
                    observer.disconnect();
                    return;
                  }
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  },
  initRechargeProductPricing: function initRechargeProductPricing() {
    var vm = this;
    var el = vm.defaults;
    var initPricing = function initPricing() {
      var productId = el.productObj && el.productObj.id ? el.productObj.id : null;
      if (!productId) {
        var form = document.querySelector('form[action="/cart/add"]');
        productId = form ? form.getAttribute('data-product-id') : null;
      }
      if (!productId) return;
      var productIdNum = parseInt(productId, 10);
      function waitForRechargeWidget(productIdNum, callback) {
        var tries = 0;
        function checkLoaded() {
          if (window.ReChargeWidget && typeof window.ReChargeWidget.getWidget === "function") {
            var widget = window.ReChargeWidget.getWidget(productIdNum);
            if (widget) {
              waitForWidgetReady(widget, callback);
              return;
            }
          }
          if (tries++ < 50) {
            setTimeout(checkLoaded, 100);
          } else {
            console.warn("Recharge widget never became available.");
          }
        }
        checkLoaded();
      }
      function waitForWidgetReady(widget, callback) {
        var readyTries = 0;
        function checkReady() {
          if (typeof widget.subscriptionActive !== "undefined") {
            callback(widget);
            return;
          }
          if (readyTries++ < 30) {
            // 3 seconds 
            setTimeout(checkReady, 100);
          } else {
            var toggleVisibility = function toggleVisibility(showEl, hideEl) {
              if (showEl) {
                showEl.classList.remove(hiddenClass);
                showEl.classList.add(visibleClass);
              }
              if (hideEl) {
                hideEl.classList.remove(visibleClass);
                hideEl.classList.add(hiddenClass);
              }
            };
            console.warn("Widget never fully initialized.");
            var regularPriceEl = document.getElementById('regular-price');
            var subscriptionPriceEl = document.getElementById('subscription-price');
            var subscribeRegularPriceEl = document.getElementById('subscribe-regular-price');
            var subscribeSubscriptionPriceEl = document.getElementById('subscribe-subscription-price');
            var visibleClass = 'subscription-visible';
            var hiddenClass = 'subscription-hidden';
            toggleVisibility(regularPriceEl, subscriptionPriceEl);
            toggleVisibility(subscribeRegularPriceEl, subscribeSubscriptionPriceEl);
            callback(widget);
          }
        }
        checkReady();
      }
      var processWidget = function processWidget(widget) {
        var isPlanActive = false;
        if (widget) {
          isPlanActive = widget.subscriptionActive === true;
        }
        var visibleClass = 'subscription-visible';
        var hiddenClass = 'subscription-hidden';
        function toggleVisibility(showEl, hideEl) {
          if (showEl) {
            showEl.classList.remove(hiddenClass);
            showEl.classList.add(visibleClass);
          }
          if (hideEl) {
            hideEl.classList.remove(visibleClass);
            hideEl.classList.add(hiddenClass);
          }
        }

        // Handle sticky add to cart pricing
        var subscriptionPriceEl = document.getElementById('subscription-price');
        var regularPriceEl = document.getElementById('regular-price');
        if (isPlanActive && subscriptionPriceEl) {
          toggleVisibility(subscriptionPriceEl, regularPriceEl);
        } else if (regularPriceEl) {
          toggleVisibility(regularPriceEl, subscriptionPriceEl);
        }

        // Handle subscribe form pricing
        var subscribeSubscriptionPriceEl = document.getElementById('subscribe-subscription-price');
        var subscribeRegularPriceEl = document.getElementById('subscribe-regular-price');
        if (isPlanActive && subscribeSubscriptionPriceEl) {
          toggleVisibility(subscribeSubscriptionPriceEl, subscribeRegularPriceEl);
        } else if (subscribeRegularPriceEl) {
          toggleVisibility(subscribeRegularPriceEl, subscribeSubscriptionPriceEl);
        }
      };
      waitForRechargeWidget(productIdNum, processWidget);
    };
    if (document.readyState === 'complete') {
      initPricing();
    } else {
      window.addEventListener('load', initPricing);
    }
  },
  removeItemRowAjax: function removeItemRowAjax(rowData) {
    // rowData should accept an object: { rowclass: "class-of-the-row-to-be-removed", product_id: "data-productid attr of the row" };
    var vm = this;
    jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: "quantity=" + 0 + '&id=' + rowData.line_item_key,
      beforeSend: function beforeSend(data) {},
      success: function success(data) {
        // vm.updateLineItem(data);
        // Shopify.getCart(function(cart) {
        // var itemRow = $('.'+rowData.rowclass+'[data-lineitem-key="'+rowData.line_item_key+'"]');
        // itemRow.remove();
        // vm.updateCartTotal();
        // });
        Shopify.getCart(function (cart) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-item-count').text(cart.item_count);
          var cartItem = cart.item_count;
          var getQtyCartLimit = localStorage.getItem("max_variant_cart");
          console.log("remove cart item " + cartItem);
          console.log("remove cart getQtyCartLimit " + getQtyCartLimit);
          if (getQtyCartLimit != null) {
            //when SKU Limit 5 is ON
            if (cartItem < getQtyCartLimit) {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", false);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
            }
          } else {
            //when SKU Limit 5 is off
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", false);
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
          }
          var data_price = jquery__WEBPACK_IMPORTED_MODULE_2___default()("#rc_duplicate_selector").find(':selected').attr('data-price');
          var data_discount_price = jquery__WEBPACK_IMPORTED_MODULE_2___default()("#rc_duplicate_selector").find(':selected').attr('data-discount-price');
          var quan = parseInt(jquery__WEBPACK_IMPORTED_MODULE_2___default()("#Quantity").val());
          var p = (data_price / 100).toFixed(2);
          var btnPrice = quan * p;
          if (data_price) {
            jquery__WEBPACK_IMPORTED_MODULE_2___default()(".add-to-cart-btn").html('<span data-submit-button-text >ADD TO CART <span> <span class="divider">|</span> $' + btnPrice.toFixed(2));
          }
          jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").html('<div class="add-to-cart-text"><span data-submit-button-text="">ADD TO CART</span></div> <span class="divider">|</span> $' + data_discount_price);
        });
        jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
          method: 'GET',
          url: location.href,
          async: true,
          dataType: 'html',
          success: function success(data) {
            if (jquery__WEBPACK_IMPORTED_MODULE_2___default()('.template-cart').length) {
              location.reload();
            }
            var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_2___default()(data).find("#site-slidecart-inner");
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('#site-slide-cart-drawer').html(cart_slide);
          }
        });
        vm.rechargeRemoveAfterpay();
      }
    });
  },
  warningScroll: function warningScroll() {
    var aTag = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".tga-warning a.scrollLink");
    aTag.click(function (e) {
      e.preventDefault();
      var target_name = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).attr('href');
      var target = jquery__WEBPACK_IMPORTED_MODULE_2___default()(target_name);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('html,body').animate({
        scrollTop: target.offset().top - 80
      }, 'slow');
      setTimeout(function () {
        if (jquery__WEBPACK_IMPORTED_MODULE_2___default()('#warning').hasClass('open')) {} else {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('#warning .accordion-header').trigger('click');
        }
      }, 300);
    });
  },
  quickAddVariantSelector: function quickAddVariantSelector() {
    var quick_variant_select = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.quick-variant-selector');
    quick_variant_select.each(function () {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).on('change', function () {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).parent().addClass('selected-one');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).parent().parent().find('.quickadd-with-variant').addClass('show-add');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).parent().parent().find('.quickadd-with-variant').attr('data-varid', this.value);
      });
    });
  },
  productPaymentOptions: function productPaymentOptions() {
    jquery__WEBPACK_IMPORTED_MODULE_2___default()('.tab-header a').click(function (e) {
      e.preventDefault();
      var this_tab = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this),
        target_content = this_tab.data('tab'),
        content_tab = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.tab-content-wrap[data-tab="' + target_content + '"]');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.tab-content-wrap').removeClass('active');
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.tab-header a').removeClass('active');
      this_tab.addClass('active');
      content_tab.addClass('active');
    });
    //radio clicks
    jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').on('click', '.rc-radio', function (e) {
      //e.preventDefault();
      // $('.subscribe-cart-btn').addClass("disabled");
      // $('.subscribe-cart-btn').attr("disabled", false);
      var buyOnceP = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc_widget__price--onetime").text();
      var subSaveP = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc_widget__price--subsave").text();
      var buyOnceOrigP = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").eq(0).attr("base-price") && jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").eq(0).attr("base-price");

      // $(".rc_widget__price--onetime").text(buyOnceP.replace('US',''));
      // $(".rc_widget__price--subsave").text(subSaveP.replace('US',''));

      jquery__WEBPACK_IMPORTED_MODULE_2___default()(".selected_variant_id_prod").val(jquery__WEBPACK_IMPORTED_MODULE_2___default()(".selected_variant_id_prod option:first").val());
      jquery__WEBPACK_IMPORTED_MODULE_2___default.a.getJSON('/cart.js', function (cart) {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
      }).done(function (cart) {
        var cartItem = cart.item_count;
        var getQtyCartLimit = localStorage.getItem("max_variant_cart");
        if (getQtyCartLimit != null) {
          //when SKU Limit 5 is ON
          if (cartItem < getQtyCartLimit) {
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", false);
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
          }
        } else {
          //when SKU Limit 5 is off
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", false);
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
        }
      });
      if (jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).hasClass("rc_widget__option--subsave")) {
        //discount text static
        var discData = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc-option__discount").text();
        if (discData == null || discData == "" || discData == undefined) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc-desciption-content").css("display", "none");
        }
        jquery__WEBPACK_IMPORTED_MODULE_2___default()("[name=quantity]").val('1');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.forms-pdp .tab-buy-once .no-subs').css('display', 'none');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.forms-pdp .tab-subscribe').css('display', 'block');
        // var price = $(".rc_widget__price--subsave").text();
        // price = price.replace("US", "$");

        jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn .product-price").empty().append(price);
        jquery__WEBPACK_IMPORTED_MODULE_2___default()("#rc_duplicate_selector option").data('price', price);

        //on load price
        var price_on_load = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc_widget__price--subsave").text();
        price_on_load = price_on_load.replace("US", "");
        //price_on_load = price_on_load.replace(/\.00/,'');

        //$(".subscribe-cart-btn").empty().append("<div class='add-to-cart-text'> <span data-submit-button-text>ADD TO CART</span> </div> <span class='divider'>|</span> "+price_on_load+ " <span class='divider'>|</span> <span style='display: inline-block;vertical-align: middle;'>Every delivery</span>");
        // $(".subscribe-cart-btn").empty().append("<div class='add-to-cart-text'> <span data-submit-button-text>ADD TO CART</span> </div> <span class='divider'>|</span> <s data-compare-price='' id='compare_price_data'>"+buyOnceOrigP+"</s>"+price_on_load);
        var comparePrice = buyOnceOrigP ? parseFloat(buyOnceOrigP.replace('$', '')) : 0;
        var comparePriceAt = price_on_load ? parseFloat(price_on_load.replace('$', '')) : 0;
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").empty().append("<div class='add-to-cart-text'> <span data-submit-button-text>ADD TO CARTaa</span> </div> <span class='divider'>|</span> <s data-compare-price='' id='compare_price_data'>".concat(comparePrice > comparePriceAt ? buyOnceOrigP : '', "</s>").concat(price_on_load));
        var stickyAddToCartBtnEl = document.querySelector('.sticky-add-to-cart__button');
        var stickyAddToCartBtnText = (stickyAddToCartBtnEl === null || stickyAddToCartBtnEl === void 0 ? void 0 : stickyAddToCartBtnEl.querySelector('[data-submit-button-text]').dataset.submitButtonText) == 'CHOOSE OPTIONS' || document.querySelector('.c-product-variants__list') ? 'Choose Options' : 'Add to cart';
        stickyAddToCartBtnEl && jquery__WEBPACK_IMPORTED_MODULE_2___default()(".sticky-add-to-cart__button").empty().append("<span data-submit-button-text>".concat(stickyAddToCartBtnText, "</span>  <span class='divider'>|</span><s data-compare-price='' id='compare_price_data'>").concat(comparePrice > comparePriceAt ? buyOnceOrigP : '', "</s>").concat(price_on_load));
      }
      if (jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).hasClass("rc_widget__option--onetime")) {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()("[name=quantity]").val('1');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.forms-pdp .tab-buy-once .no-subs').css('display', 'flex');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.forms-pdp .tab-subscribe').css('display', 'none');
        var price_once = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc_widget__price--onetime").text();
        price_once = price_once.replace("US", "");
        price_once = price_once.replace("$", "");
        //price_once = price_once.replace(/\.00/,'');

        jquery__WEBPACK_IMPORTED_MODULE_2___default()('#Option1').attr('data-single-discount', price_once);
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('button .product-price').html('$' + price_once);
        var _comparePrice = buyOnceOrigP ? parseFloat(buyOnceOrigP.replace('$', '')) : 0;
        var _comparePriceAt = price_once ? parseFloat(price_once.replace('$', '')) : 0;
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(".add-to-cart-btn").empty().append("<span data-submit-button-text> Add to Cart </span> <span class='divider'>|</span> <s data-compare-price='' id='compare_price_data'>".concat(_comparePrice > _comparePriceAt ? buyOnceOrigP : '', "</s> $").concat(price_once));
        var _stickyAddToCartBtnEl = document.querySelector('.sticky-add-to-cart__button');
        var _stickyAddToCartBtnText = (_stickyAddToCartBtnEl === null || _stickyAddToCartBtnEl === void 0 ? void 0 : _stickyAddToCartBtnEl.querySelector('[data-submit-button-text]').dataset.submitButtonText) == 'CHOOSE OPTIONS' || document.querySelector('.c-product-variants__list') ? 'Choose Options' : 'Add to cart';
        _stickyAddToCartBtnEl && jquery__WEBPACK_IMPORTED_MODULE_2___default()(".sticky-add-to-cart__button").empty().append("<span data-submit-button-text>".concat(_stickyAddToCartBtnText, "</span>  <span class='divider'>|</span><s data-compare-price='' id='compare_price_data'>").concat(_comparePrice > _comparePriceAt ? buyOnceOrigP : '', "</s>$").concat(price_once));

        // $(".add-to-cart-btn").empty().append("<span data-submit-button-text> Add to Cart </span> <span class='divider'>|</span> $"+price_once);
        // $(".add-to-cart-btn").empty().append("<span data-submit-button-text=''> Add to Cart </span> <span class='divider'>|</span> <s data-compare-price='' id='compare_price_data'>"+buyOnceOrigP+"</s>$"+price_once);
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()("body").one('click', '.rc-radio', function () {
      // executes only once
      var classList = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).attr('class').split(/\s+/);
      var appended = false;
      jquery__WEBPACK_IMPORTED_MODULE_2___default.a.each(classList, function (index, item) {
        if (item === 'rc_widget__option--subsave') {
          var price = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".rc_widget__price--subsave").text();
          price = price.replace("US$", "$");
          // if(!appended){
          // 	$("#rc_duplicate_selector option").append(price+ ' (EACH)');
          // 	appended = true;
          // }
        }
      });
    });
  },
  updateLineItem: function updateLineItem(cart) {
    var items = cart.items;
    items.forEach(function (item) {
      var price = '$' + parseFloat(item.line_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.drawer-row-item[data-productid="' + item.id + '"]').find('.item-total').html(price);
    });
    if (jquery__WEBPACK_IMPORTED_MODULE_2___default()('#results.suffix-questionnaire-results').length > 0) {
      var bundle_in_cart = [];
      var bundleID = ["19470928052312", "32423651475544", "20320085999704"];
      items.forEach(function (item) {
        var product_id = item.id;
        var item_prop_obj = item.properties;
        for (var key in item_prop_obj) {
          if (key == 'Quiz Result') {
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('button.add-to-cart-btn[data-variant-id="' + product_id + '"]').addClass('disabled');
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('button.add-to-cart-btn[data-variant-id="' + product_id + '"]').html('Item Added to Cart');
            bundle_in_cart.push('' + product_id + '');
          }
        }
      });

      // compare arrays:
      var isIdentical = function isIdentical(arr1, arr2) {
        return jquery__WEBPACK_IMPORTED_MODULE_2___default()(arr1).not(arr2).length === 0 && jquery__WEBPACK_IMPORTED_MODULE_2___default()(arr2).not(arr1).length === 0;
      };

      // get comparison result:
      var result = isIdentical(bundle_in_cart, bundleID);
      if (result) {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').text('Your Bundle is Already In The Cart');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').addClass('disabled');
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').removeClass('disabled');
        var get_origtex = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').attr('data-origtext');
        if (get_origtex) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').html(get_origtex);
        }
      }
    }
  },
  subscriptionProduct: function subscriptionProduct() {
    var vm = this;
    var rc_ddiscount = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#rc_percentage_discount').val();
    if (rc_ddiscount < 1) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-options-tabs .tab-header a[data-tab="subscribe"]').html('Subscribe');
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-options-tabs .tab-header a[data-tab="subscribe"]').html('Subscribe & Save <span class="recharge-percentage-discount">' + rc_ddiscount + '</span>%');
    }
    if (location.search.includes('subscribe_selected')) {
      //$('.payment-options-tabs .tab-header a[data-tab="subscribe"]')[0].click();
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('#puchase_as_a_gift-infotab').hide();
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('#puchase_as_a_gift-infotab').show();
    }
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('click', '.payment-options-tabs .tab-header a', function () {
      var data_target = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).data('tab');
      if (data_target == 'subscribe') {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('#puchase_as_a_gift-infotab').hide();
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('#puchase_as_a_gift-infotab').show();
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('click', '.subscribe-cart-btn', function (e) {
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      // $('.subscribe-cart-btn').attr("disabled", true);

      var subscribe_form = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).closest('.subscribe-form');
      var selectedVariant = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.rc-prod-option.active');
      var vartiantID = jquery__WEBPACK_IMPORTED_MODULE_2___default()("#rc_duplicate_selector").val();
      if (vartiantID == undefined) {
        vartiantID = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-form [name="id"]').val();
      }
      var cla_quantity = subscribe_form.find('#subscribe-quantity').val();
      var interval_type = "Days";
      var rcgID = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#rc_subscription_id').val();
      var subsDays = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#frequency').val();
      vm.reChargeaddItemToCart(vartiantID, cla_quantity, subsDays);
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('click', '[data-rc-add-btn]', function (e) {
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      // $('.subscribe-cart-btn').attr("disabled", true);
      var $this = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this);
      var varId = $this.attr('data-sub-var-id');
      var subsId = $this.data('sub-id');
      var subsDays = $this.data('sub-interval-type');
      var subsInterval = $this.data('sub-frequency');
      vm.reChargeaddItemToCart(varId, 1, subsDays, subsInterval, subsId);
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('change', '[data-rc-select]', function () {
      var btn_container = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).parent().closest('.add-to-cart-featured-prod').find('.btn-row');
      var btn = btn_container.find('[data-rc-add-btn]');
      btn.attr('data-sub-var-id', jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).val());
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('change', '.selected_variant_id_prod', function () {
      console.log("var change");

      // Use logic from AU
      var $selectedOption = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#Option1').find(':selected');
      var variantId = $selectedOption.val();

      // Grab prices from selected option
      var singleDiscount = $selectedOption.data('single-discount');
      var singleOrigPrice = $selectedOption.data('single-orig-price');

      // TODO: But if selected product has subscription a plan, get the subscription price instead
      // const subscriptionDiscount = 
      // const subscriptionOrigPrice = 

      // Quantity
      var quantity = parseInt(jquery__WEBPACK_IMPORTED_MODULE_2___default()("#Quantity").val()) || 1;

      // Remove "$" and calculate totals
      var basePrice = jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").eq(0).attr("base-price") && jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").eq(0).attr("base-price");
      basePrice = basePrice ? parseFloat(basePrice.replace('$', '')) : 0;
      var subPrice = parseFloat(jquery__WEBPACK_IMPORTED_MODULE_2___default()('.rc-radio__input:checked+label span[data-price-subsave]').text().replace('$', '')) || 0;
      var discountValue = subPrice != 0 ? subPrice : parseFloat(singleDiscount.replace('$', '')) || 0;
      var compareAtValue = basePrice != 0 ? basePrice : parseFloat(singleOrigPrice.replace('$', '')) || 0;
      var totalPrice = subPrice != 0 ? (subPrice * quantity).toFixed(2) : (discountValue * quantity).toFixed(2);

      // Update buttons
      jquery__WEBPACK_IMPORTED_MODULE_2___default()(".add-to-cart-btn").html("\n\t\t\t\t<span data-submit-button-text=''>ADD TO CART</span>\n\t\t\t\t<span class='divider'>|</span>\n\t\t\t\t".concat(compareAtValue > discountValue ? "<s>$".concat(compareAtValue.toFixed(2), "</s> ") : '', "\n\t\t\t\t$").concat(totalPrice, "\n\t\t\t"));
      jquery__WEBPACK_IMPORTED_MODULE_2___default()(".subscribe-cart-btn").html("\n\t\t\t\t<div class=\"add-to-cart-text\">\n\t\t\t\t\t<span data-submit-button-text=\"\">ADD TO CART</span>\n\t\t\t\t</div>\n\t\t\t\t<span class=\"divider\">|</span>\n\t\t\t\t".concat(compareAtValue > discountValue ? "<s>$".concat(compareAtValue.toFixed(2), "</s> ") : '', "\n\t\t\t\t$").concat(discountValue.toFixed(2), "\n\t\t\t"));
      var stickyAddToCartBtnEl = document.querySelector('.sticky-add-to-cart__button');
      var stickyAddToCartBtnText = (stickyAddToCartBtnEl === null || stickyAddToCartBtnEl === void 0 ? void 0 : stickyAddToCartBtnEl.querySelector('[data-submit-button-text]').dataset.submitButtonText) == 'CHOOSE OPTIONS' || document.querySelector('.c-product-variants__list') ? 'Choose Options' : 'Add to cart';
      var btnStickyHtml = "\n      <span data-submit-button-text>".concat(stickyAddToCartBtnText, "</span>\n      <span class=\"divider\">|</span>\n      ").concat(stickyAddToCartBtnText !== 'Add to cart' ? '' : '', "\n\t\t\t").concat(compareAtValue > discountValue ? "<s data-compare-price id=\"compare_price_data\">$".concat(compareAtValue.toFixed(2), "</s> ") : '', "\n      <span data-subscribe-price>$").concat(discountValue.toFixed(2), "</span>\n      ");
      if (stickyAddToCartBtnEl) {
        stickyAddToCartBtnEl.innerHTML = btnStickyHtml;
      }
      // var buyOnceOrigP = $("#compare_price_data").text();
      // const this_val = $(this).val();
      // $("#rc_duplicate_selector").val(this_val);
      // var hasDiscountP = $('#Option1').find(':selected').attr('data-single-orig-price');
      // var hasDiscountSubP = $('#rc_duplicate_selector').find(':selected').attr('data-subs-orig-price');

      // //var varPrice =$('option:checked', this).attr('data-single-discount');
      // var data_price = $("#rc_duplicate_selector").find(':selected').attr('data-price');
      // var price_in_dec = (data_price / 100).toFixed(2);
      // var data_discount_price = $("#rc_duplicate_selector").find(':selected').attr('data-discount-price');
      // var quan = parseInt($("#Quantity").val());
      // var p = (data_price / 100).toFixed(2);
      // var btnPrice = quan * p;

      //$(".add-to-cart-btn").html('<span data-submit-button-text >ADD TO CART <span> <span class="divider">|</span> $'+ btnPrice.toFixed(2));

      //$(".subscribe-cart-btn").html('<div class="add-to-cart-text"><span data-submit-button-text="">ADD TO CART</span></div> <span class="divider">|</span> $'+data_discount_price+' <span class="divider">|</span> <span style="display: inline-block;vertical-align: middle;">Every delivery</span>');

      // $(".add-to-cart-btn").html("<span data-submit-button-text=''> Add to Cart </span> <span class='divider'>|</span> <s data-compare-price id='compare_price_data'>"+hasDiscountP+"</s>$"+btnPrice.toFixed(2));
      // $(".subscribe-cart-btn").html("<div class='add-to-cart-text'> <span data-submit-button-text>ADD TO CART</span> </div> <span class='divider'>|</span> <s data-compare-price id='compare_price_data'>"+hasDiscountSubP+"</s>$"+data_discount_price);

      // $(".rc_widget__price--onetime").html('$'+(data_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      // $(".rc_widget__price--subsave").html('$'+data_discount_price);

      var daysSub = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#frequency').val();
      if (daysSub != 'none') {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeClass("disabled");
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').addClass("disabled");
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
      }
    });
    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('change', '#frequency', function () {
      var daysSub = jquery__WEBPACK_IMPORTED_MODULE_2___default()('#frequency').val();
      if (daysSub != 'none') {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeClass("disabled");
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').addClass("disabled");
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", false);
      }
    });

    // $(document).on('change', '#rc_duplicate_selector', function(){
    // 	var variant_price = $(this).find(':selected').attr('data-discount-price');
    // 	const subscribe_form = $(this).closest('.subscribe-form');
    // 	const add_btn = subscribe_form.find('.subscribe-cart-btn span[data-product-price]');
    // 	const compare_price = subscribe_form.find('.subscribe-cart-btn s[data-compare-price]');
    // 	add_btn.text('$' + variant_price * $('.subscribe-form #subscribe-quantity').val());
    // 	var variant_original_price = $(this).find(':selected').attr('data-original-price');

    // 	var pricewithquantitycompare = variant_original_price * $('.subscribe-form #subscribe-quantity').val();
    // 	compare_price.text('$'+(pricewithquantitycompare / 100).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    // });

    jquery__WEBPACK_IMPORTED_MODULE_2___default()(document).on('click', '.rc_learn_more_link', function (e) {
      e.preventDefault();
      var target_section = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.rc_how-it-works');
      if (target_section.hasClass('open-hiw')) {
        target_section.removeClass('open-hiw');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).text('More Info');
      } else {
        target_section.addClass('open-hiw');
        jquery__WEBPACK_IMPORTED_MODULE_2___default()(this).text('Less Info');
      }
    });
  },
  reChargeaddItemToCart: function reChargeaddItemToCart(variant_id, quantity, selling_plan_id) {
    jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
    // $('.subscribe-cart-btn').attr("disabled", true);

    var vm = this;
    var el = vm.defaults;
    var updateCart = el.updateCart.updateCart;
    jquery__WEBPACK_IMPORTED_MODULE_2___default.a.getJSON('/cart.js', function (cart) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
    }).done(function (cart) {
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
      jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
      var cartItem = cart.item_count;
      var getQtyCartLimit = localStorage.getItem("max_variant_cart");
      console.log("cartItem recharge: " + cartItem);
      if (getQtyCartLimit != null) {
        //when SKU Limit 5 is ON
        if (cartItem < getQtyCartLimit) {
          var data = {
            "quantity": quantity,
            "id": variant_id,
            "selling_plan": selling_plan_id
          };
          jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function success(data) {
              Shopify.getCart(function (cart) {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-item-count').text(cart.item_count);
              });
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
            }
          }).done(function (data) {
            jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
              method: 'GET',
              url: location.href,
              async: true,
              dataType: 'html',
              success: function success(data) {}
            }).done(function (data) {
              var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_2___default()(data).find("#site-slidecart-inner");
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('#site-slide-cart-drawer').html(cart_slide);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-american_express"]').hide();
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-google_pay"]').hide();
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-shopify_pay"]').hide();
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-apple_pay"]').hide();
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons .afterpay').hide();
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').removeClass('empty-cart');
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').addClass('slide-cart');
              var getCartItems = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.mobile-cart .cart-item-count').text();
              //var getQtyCartLimit = $('.add-to-cart-text').data('qtycartlimit');
              var getQtyCartLimit = localStorage.getItem("max_variant_cart");
              var setDefaultQuant = getQtyCartLimit - getCartItems;
              if (getQtyCartLimit != null) {
                //when SKU Limit 5 is ON
                if (getCartItems < getQtyCartLimit) {
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
                } else {
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
                  jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
                }
              } else {
                //when Sconsole.warn("Widget never fully initialized.");KU Limit 5 is off
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
              }
            });
          });
        } else {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
        }
      } else {
        //when SKU Limit 5 is off
        var data = {
          "quantity": quantity,
          "id": variant_id,
          "selling_plan": selling_plan_id
        };
        jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function success(data) {
            Shopify.getCart(function (cart) {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.cart-item-count').text(cart.item_count);
            });
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
          }
        }).done(function (data) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
            method: 'GET',
            url: location.href,
            async: true,
            dataType: 'html',
            success: function success(data) {}
          }).done(function (data) {
            var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_2___default()(data).find("#site-slidecart-inner");
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('#site-slide-cart-drawer').html(cart_slide);
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-american_express"]').hide();
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-google_pay"]').hide();
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-shopify_pay"]').hide();
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-apple_pay"]').hide();
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons .afterpay').hide();
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').removeClass('empty-cart');
            jquery__WEBPACK_IMPORTED_MODULE_2___default()('body').addClass('slide-cart');
            var addonSlides = document.querySelectorAll('.drawer-row-item.is-upsell');
            if (addonSlides.length >= 1) {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.checkout-box').addClass('has-items');
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.upsell-carousel-wrapper').slick({
                infinite: false,
                arrows: true,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<div class="slick-arrow slick-prev"></div>',
                nextArrow: '<div class="slick-arrow slick-next"></div>'
              });
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.checkout-box').removeClass('has-items');
            }
            var getCartItems = jquery__WEBPACK_IMPORTED_MODULE_2___default()('.mobile-cart .cart-item-count').text();
            //var getQtyCartLimit = $('.add-to-cart-text').data('qtycartlimit');
            var getQtyCartLimit = localStorage.getItem("max_variant_cart");
            var setDefaultQuant = getQtyCartLimit - getCartItems;
            if (getQtyCartLimit != null) {
              //when SKU Limit 5 is ON
              if (getCartItems < getQtyCartLimit) {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
              } else {
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').attr("disabled", true);
                jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').attr("disabled", true);
              }
            } else {
              //when SKU Limit 5 is off
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.product-form .input-quantity').val(1);
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.add-to-cart-btn').removeAttr('disabled');
              jquery__WEBPACK_IMPORTED_MODULE_2___default()('.subscribe-cart-btn').removeAttr('disabled');
            }
          });
        });
      }
    });
  },
  rechargeRemoveAfterpay: function rechargeRemoveAfterpay() {
    Shopify.getCart(function (cart) {
      var cart_line_item = cart['items'];
      var item_titles = [];
      cart_line_item.forEach(function (item_obj) {
        if (item_obj.title.includes('Auto renew')) {
          item_titles.push(item_obj.title);
        }
      });
      if (item_titles.length > 0) {
        //$('.cart-page-purchase-gift').hide();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons .afterpay').hide();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-american_express"]').hide();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-google_pay"]').hide();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-shopify_pay"]').hide();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-apple_pay"]').hide();
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons .afterpay').show();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-american_express"]').show();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-google_pay"]').show();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-shopify_pay"]').show();
        jquery__WEBPACK_IMPORTED_MODULE_2___default()('.payment-icons [aria-labelledby="pi-apple_pay"]').show();
      }
    });
  },
  stickyProductATC: function stickyProductATC() {
    var stickyAddToCartEl = document.querySelector('.sticky-add-to-cart');
    var stickyAddToCartBtn = document.querySelector('.sticky-add-to-cart__button');
    if (stickyAddToCartEl) {
      window.addEventListener("scroll", function () {
        var productDetailsEl = document.querySelector('.section-product-details') || document.querySelector('#shopify-section-product-cwv');
        var scrollDistance = window.innerWidth < 768 ? productDetailsEl.getBoundingClientRect().height - 20 : productDetailsEl.getBoundingClientRect().height - 79;
        if (window.scrollY > scrollDistance) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('html').addClass('show-button');
        }
        if (window.scrollY < scrollDistance) {
          jquery__WEBPACK_IMPORTED_MODULE_2___default()('html').removeClass('show-button');
        }
      });
      if (stickyAddToCartBtn) {
        stickyAddToCartBtn.addEventListener('click', function (e) {
          var form = document.querySelector('form[action="/cart/add"]');
          if (this.classList.contains('has-variant')) {
            if (form) {
              var formTop = form.getBoundingClientRect().top + window.pageYOffset - 150;
              window.scrollTo({
                top: formTop,
                behavior: 'smooth'
              });
            }
          } else {
            if (form) {
              var formTop = form.getBoundingClientRect().top + window.pageYOffset - 150;
              window.scrollTo({
                top: formTop,
                behavior: 'smooth'
              });
              jquery__WEBPACK_IMPORTED_MODULE_2___default()("[data-submit-button]").trigger("click");
            }
          }
        });
      }
    }
  },
  upsellAddToCart: function upsellAddToCart() {
    var vm = this;
    var SEL_UPSELL_BUTTON = '[data-pdp-upsell-add-btn]';
    var upsellButtons = document.querySelectorAll(SEL_UPSELL_BUTTON);
    upsellButtons.forEach(function (upsellButton) {
      var upsellItem = upsellButton.dataset.pdpUpsellAddBtn;
      var itemToAdd = {
        id: upsellItem,
        quantity: 1
      };
      upsellButton.addEventListener('click', function (e) {
        e.preventDefault();
        vm.addToCartAjax(itemToAdd);
      });
    });
  },
  initializeReviewsCarousel: function initializeReviewsCarousel() {
    var vm = this;
    var SEL_REVIEWS_CAROUSEL = '[data-reviews-carousel]';
    var SEL_REVIEWS_CAROUSEL_PREV = '[data-reviews-carousel-prev]';
    var SEL_REVIEWS_CAROUSEL_NEXT = '[data-reviews-carousel-next]';
    var SEL_REVIEWS_CAROUSEL_INNER = '[data-reviews-carousel-inner]';
    var SEL_REVIEWS_CAROUSEL_SLIDE = '[data-reviews-carousel-slide]';
    var SEL_REVIEWS_SHOWALL_BUTTON = '[data-review-showall-button]';
    var SEL_SECTION_REVIEWS = '[data-yotpo-element-id="1"]';
    var reviewCarousel = document.querySelectorAll(SEL_REVIEWS_CAROUSEL);
    var allReviewsButton = document.querySelector(SEL_REVIEWS_SHOWALL_BUTTON);
    var reviewsSection = document.querySelector(SEL_SECTION_REVIEWS);
    if (!allReviewsButton || !reviewCarousel) return;
    allReviewsButton === null || allReviewsButton === void 0 || allReviewsButton.addEventListener('click', function (e) {
      e.preventDefault();
      reviewsSection === null || reviewsSection === void 0 || reviewsSection.scrollIntoView({
        behavior: "smooth"
      });
    });
    reviewCarousel === null || reviewCarousel === void 0 || reviewCarousel.forEach(function (carousel) {
      var carouselPrev = carousel.querySelector(SEL_REVIEWS_CAROUSEL_PREV);
      var carouselNext = carousel.querySelector(SEL_REVIEWS_CAROUSEL_NEXT);
      var carouselInner = carousel.querySelector(SEL_REVIEWS_CAROUSEL_INNER);
      var carouselSlide = carousel.querySelectorAll(SEL_REVIEWS_CAROUSEL_SLIDE);
      var firstSlide = carouselSlide[0];
      var lastSlide = carouselSlide[carouselSlide.length - 1];
      var startSlideObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            carouselPrev === null || carouselPrev === void 0 || carouselPrev.classList.add("is-hidden");
          } else {
            carouselPrev === null || carouselPrev === void 0 || carouselPrev.classList.remove("is-hidden");
          }
        });
      }, {
        threshold: 0.9
      });
      var endSlideObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            carouselNext === null || carouselNext === void 0 || carouselNext.classList.add("is-hidden");
          } else {
            carouselNext === null || carouselNext === void 0 || carouselNext.classList.remove("is-hidden");
          }
        });
      }, {
        threshold: 0.9
      });
      startSlideObserver.observe(firstSlide);
      endSlideObserver.observe(lastSlide);
      carouselPrev.addEventListener('click', function (e) {
        e.preventDefault();
        carouselInner.scrollLeft -= carouselSlide[0].offsetWidth;
      });
      carouselNext.addEventListener('click', function (e) {
        e.preventDefault();
        carouselInner.scrollLeft += carouselSlide[0].offsetWidth;
      });
    });
  },
  handleVariantSwatches: function handleVariantSwatches() {
    var variantSwatches = document.querySelectorAll('[data-variant-swatch]');
    var variantSelectors = document.querySelectorAll('.selected_variant_id_prod');
    if (!variantSwatches || !variantSelectors) return;
    variantSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (swatch.classList.contains('is-selected')) return;
        variantSwatches.forEach(function (swatch) {
          swatch.classList.remove('is-selected');
        });
        variantSelectors.forEach(function (select) {
          if (select.getAttribute('id') === swatch.getAttribute('data-option-selector')) {
            var variantId = swatch.getAttribute('data-variant');
            Array.from(select.options).forEach(function (option) {
              option.selected = option.value === variantId;
            });
            select.dispatchEvent(new Event('change'));
            jquery__WEBPACK_IMPORTED_MODULE_2___default()(select).trigger('change');
          }
        });
        swatch.classList.add('is-selected');
      });
    });
  },
  initializeZoom: function initializeZoom() {
    // Zoom 
    var vm = this;
    var el = vm.defaults;
    var $productZoom = jquery__WEBPACK_IMPORTED_MODULE_2___default()(el.productCarousel).find(SELECTOR_ZOOM);
    $productZoom.each(function () {
      var $wrap = jquery__WEBPACK_IMPORTED_MODULE_2___default()(this);
      $wrap.on('mousedown', function (e) {
        vm.onZoomStart(e);
      });
      $wrap.on('touchstart', function (e) {
        vm.onZoomStart(e);
      });
      $wrap.on('mousemove', function (e) {
        vm.onZoomMove(e);
      });
      $wrap.on('touchmove', function (e) {
        vm.onZoomMove(e);
      });
      $wrap.on('mouseup', function (e) {
        vm.onZoomEnd(e);
      });
      $wrap.on('touchend', function (e) {
        vm.onZoomEnd(e);
      });
    });
  },
  onZoomStart: function onZoomStart(e) {
    var vm = this;
    var cPos = vm.getClientPos(e);
    vm.dragOriginX = cPos.x;
    vm.dragOriginY = cPos.y;
    vm.dragDx = 0;
    vm.dragDy = 0;
    vm.isDragging = true;
    var $target = jquery__WEBPACK_IMPORTED_MODULE_2___default()(e.currentTarget);
    if ($target.hasClass(CLASS_ZOOMED)) {
      e.preventDefault();
      e.stopPropagation();
      var percentFromCentreX = $target.css('--offsetPercentX');
      var percentFromCentreY = $target.css('--offsetPercentY');
      vm.offsetStartX = parseFloat(percentFromCentreX.split('%')[0]);
      vm.offsetStartY = parseFloat(percentFromCentreY.split('%')[0]);
    }
  },
  onZoomMove: function onZoomMove(e) {
    var $target = jquery__WEBPACK_IMPORTED_MODULE_2___default()(e.currentTarget);
    var vm = this;
    var cPos = vm.getClientPos(e);
    if (vm.isDragging) {
      vm.dragDx = cPos.x - vm.dragOriginX;
      vm.dragDy = cPos.y - vm.dragOriginY;
    } else {
      vm.dragDx = 0;
      vm.dragDy = 0;
    }
    var zoomContainerRect = $target[0].getBoundingClientRect();
    var zoomContainerCentreX = zoomContainerRect.x + zoomContainerRect.width / 2;
    var zoomContainerCentreY = zoomContainerRect.y + zoomContainerRect.height / 2;
    var percentFromCentreX = 0;
    var percentFromCentreY = 0;
    if (e.type === 'mousemove') {
      percentFromCentreX = -1 * ((cPos.x - zoomContainerCentreX) / (zoomContainerRect.width / 2)) * 100 / 2;
      percentFromCentreY = -1 * ((cPos.y - zoomContainerCentreY) / (zoomContainerRect.height / 2)) * 100 / 2;
    } else {
      percentFromCentreX = vm.offsetStartX + vm.dragDx / window.innerWidth * 100;
      percentFromCentreY = vm.offsetStartY + vm.dragDy / window.innerHeight * 100;
    }
    percentFromCentreX = Math.max(Math.min(percentFromCentreX, 50), -50);
    percentFromCentreY = Math.max(Math.min(percentFromCentreY, 50), -50);
    $target.css('--offsetPercentX', "".concat(percentFromCentreX, "%"));
    $target.css('--offsetPercentY', "".concat(percentFromCentreY, "%"));
  },
  onZoomEnd: function onZoomEnd(e) {
    var vm = this;
    var $target = jquery__WEBPACK_IMPORTED_MODULE_2___default()(e.currentTarget);
    if (vm.onDebounceCooldown) {
      return;
    }
    vm.onDebounceCooldown = true;
    setTimeout(function () {
      vm.onDebounceCooldown = false;
    }, DEBOUNCE_COOLDOWN);
    if (Math.abs(vm.dragDx) < MIN_DRAG_DELTA && Math.abs(vm.dragDy) < MIN_DRAG_DELTA) {
      vm.isDragging = false;
    }
    if (!vm.isDragging && !$target.hasClass(CLASS_ZOOMED)) {
      $target.removeClass(CLASS_ZOOMED);
      $target.addClass(CLASS_ZOOMED);
    } else if (!vm.isDragging) {
      $target.removeClass(CLASS_ZOOMED);
    }
  },
  getClientPos: function getClientPos(e) {
    var eventX = 0;
    var eventY = 0;
    if (e.changedTouches) {
      var firstTouch = e.changedTouches[0];
      eventX = firstTouch.clientX;
      eventY = firstTouch.clientY;
    } else {
      eventX = e.clientX;
      eventY = e.clientY;
    }
    return {
      x: eventX,
      y: eventY
    };
  }
};
var _product = product;


/***/ }),

/***/ "./src/js/er-custom/redirect-login.js":
/*!********************************************!*\
  !*** ./src/js/er-custom/redirect-login.js ***!
  \********************************************/
/*! exports provided: redirectLogin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redirectLogin", function() { return _redirectLogin; });
var redirectLogin = {};
redirectLogin = {
  defaults: {
    container: $('.customers-login')
  },
  onInit: function onInit(e) {
    var container = this.defaults.container;
    if (window.location.pathname.split('/')[1] !== 'account') {
      document.cookie = "newRedirectSignIn= ; expires= Thu, 21 Aug 1980 00:00:00 UTC; path=/account;";
    }
    if (window.location.pathname === '/pages/new-year-new-gut') {
      document.cookie = "newRedirectSignIn=";
      document.cookie = "newRedirectSignIn=".concat(window.location.pathname, "; path=/account");
    }
    if (container.length && this.getCookie('newRedirectSignIn') !== '') {
      document.getElementById('return_to_login').value = this.getCookie('newRedirectSignIn') + '/';
      document.getElementById('return_to_register').value = this.getCookie('newRedirectSignIn') + '/';
    }
  },
  getCookie: function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
};
var _redirectLogin = redirectLogin;


/***/ }),

/***/ "./src/js/er-custom/review-slider.js":
/*!*******************************************!*\
  !*** ./src/js/er-custom/review-slider.js ***!
  \*******************************************/
/*! exports provided: review_slider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "review_slider", function() { return _review_slider; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slick-carousel/slick/slick.min */ "./node_modules/slick-carousel/slick/slick.min.js");
/* harmony import */ var slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min__WEBPACK_IMPORTED_MODULE_1__);


var review_slider = {};
review_slider = {
  defaults: {},
  onInit: function onInit(e) {
    var vm = this;
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.slider-layout').length > 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.review-slider-text').slick({
        dots: false,
        infinite: false,
        arrows: false,
        fade: true,
        slidesToShow: 1,
        centerMode: true,
        asNavFor: '.review-image-slider'
      });
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.review-image-slider').slick({
        dots: false,
        infinite: false,
        slidesToShow: 1,
        asNavFor: '.review-slider-text',
        prevArrow: '.slide-arrow-prev',
        nextArrow: '.slide-arrow-next'
      });
    }
  }
};
var _review_slider = review_slider;


/***/ }),

/***/ "./src/js/er-custom/science-section.js":
/*!*********************************************!*\
  !*** ./src/js/er-custom/science-section.js ***!
  \*********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ScienceSection = /*#__PURE__*/function () {
  function ScienceSection(container) {
    _classCallCheck(this, ScienceSection);
    this.container = container;
    this.tabButtons = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).find("[data-tab]");
    this.tabHandleAttr = "data-tab-handle";
  }
  return _createClass(ScienceSection, [{
    key: "init",
    value: function init() {
      if (this.tabButtons) {
        // binding to access constructor this
        this.tabButtons.on("click", this.onTabClick.bind(this));
        this.activeHandle = this.tabButtons.first().attr(this.tabHandleAttr);
        this.clearActiveElements();
        this.setActiveElements();
      }
    }
  }, {
    key: "onTabClick",
    value: function onTabClick(e) {
      e.preventDefault();
      var targetEl = e.currentTarget;
      this.activeHandle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(targetEl).attr(this.tabHandleAttr);
      this.clearActiveElements();
      this.setActiveElements();
    }
  }, {
    key: "clearActiveElements",
    value: function clearActiveElements() {
      var tabElements = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.container).find("[".concat(this.tabHandleAttr, "]"));
      if (tabElements) tabElements.removeClass("is-active");
    }
  }, {
    key: "setActiveElements",
    value: function setActiveElements() {
      if (!this.activeHandle) return;
      var tabElements = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.container).find("[".concat(this.tabHandleAttr, "=\"").concat(this.activeHandle, "\"]"));
      if (tabElements) tabElements.addClass("is-active");
    }
  }]);
}();
jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find("[data-science-section]").each(function (i, container) {
  var scienceSection = new ScienceSection(container);
  scienceSection.init();
});

/***/ }),

/***/ "./src/js/er-custom/search-bar.js":
/*!****************************************!*\
  !*** ./src/js/er-custom/search-bar.js ***!
  \****************************************/
/*! exports provided: searchBar */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchBar", function() { return _searchBar; });
var searchBar = {};
searchBar = {
  defaults: {
    searchBarContainer: $('.header-search')
  },
  onInit: function onInit(e) {
    var vm = this;
    vm.showSearchBar();
    vm.hideSearchBar();
  },
  showSearchBar: function showSearchBar() {
    var vm = this;
    var el = vm.defaults;

    // el.searchBarContainer
    $('.search-trigger').on('click', function (e) {
      e.preventDefault();
      $('body').addClass('search-bar-active');
      $('#Search-In-Modal-1').focus();
      var valueLength = $('#Search-In-Modal-1').val().length;
      $('#Search-In-Modal-1')[0].setSelectionRange(valueLength, valueLength);
      // if(window.innerWidth < 1131) {
      // 	$('.mobile-search-trigger').hide()
      // 	$('.mobile-close-search').removeClass('d-none')
      // }
    });
  },
  hideSearchBar: function hideSearchBar() {
    $('.close-search').on('click', function () {
      $('body').removeClass('search-bar-active');
      $('#Search-header').blur();
      if (window.innerWidth < 1131) {
        $('.mobile-search-trigger').show();
        $('.mobile-close-search').addClass('d-none');
      }
    });
  }
};
var _searchBar = searchBar;


/***/ }),

/***/ "./src/js/er-custom/trackorder.js":
/*!****************************************!*\
  !*** ./src/js/er-custom/trackorder.js ***!
  \****************************************/
/*! exports provided: trackorder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackorder", function() { return _trackorder; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

var trackorder = {
  defaults: {},
  onInit: function onInit() {
    var vm = this;
    vm.trackorderForm();
    vm.awsAjaxCall();
  },
  trackorderForm: function trackorderForm() {
    var vm = this;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '#submit-trackorder', function (e) {
      e.preventDefault();
      var order_id = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#orderID').val().replace('#', '');
      var order_email = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#orderEmail').val();
      var current_url = location.origin + location.pathname;
      var new_url = current_url + '?orderid=' + order_id + '&orderemail=' + order_email;
      window.location.replace(new_url);
    });
  },
  awsAjaxCall: function awsAjaxCall() {
    var vm = this;
    var urlParams = new URLSearchParams(window.location.search);
    var order_id = urlParams.get('orderid');
    var order_email = urlParams.get('orderemail');
    if (order_id && order_email) {
      var data_obj = JSON.stringify({
        "order_name": order_id,
        "email": order_email,
        "slug": "usps"
      });
      jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
        type: "POST",
        crossDomain: true,
        url: "https://8ju7eta2kh.execute-api.ap-southeast-2.amazonaws.com/live/aftershiporderstatus",
        data: data_obj,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function success(data) {
          if (data.status) {
            vm.buildtrackingPage(data);
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.trackpage-loader').hide();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-landing').show();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-results').hide();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-tracking-form').prepend('<p class="text-center">' + data.message + '. Please input correct details.</p>');
          }
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          alert(xhr.status);
          alert(thrownError);
        }
      });
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.trackpage-loader').hide();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-landing').show();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-results').hide();
    }
  },
  buildtrackingPage: function buildtrackingPage(data) {
    function makeTitle(slug) {
      var words = slug.split('-');
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        words[i] = word.charAt(0).toUpperCase() + word.slice(1);
      }
      return words.join(' ');
    }
    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var monthNamesAbv = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var track = data.data.tracking.tracking;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tracking_number').text(track.tracking_number);
    var last_update_d = new Date(track.last_updated_at);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tracking-order-date').text(last_update_d.getDate() + ' ' + monthNames[last_update_d.getMonth()] + ' ' + last_update_d.getFullYear());
    var checkpoints = track.checkpoints;
    var last_checkpoints = checkpoints[checkpoints.length - 1];
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tracking-delivery-to').text(last_checkpoints.location);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.courier-name').text(makeTitle(track.slug));
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.delivery-progress-status').text(track.tag);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.progress-dot-' + track.tag.toLowerCase()).addClass('active');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.progress-label-status').text(last_checkpoints.location);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.progress-label-date').html(last_update_d.getDate() + ' ' + monthNamesAbv[last_update_d.getMonth()] + ' ' + last_update_d.getFullYear() + ', <span class="light">' + last_update_d.getHours() + ':' + (last_update_d.getMinutes() < 10 ? '0' : '') + last_update_d.getMinutes() + '</span>');
    checkpoints.forEach(function (timeline) {
      var timelineHtml = '';
      var checkpoints_location = '&nbsp;';
      var checkpoint_time = new Date(timeline.checkpoint_time);
      if (timeline.location) {
        checkpoints_location = timeline.location;
      }
      timelineHtml = "<div class=\"timeline\">\n       <div class=\"row\">\n         <div class=\"col-9\">\n           <div class=\"timeline-info\">\n             <h4 class=\"timeline-title\">".concat(timeline.message, "</h4>\n             <p class=\"timelane-details\">").concat(checkpoints_location, "</p>\n           </div>\n         </div>\n         <div class=\"col-3 text-right\">\n           <div class=\"timeline-date\">").concat(checkpoint_time.getDate(), " ").concat(monthNamesAbv[checkpoint_time.getMonth()], "</div>\n           <div class=\"timeline-hours\">").concat(checkpoint_time.getHours(), ":").concat(checkpoint_time.getMinutes(), "</div>\n         </div>\n       </div>\n     </div>");
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('#checkpoints-wrapper').prepend(timelineHtml);
    });
    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.trackpage-loader').hide();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-landing').hide();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-results').show();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.tyo-faqs .accordion-group:first-of-type .accordion-header').click();
    }, 500);
  }
};
var _trackorder = trackorder;


/***/ }),

/***/ "./src/js/er-custom/update-cart.js":
/*!*****************************************!*\
  !*** ./src/js/er-custom/update-cart.js ***!
  \*****************************************/
/*! exports provided: updateCart */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCart", function() { return _updateCart; });
/* harmony import */ var _er_cart_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./er-cart-drawer */ "./src/js/er-custom/er-cart-drawer.js");

var updateCart = {};
updateCart = {
  defaults: {
    cartdrawerjs: _er_cart_drawer__WEBPACK_IMPORTED_MODULE_0__
  },
  onInit: function onInit(e) {},
  updateCartItem: function updateCartItem() {
    var vm = this;
    var el = vm.defaults;
    var cartDrawer = el.cartdrawerjs.cartDrawer;
    $.getJSON('/cart.js', function (cart) {
      cartDrawer.buildItemRows(cart);
    });
  }
};
var _updateCart = updateCart;


/***/ }),

/***/ "./src/js/er-custom/upsell-item.js":
/*!*****************************************!*\
  !*** ./src/js/er-custom/upsell-item.js ***!
  \*****************************************/
/*! exports provided: UpsellItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpsellItem", function() { return UpsellItem; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var UpsellItem = /*#__PURE__*/function () {
  function UpsellItem(container) {
    _classCallCheck(this, UpsellItem);
    this.container = container;
    this.mainUpsellImage = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).find('[data-main-upsell-image]');
    this.variantInputs = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).find('[data-variant-input]');
    this.btnAdd = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).find('[data-button-add]');
    this.toggle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).find('[data-button-toggle]');
    this.variantsContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).find('[data-variants-container]');
    this.variantsContHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.variantsContainer).outerHeight(true);
  }
  return _createClass(UpsellItem, [{
    key: "init",
    value: function init() {
      this.attachEvents();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.variantsContainer).css({
        "max-height": 0
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      // bind to be able to access the constructor "this" inside the function
      this.variantInputs.on("click", this.onVariantChanged.bind(this));
      this.btnAdd.on("click", this.onButtonAdd.bind(this));
      this.toggle.on("click", this.onToggleClick.bind(this));
    }
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: params,
                beforeSend: function beforeSend(data) {},
                success: function success(data) {
                  Shopify.getCart(function (cart) {
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.cart-item-count').text(cart.item_count);
                  });
                },
                error: function error(_error) {
                  console.log("Error: ", _error);
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-upsell-item] [data-button-add]').attr("disabled", false);
                }
              }).done(function (data) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                  method: 'GET',
                  url: location.href,
                  async: true,
                  dataType: 'html',
                  success: function success(data) {
                    var cart_slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(data).find("#site-slidecart-inner");
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#site-slide-cart-drawer').html(cart_slide);
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('empty-cart');
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('slide-cart');
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-upsell-item] [data-button-add]').attr("disabled", false);
                  }
                });
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function addToCart(_x) {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
  }, {
    key: "updateMainImage",
    value: function updateMainImage() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!src) return;
      this.mainUpsellImage.attr("src", src);
      this.mainUpsellImage.attr("srcset", src);
    }
  }, {
    key: "updateVariantName",
    value: function updateVariantName() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      if (!name) return;
      var variantNameEl = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.container).find('[data-variant-container] [data-variant-name]');
      variantNameEl.text(name);
    }
  }, {
    key: "onVariantChanged",
    value: function onVariantChanged(e) {
      var targetEl = e.currentTarget;
      var data = jquery__WEBPACK_IMPORTED_MODULE_0___default()(targetEl).data();
      if (!targetEl.checked) return;
      this.updateMainImage(data.imageSrc);
      this.updateVariantName(data.variantTitle);
    }
  }, {
    key: "onButtonAdd",
    value: function onButtonAdd(e) {
      var variantInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.container).find('input[data-variant-input]');
      var variantId = "";
      variantInput.each(function (index, element) {
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).attr("type") == "radio") {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).is(":checked")) {
            variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).val();
          }
        } else {
          variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).val();
        }
      });
      if (!variantId) return;
      var params = {
        "id": parseInt(variantId),
        "quantity": 1
      };
      this.btnAdd.attr('disabled', true);
      this.addToCart(params);
    }
  }, {
    key: "onToggleClick",
    value: function onToggleClick(e) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.btnAdd).toggleClass("is-show");
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.toggle).toggleClass("is-show");
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.variantsContainer).toggleClass("is-visible");
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.toggle).hasClass("is-show")) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.variantsContainer).css({
          "max-height": this.variantsContHeight
        });
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.variantsContainer).css({
          "max-height": 0
        });
      }
    }
  }]);
}();
jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-upsell-item]').each(function (i, el) {
  var upsellItem = new UpsellItem(el);
  upsellItem.init();
});

/***/ }),

/***/ "./src/js/er-custom/video-popup.js":
/*!*****************************************!*\
  !*** ./src/js/er-custom/video-popup.js ***!
  \*****************************************/
/*! exports provided: video_popup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "video_popup", function() { return _video_popup; });
var video_popup = {};
video_popup = {
  defaults: {},
  onInit: function onInit(e) {
    var vm = this;
    if ($('.popup-video-wrapper').length > 0) {
      $(document).on('click', '#videoTrigger', function (e) {
        e.preventDefault();
        var popup = $('.popup-video-wrapper');
        if (popup.hasClass('display-popup')) {
          popup.removeClass('display-popup');
          popup.addClass('hide-popup');
        } else {
          popup.addClass('display-popup');
          popup.removeClass('hide-popup');
        }
      });
      $(document).on('click', '#closeVideoPopup', function (e) {
        e.preventDefault();
        var popup = $('.popup-video-wrapper');
        if (popup.hasClass('hide-popup')) {
          popup.addClass('display-popup');
          popup.removeClass('hide-popup');
        } else {
          popup.removeClass('display-popup');
          popup.addClass('hide-popup');
        }
      });
    }
    $(document).on('click', '#videoTrigger', function (e) {
      e.preventDefault();
      var cover = $(this).closest(".video-cover");
      var videoHolder = $(".video-vimeo-holder");
      var vimeoframe = $(".video-vimeo-holder iframe")[0];
      cover.addClass('video-playing');
      videoHolder.addClass('video-playing');
      vimeoframe.src += "&autoplay=1";
    });
  }
};
var _video_popup = video_popup;


/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/*!*************************************************!*\
  !*** multi ./src/js/app.js ./src/scss/app.scss ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /Users/bonn/Projects/Beauty-Chef-US/src/js/app.js */"./src/js/app.js");
module.exports = __webpack_require__(/*! /Users/bonn/Projects/Beauty-Chef-US/src/scss/app.scss */"./src/scss/app.scss");


/***/ })

/******/ });